/********************************************************************************/
/* PAYMENTS MANAGER																*/
/********************************************************************************/
/*
El sistema se compone de tres clases:
	+ paymentsStorage:
		Es un almacen que contiene datos guardados previamente de un sistema de pago. Por ejemplo, las tarjetas almacenadas o cuentas
		corrientes. Se asocian a un método de pago.
		También gestiona el marcaje HTML para mostrar las listas y se encarga de gestionar las acciones de selecionar cada uno de los métodos en uso.

	+ paymentsObj:
		Esta clase almacena la lógica del sistema de pagos. Se inicializa con la lista de métodos de pago que van a usarse conforme al protocolo indicado en la clase.
		También gestiona la lógica del envío de los datos de pago.
		Por defecto se gestiona un sistema de pago neutro en el que se NO tiene en cuenta un balance previo (por ej.: añadir Saldo Virtual). Si se va a utilizar en el contexto de un carro de la compra
		o de una extración de saldo, hay que especificar los opciones widthdraw o cart, en el que se indican valores como balance actual, o el valor de la compra para realizar los cálculos correspondientes.
		Es IMPORTANTE reseñar, que esta clase es independiente de interfaz. Sólo obtiene o establece valores y calcula, ni crea que gestiona nada con respecto a la interfaz.
		Lanza los callbacks correspondientes en el caso de que los límites se traspasen, no lleguen o se encuentren en los valores permitidos.
		Por defecto se llaman a funciones externas que gestionan los valores de los límites de una forma genérica. Estas funciones pueden sobreescribirse para adaptarse a cada proyecto.
		- on_minLimitReached_functions
		- on_maxLimitReached_functions
		- on_remainingReached_functions
		- on_validValues_functions
		- on_success_functions
		- on_fail_functions

	+ paymentsManager:
		Esta clase proporciona la interfaz y establece relaciones tanto con paymentsStorage como paymentsObj para funcionar, que han de pasarse correctamente al instanciarse.
		Es IMPERATIVO que al instanciar la clase, se llame al método attachPayMethodsObj() para inicializar los métodos de pago correctamente, ya que se las llamadas
		a los callbacks de paymentsObj, podrían incluir referencias a paymentsManager para alterar la interfaz.

Igualmente, se utilizan las plantillas CORE de servidor, que incluyen los elementos de la interfaz con los que trabajan los scripts.

	ATENCIÓN:
	JAMÁS utilizar datos dependientes de la interfaz. Crear los métodos lógicos en paymentsObj si fuera necesario, y un setter para llenarlos desde paymentsManager que es
	la única clase con acceso a la interfaz.



	EJEMPLO:


	//1. INSTANCIAMOS almacen de datos paymentsStorage
	//***********************************************************************************

		var almacenPagos = new paymentsStorage({
			storedPaymentsObj:	new Array(

								{ methodId: 2,
								  submethodId: 1,
								  name: "Tarjeta de crédito",
								  autopayment: true,
								  withdrawals: false,
								  payments:true,
								  storedValues: new Array(
								  							{	id:"card1",
													 			caption: "card1",
													 			isDefault: false,
																enabled:true,
																"validado":null|0|1 	<-- null:no requiere,0 no validado, 1 validado
																max: null,
																min: null
															},
															{	id:"card2",
																caption: "card2",
																isDefault: false,
																enabled:false,
																"validado":null|0|1 	<-- null:no requiere,0 no validado, 1 validado
																max:null,
																min:null
															},
															{	id:"card3",
																caption: "card3",
																isDefault: true,
																enabled:true,
																"validado":null|0|1 	<-- null:no requiere,0 no validado, 1 validado
																max:null,
																min:null
															}
														)

								}
			},
			allowNonValidMethods: false,			<-- Bool: si true, permite los medios almacenados que no han sido validados. False: los purga y elimina del objeto storedPaymentsObj
			purgeNonShowableInPayments: false,		<-- Bool: si true, elimina los métodos purgando los que tengan el atributo reqs: {noShowOnPayments: true}
		  	showLimits: paymentsObj, 				<-- PaymentsObj: Si queremos mostrar límites, se pasa un objeto tipo paymentsObj, para cotejar sus límites y mostrarlos
			currencyObj: 							//Opcional si queremos usar un objeto del typo systemCurrency (currency.js), para la gestión avanzada de divisas
			)

	//2. INSTANCIAMOS el sistema de pagos paymentsManager
	//***********************************************************************************
		var payments = new paymentsManager({
			elem:			$('#add_cash'),
			cashRegister:	{
								maxValue:99000,
								minValue:0,
								decimals:2,
								addCallback:function(){},
								remCallback:function(){}
							},
			paymentsStorageObj: almacenPagos,
			documentsObj:	objetoDocuments //Necesario para la validación en Withdrawals,
			selectVCFirstIfAvailable: bool			//Opcional si queremos que por defecto al iniciar se despliegue Saldo Virtual como método de pago si es viable. Esta opción deshabilita selectFirstAvailableMethod.
			selectFirstAvailableMethod: bool		//Opcional si queremos que por defecto al iniciar se despliegue el primer método de pago viable disponible. Si selectVCFirstIfAvailable está a true, esta función se deshabilita.
			currencyObj: 							//Opcional si queremos usar un objeto del typo systemCurrency (currency.js), para la gestión avanzada de divisas
		})


	//3. INSTANCIAMOS paymentsObj
	//***********************************************************************************

	var paymentsObject = new paymentsObj("{$Config->MAINURLNS}/data/?action=performPurchase",{
		payMethodObj: 	{
							id:0,
							name:"Tarjeta",
							fees:1.00,
							documento:"6"	NULL|o tipo de documento (si necesita validación, se incluye el tipo de documento que se requiere, si no necesita, NULL)
							limits: new Array(
								{	id:1,				//id: opcional (puede ser null si no hay subtipo), si hay subtipo (como tarjeta : directo y pasarela), hay que identicarlos con un id
									minLimit:10,
									maxLimit:2000,
									remaining:150,
									enabled:true,		//Opcional, si existe y está establecido a false, se cambia el método al estado de NO DISPONIBLE. Por defecto vale true.
									allowFundsCompensation:true,
									on_minLimitReached_callback: 		function(){}, //recibe como parametros self,method,limit,minLimit
									on_maxLimitReached_callback: 		function(){}, //recibe como parametros self,method,limit,maxLimit
									on_remainingReached_callback: 		function(){}, //recibe como parametros self,method,limit,remaining
									on_methodNotAvailable_callback: 	function(){}, //recibe como parametros self,method,limit
									on_validValues_callback:			function(){}, //recibe como parametros self,method,limit
								},
								{	id:2,				//id: opcional (puede ser null si no hay subtipo), si hay subtipo (como tarjeta : directo y pasarela), hay que identicarlos con un id
									minLimit:10,
									maxLimit:2000,
									remaining:150,
									enabled:true,		//Opcional, si existe y está establecido a false, se cambia el método al estado de NO DISPONIBLE. Por defecto vale true.
									allowFundsCompensation:true,
									on_minLimitReached_callback: 		function(){}, //recibe como parametros self,method,limit,minLimit
									on_maxLimitReached_callback: 		function(){}, //recibe como parametros self,method,limit,maxLimit
									on_remainingReached_callback: 		function(){}, //recibe como parametros self,method,limit,remaining
									on_methodNotAvailable_callback: 	function(){}, //recibe como parametros self,method,limit
									on_validValues_callback:			function(){}, //recibe como parametros self,method,limit
								}
							),
						},
		strings:		paymentStrings,
		onSuccess: 		function(e){
							on_success_functions(e,payments)
						},
		onFail:			function(e){
							on_fail_functions(e,payments)
						},
		cart:			{
							currentBalance: 15,
							purchaseValue: 10
						},
		withdraw:		{										//Si es extracción de saldo, hay que pasar esta propiedad withdraw, junto al saldo actual extraíble para los calculos iniciales
						 	currentBalance: 10,50
						},

		validationMode:	{										//Se usa sólo para validar o agregar métodos nuevos de pago. Se ignoran límites (no hace falta pasarlos)
							method:1,							//Método de pago para validar
							submethod: {$showOnly["subtipo"]}	//Submétodo de pago para validar o null, este valor se pasa a la hora de hacer la "compra" virtual
						}
	})


	//4. VINCULAMOS paymentsObj a paymentsManager
	//***********************************************************************************

	payments.attachPayMethodsObj(paymentsObject)

*/














var paymentsStorage = function(options){
	this.tableElem = "data-paymentsStorage";
	this.allowOrder = false;
	this.allowRemoval = false;
	this.editable = false;
	this.orderable = false;
	this.strings = {
		expiration:"{t}Caducidad{/t}",
		withdrawals:"{t}Retiradas{/t}",
		payments:"{t}Pagos{/t}",
		welcome:"{t}Puedes usar uno de estos medios que tienes almacenados:{/t}",
		min:"{t}min{/t}",
		max:"{t}max{/t}"
	}
	this.allowNonValidMethods = false;
	this.currency = null;
	this.showLimits = false;
	this.storedPaymentsObj = new Array(
	/*
			{ methodId: "ccard",
			  submethodId: null,		(actualmente aunque implementado, está desactivado al considerarse cada medio como único, sin submétodos. Para activar, revisar método getMethod() )
			  name:"PayPal",
			  withdrawals: true,		indica si se permite este método para extraer importes
			  payments:true,			indica si se permite este método para realizar pagos
			  autoPayment:true,			Indica si permite el pago automático con este método. En la renderización de la interfaz, aparecerá un checkbox.
			  storedValues: new Array(
			  							{	id:"123",
								 			caption: "PPAl1 (1/2029)",
								 			isDefault: true,		<--- Deprecated, se usa como método por defecto, la primera entrada en el orden que sea enabled
											enabled:true,
											selected:false,
											"orden":2,
											"vault":null|vaultValue <--- Si el método ha sido verificado, indicamos en que vault está guardado (numérico)
											submethod:"safecharge",
											tag:"SafeCharge",
											reqs: {
												askForCVV: true
											}
										},
										{	id:"ppaycode2",
											caption: "PPAl2 (1/2029)",
											isDefault: false		,<--- Deprecated, se usa como método por defecto, la primera entrada en el orden que sea enabled
											enabled:false,
											selected:false,
											"orden":1,
											vault:null,
											"validado":null|0|1 	<-- null:no requiere,0 no validado, 1 validado por documentación
											submethod:"trustpayments",
											tag:"TrustPayments",
											reqs: {
												askForCVV: true
											}
										},
									)

			},
			{ methodId: "trans",
			  submethodId: null,
			  name:"Transferencia",
			  withdrawals: true,
			  payments:true,
			  autoPayment:true,
			  storedValues: new Array(
			  							{	id:"bankAccount1",
								 			caption: "ES02 XXXXXXXXXX 00",
								 			expiration:1584460806,
								 			isDefault: false,	<--- Deprecated, se usa como método por defecto, la primera entrada en el orden que sea enabled
											enabled:true,
											selected:false,
											orden:3,
											vault:null,
											validado:null,
											submethod:null
										},
										{	id:"bankAccount2",
								 			caption: "ES02 XXXXXXXXXX 02",
								 			expiration:1584460806,
								 			isDefault: false,	<--- Deprecated, se usa como método por defecto, la primera entrada en el orden que sea enabled
											enabled:false,
											selected:false,
											orden:5,
											vault:null,
											validado:0,
											submethod:null
										},
										{	id:"bankAccount3",
								 			caption: "ES02 XXXXXXXXXX 03",
								 			expiration:1584460806,
								 			isDefault: false,	<--- Deprecated, se usa como método por defecto, la primera entrada en el orden que sea enabled
											enabled:true,
											selected:false,
											orden:6,
											vault:81872,
											validado:1,
											submethod:null
										}
									)
			},
			{ methodId: "paypal",
			  submethodId: null,		(actualmente aunque implementado, está desactivado al considerarse cada medio como único, sin submétodos. Para activar, revisar método getMethod() )
			  name:"PayPal",
			  withdrawals: true,		indica si se permite este método para extraer importes
			  payments:true,			indica si se permite este método para realizar pagos
			  autoPayment:true,			Indica si permite el pago automático con este método. En la renderización de la interfaz, aparecerá un checkbox.
			  aliasesId: [3],			Si se establece, el método de pago que corresponda con el id del alias, tendrá su equivalencia en este elemento del almacén. Si existe este valor establecido, se utilizará este ID para almacenar y obtener datos en lugar de methodId.
			  storedValues: new Array(
			  							{	id:"ppaycode1",
								 			caption: "PPAl1 (1/2029)",
								 			isDefault: true,	<--- Deprecated, se usa como método por defecto, la primera entrada en el orden que sea enabled
											enabled:true,
											selected:false,
											"orden":2,
											vault:null,
											validado:1,
											submethod:null
										},
										{	id:"ppaycode2",
											caption: "PPAl2 (1/2029)",
											isDefault: false,	<--- Deprecated, se usa como método por defecto, la primera entrada en el orden que sea enabled
											enabled:false,
											selected:false,
											"orden":1,
											vault:null,
											validado:1,
											submethod:null
										},
									)

			}
	*/
	)
	this.orderedStructure = new Array(
/*
		{
			orden:1,
			id:"ppaycode2",
			methodId:1,
			submethodId:null
		},
		{
			orden:2,
			id:"ppaycode1",
			methodId:1,
			submethodId:null
		},
		{
			orden:2,
			id:"bankAccount1",
			methodId:1,
			submethodId:null
		}...
*/
	)

	if(typeof options != "undefined"){
		if (typeof options.storedPaymentsObj != "undefined"){ this.storedPaymentsObj = options.storedPaymentsObj }
		if(typeof options.strings != "undefined"){
			if(typeof options.strings.expiration != "undefined"){ this.strings.expiration = options.strings.expiration;}
			if(typeof options.strings.withdrawals != "undefined"){ this.strings.withdrawals = options.strings.withdrawals;}
			if(typeof options.strings.payments != "undefined"){ this.strings.payments = options.strings.payments;}
			if(typeof options.strings.welcome != "undefined"){ this.strings.welcome = options.strings.welcome;}
			if(typeof options.strings.min != "undefined"){ this.strings.min = options.strings.min;}
			if(typeof options.strings.max != "undefined"){ this.strings.max = options.strings.max;}
		}
		if (typeof options.allowNonValidMethods != "undefined"){ this.allowNonValidMethods = options.allowNonValidMethods}
		if (typeof options.currency != "undefined"){ this.currency = options.currency}

	}
	this.hasAliases = false;

	var self = this;

	// 	console.log("INICIO:",self.storedPaymentsObj)
	setParentMethodOnStoredValues();
	if (typeof options.purgeNonShowableInPayments != "undefined" && options.purgeNonShowableInPayments){
		self.purgeMethods(true);
	}else{
		self.purgeMethods();
	}


	function setParentMethodOnStoredValues(){
		//Función que añade cuál es el método padre en cada uno de los storedValues si no viniera
		$.each(self.storedPaymentsObj,function(k,v){
			$.each(v.storedValues,function(i,j){
				j["parentMethodId"] = v.methodId;
			})
		})
	}




	addVirtualMethodsFromAliases();
	function addVirtualMethodsFromAliases(){
		//Buscamos si hay aliases
		var addQueue = new Array();
		$(self.storedPaymentsObj).each(function(k,v){
			if(typeof v.aliasesId != "undefined" &&  v.aliasesId != null && v.aliasesId.length > 0){
				$(v.aliasesId).each(function(j,i){

					var virtualMethodToAdd = {}
					if(typeof Object.assign != "undefined"){
						virtualMethodToAdd = Object.assign({},v);
					}else{
						var raw = JSON.parse(JSON.stringify(v));
						virtualMethodToAdd = toObject(raw);
					}

					virtualMethodToAdd.methodId = String(i);
					virtualMethodToAdd.isAliasOf = v.methodId;
					delete(virtualMethodToAdd.aliasesId);
					addQueue.push(virtualMethodToAdd)
				})
			}
		});
		if(addQueue.length > 0){
			self.hasAliases = true;
		}
		$(addQueue).each(function(){
			self.storedPaymentsObj.push(this)
		})
	}

	function orderMethods(){
		var storedPaymentsTmp = new Array();
		$(self.storedPaymentsObj).each(function(jMethod,jValue){
			if(typeof jValue.isAliasOf == "undefined"){
				$(jValue.storedValues).each(function(kMethod,kValue){
					if(jValue.submethodId == null){
						var sub = null
					}else{
						var sub = jValue.submethodId
					}
					storedPaymentsTmp.push({
						orden:kValue.orden,
						id:kValue.id,
						methodId:jValue.methodId,
						submethodId:sub
					})
				})
			}
		})
		storedPaymentsTmp.sort(function(a,b){
			if(a.orden > b.orden){
				return 1;
			}else if(a.orden < b.orden){
				return -1;
			}else{
				return 0;
			}
		})
		return storedPaymentsTmp;
	}
	self.orderedStructure = orderMethods();

}
paymentsStorage.prototype.purgeMethods = function(purgeNonShowable){
	//Purgamos el objeto storedPaymentsObj. Eliminamos métodos si no tienen storedValues, y si los tienen, eliminamos o permitimos los elementos en función de allowNonValidMethods
	//Si se le pasa el parametro purgeNonShowable a true, también tiene en cuenta si se purgan los elementos con el atributo "noShowOnPayments" a true.


	var newStoredPaymentsObj = new Array();
	var purgeNonShowableInPayments = false;
	if(typeof purgeNonShowable != "undefined" && purgeNonShowable){
		purgeNonShowableInPayments = true;
	}

	$.each(self.storedPaymentsObj,function(k,v){
		var methodTmp = new Array();
		var tmp = new Array();
		if(!purgeNonShowableInPayments || (purgeNonShowableInPayments && self.getShowInPayments(v.methodId)) ){
			if(v.storedValues.length > 0){
				$.each(v.storedValues,function(j,l){
					if(!self.allowNonValidMethods){
						if(l.validado == 1 || l.validado == null){ //Si no require validación o si ha sido validado.
							tmp.push(l)
						}
					}else{
						tmp.push(l)
					}
				})
				if(tmp.length > 0){
					methodTmp = v
					methodTmp.storedValues = tmp
					newStoredPaymentsObj.push(methodTmp);
				}
			}
		}
		self.storedPaymentsObj = newStoredPaymentsObj;
	})
}
paymentsStorage.prototype.setShowLimits = function(paymentsObj){
	//Método al que adjunta un objeto paymentsObj, y extrae los mínimos y máximos de cada submétodo y los añade a la estructura de datos
	var self = this;

	function getSubmethod(methodId,submethodId){
		var returnValue = false;
		if(typeof paymentsObj != "undefined" && paymentsObj && paymentsObj != null){
			$(paymentsObj).each(function(k,v){
				if(v.id == methodId){
					$(v.limits).each(function(lk,lv){
						if(lv.id == submethodId){
							returnValue = lv;
							return false;
						}
					})
				}
				if(returnValue){
					return false;
				}
			})
		}
		return returnValue;
	}
	$.each(self.storedPaymentsObj,function(k,v){
		if(v.storedValues.length > 0){
			$.each(v.storedValues,function(j,l){
				var subm = getSubmethod(l.parentMethodId,l.methodId);
				if(subm){
					l["min"] = subm.minLimit;
					l["max"] = subm.remaining;
/* 					if(typeof subm.currency != "undefined"){
						l["currency"] = subm.currency;
					}else{
						l["currency"] = self.getCurrency();
					} */
				}
			})
		}
	})
}
paymentsStorage.prototype.getCurrency = function(){
	if(this.currency != null){
		return this.currency;
	}else{
		return false;
	}
}

paymentsStorage.prototype.purgeNonShowableInPayments = function(){
	//Purga los elementos que no se permite que se muestren en pagos (sólo pagos, no en retiradas)
	this.purgeMethods(true);
}

paymentsStorage.prototype.purgeOrphans = function(arrayPayMethods){
	//Purga los métodos guardados que no se encuentren en una estructura "paymentsObj" pasada.
	var self = this;
	var tmpToDelete = new Array();
	var tmpToDeleteEmpty = new Array();
	$.each(self.storedPaymentsObj,function(smk,smv){
		var found = null;

		$.each(smv.storedValues,function(svk,svv){
			if(!findSubmethodId(svv.methodId)){
				tmpToDelete.push({mk:smk,smk:svk,method:svv.parentMethodId,submethod:svv.methodId})
			}
		})
	})
	for(var i = tmpToDelete.length - 1; i >= 0; i--){
		var item = tmpToDelete[i]
		self.storedPaymentsObj[item.mk].storedValues.splice(item.smk,1);
		if(self.storedPaymentsObj[item.mk].storedValues.length == 0){
			tmpToDeleteEmpty.push(item.mk);
		}
	}
	for(var i = tmpToDeleteEmpty.length - 1; i >= 0; i--){
		var item = tmpToDeleteEmpty[i]
		self.storedPaymentsObj.splice(item,1);
	}
	$(self.storedPaymentsObj).each(function(k,v){
		if(v.storedValues.length == 0){
			self.storedPaymentsObj.splice(k,1);
		}
	})

/* 	$.each(tmpToDelete,function(k,v){
		self.storedPaymentsObj[v.mk].storedValues.splice(v.smk,1);
		if(self.storedPaymentsObj[v.mk].storedValues.length == 0){
			tmpToDeleteEmpty.push(v.mk);
		}
	}) */

/* 	$(tmpToDeleteEmpty).each(function(k,v){
		self.storedPaymentsObj.splice(v,1);
	}) */

	function findSubmethodId(submethodId){
		var returnedValue = false;
		$(arrayPayMethods).each(function(k,v){
			if(returnedValue){
				return false;
			}
			$(v.limits).each(function(kk,vv){
				if(returnedValue){
					return false;
				}
				if(vv.id == submethodId){
					returnedValue = true
				}
			})
		})
		return returnedValue;
	}

}

paymentsStorage.prototype.getShowInPayments = function(methodId){
	var self = this;
	var method = self.getMethod(methodId);
	if(typeof method.reqs != "undefined" && method.reqs != null && typeof method.reqs.noShowOnPayments != "undefined" && method.reqs.noShowOnPayments === true){
		return false;
	}
	return true;
}

paymentsStorage.prototype.retrieveHTMLforMethod = function(methodId,submethodId,options){
	var self = this;
	var list = this.getMethod(methodId,submethodId);
	var ignoreVaultedItems = false;
	if(typeof options != "undefined"){
		if(typeof options.ignoreVaultedItems && options.ignoreVaultedItems === true){
			ignoreVaultedItems = true;
		}
	}

	if(list){
		list=list.storedValues;
	}
	if(list.length > 0){
		var html = "<table "+self.tableElem+">";
		if(typeof self.strings.welcome != "undefined" && self.strings.welcome != null && self.strings.welcome.length > 0){
			html = html + "<thead><tr><th colspan='3'>" + self.strings.welcome + "</th></tr></thead>";
		}
		var html = html + "<tbody>";

// 		var isAlreadyChecked = false; //Si ya hay uno marcado, lo dejamos y no seguimos marcando radioButtons
		var checkedIndex = null;
		$(list).each(function(k,v){
			if(typeof v.selected != "undefined" && v.selected === true){
				checkedIndex = k
			}
		})

		$(list).each(function(k,v){
			if(ignoreVaultedItems && v.vault != null){
				return;
			}

			var isActive = "";
			var checked = "";
			var sub = "null";
			if(submethodId != null){
				sub = submethodId;
			}
			var identifier = "str_"+methodId+"_"+sub;

			if(!v.enabled){
				var enabled = " disabled";
				isActive = "";
				checked = "";
			}else{
				var enabled = "";
				if(checkedIndex == k/* !isAlreadyChecked */){
					isActive = " is-active";
					checked = " checked";
// 					isAlreadyChecked = true;
				}
			}


			if(typeof v.expiration != "undefined" && v.expiration != null){
				var dateObj = new Date(v.expiration * 1000);
				var month = dateObj.getMonth();
				var year = dateObj.getFullYear();
				month = month + 1;
				if (month + 1 < 10){ month = '0' + month }
				var mmyy = month + "/" + year.toString().substr(2,2);
				var expiration = "<small data-expiration>("+self.strings.expiration+": "+mmyy+")</small>"
			}else{
				var expiration = "";
			}
			var submethod = v.tag;
			html = html + "<tr data-value='"+v.id+"' class='"+enabled+"'>";
			html = html + "<td><label class='beautified"+isActive+"'"+enabled+"><span></span><input data-paymentMethodSelector type='radio'"+checked+enabled+" name='"+identifier+"'></label></td>";
			html = html + "<td>"+v.caption+expiration+"</td>";
			if(typeof v.min != "undefined" && typeof v.max != "undefined" && self.showLimits){
				var max = v.max;
				var min = v.min;
				if(v.max == null){
					max = "∞";
				}

				if(self.getCurrency()){
					var min = self.getCurrency().getMoneda(v.min)
					if(v.max != null){
						max = self.getCurrency().getMoneda(v.max);
					}
				}
				html = html + "<td data-range><dl><dt>" + self.strings.min + "</dt><dd>" + min + "</dd><br><dt>" + self.strings.max + "</dt><dd>" + max + "</dd></dl></td>";
			}else if(submethod != null){
				html = html + "<td>"+"<span data-mname>"+submethod+"</span></td>";
			}else{
				html = html + "<td>&nbsp;</td>";
			}
			html = html + "</tr>";
		})
		html = html + "</table></tbody>";
		return html;
	}else{
		return "";
	}
}

paymentsStorage.prototype.retrieveHTML = function(options){
	var self = this;
	var list = self.orderedStructure; //this.storedPaymentsObj;

	var showSelectionForMethods = new Array(); //Los métodos de pago cuyo id aparezca aquí, tendran caja de selección al lado

	var useRadio = false;
	var useSwitch = true;

	if(list.length > 0){
		var html = "";
		$(list).each(function(k,v){
			var payMethod = self.getMethod(v.methodId,v.submethodId);
			var storedValue = self.getStoredIdFromMethodObj(v.id,payMethod)
			var checked = "";
			var sub = null;
			if(typeof payMethod.submethodId != "undefined" && payMethod.submethodId != null){
				sub = payMethod.submethodId;
			}
			var identifier = "stored_"+payMethod.methodId+"_"+sub+"_"+storedValue.id;

			if(!storedValue.enabled){
				var enabled = " disabled";
			}else{
				var enabled = "";
			}


			if(typeof storedValue.selected != "undefined" && storedValue.selected === true){
				var checked = " checked='checked'";
				var isActive = " is-active";
			}else{
				var checked = "";
				var isActive = "";
			}

			if(useRadio){
				var inputType = "radio";
			}else{
				var inputType = "checkbox";
			}

			if(useSwitch){
				var switchControl = '	<div class="switch">'+
											'<input data-paymentMethodSelector '+checked+' class="switch-input" id="'+identifier+'" type="checkbox" name="'+identifier+'"'+enabled+'>'+
											'<label class="switch-paddle" for="'+identifier+'"></label>'+
										'</div>';
			}else{
				var switchControl = "";
			}

			if(typeof storedValue.expiration != "undefined" && storedValue.expiration != null){
				var dateObj = new Date(storedValue.expiration * 1000);
				var month = dateObj.getMonth();
				var year = dateObj.getFullYear();
				month = month + 1;
				if (month + 1 < 10){ month = '0' + month }
				var mmyy = month + "/" + year.toString().substr(2,2);
				var expiration = "<small data-expiration>("+self.strings.expiration.substr(0,3)+": "+mmyy+")</small>"
			}else{
				var expiration = "";
			}

			var tags = "";
			if(payMethod.withdrawals){
				tags = "<span data-tag='0'>"+self.strings.withdrawals+"</span>";
			}
			if(payMethod.payments){
				tags = tags + "<span data-tag='1'>"+self.strings.payments+"</span>";
			}



			html = 	html + "<tr data-method-value='"+payMethod.methodId+"' data-submethod-value='"+payMethod.submethodId+"' data-value='"+storedValue.id+"' class='"+enabled+"'>";
			if(payMethod.autoPayment){
				if(useSwitch){
					html = 	html + "<td>"+switchControl+"</td>";
				}else{
					html = 	html + "<td><label class='beautified"+isActive+"'"+enabled+"><span></span><input data-paymentMethodSelector type='"+inputType+"'"+checked+enabled+" name='"+identifier+"'></label></td>";
				}
			}else{
				html = 	html + "<td></td>";
			}

			html = 		html + "<td><img data-img src='//cdn.inicium.com/images/common/art/cards/" + payMethod.methodId + ".png'></td>";
			html = 		html + "<td><span data-title>"+payMethod.name+"</span><span data-value>"+storedValue.caption+"</span>"+expiration+tags+"</td>";
			html = 		html + "<td class='spacer'></td>";
			html = 		html + "<td><button data-remove type='button'></button></td>";
			html = 	html + "</tr>";

		})
		return html;
	}else{
		return "";
	}
}

paymentsStorage.prototype.getPaymentsObj = function(){
	return this.storedPaymentsObj;
}
paymentsStorage.prototype.getMethod = function(methodId,submethodId,getIndex){	//getIndex Opcional
	var self = this;
	var value = null;
	//****************************************
	//En principio ignoramos el submétodo, ya que no se va almacenar en la agenda (se mantiene a "undefined" por compatibilidad), ni va a venir en la estructura de datos (siempre llega undefined)
	// 	var subMethodId = submethodId;
	var subMethodId; //Lo establecemos a undefined
	//**************************************


	$(this.storedPaymentsObj).each(function(k,v){
		if(v.methodId == methodId/*  && v.submethodId == subMethodId */){
			if(typeof getIndex != "undefined" && getIndex === true){
				value = k;
			}else{
				value = this
			}
			return false;
		}
	})

	if(value != null){
		return value;
	}
	return false;
}
paymentsStorage.prototype.getStoredId = function(id,methodId,submethodId){
	var method = this.getMethod(methodId,submethodId);
	var returnedvalue = false;
	if(method){
		$(method.storedValues).each(function(k,v){
			if(v.id == id){
				returnedvalue = v;
				return false;
			}
		})
	}
	return returnedvalue;
}
paymentsStorage.prototype.getStoredIdFromMethodObj = function(id,methodObj){
	var method = methodObj;
	var returnedvalue = false;
	if(method){
		$(method.storedValues).each(function(k,v){
			if(v.id == id){
				returnedvalue = v;
				return false;
			}
		})
	}
	return returnedvalue;
}
paymentsStorage.prototype.getSelectionFromMethod = function(methodId,submethodId){
	var method = this.getMethod(methodId,submethodId);
	var returnedvalue = false;
	if(method){
		$(method.storedValues).each(function(k,v){
			if(v.selected == true){
				returnedvalue = v.id;
				return false;
			}
		})
	}
	return returnedvalue;
}
paymentsStorage.prototype.resetAllSelections = function(methodId){
	var self = this;
	$(self.storedPaymentsObj).each(function(k,v){
		$(v.storedValues).each(function(i,j){
			self.storedPaymentsObj[k].storedValues[i]["selected"] = false;
		})
	})
}
paymentsStorage.prototype.resetSelection = function(methodId,submethodId){
	var self = this;
	var method = this.getMethod(methodId,submethodId);
	if(method){
		$(method.storedValues).each(function(k,v){
			v["selected"] = false;
		})
	}
}
paymentsStorage.prototype.getDefault = function(methodId,submethodId){
	//Usamos como método por defecto, el primero de la lista que  esté enabled
	var self = this;
	var method = this.getMethod(methodId,submethodId);
	var returnValue = false;
	if(method){
		$(method.storedValues).each(function(k,v){
			if(v.isDefault === true && v.enabled === true){
				returnValue = v;
				return false;
			}
		})
	}
	return returnValue;
}
paymentsStorage.prototype.getSelection = function(methodId,submethodId){
	var self = this;
	var submethodId = null;
	var method = this.getMethod(methodId,submethodId);
	var returnValue = false;

	if(method){
		$(method.storedValues).each(function(k,v){
			if(v.selected){
				returnValue = v;
				return false;
			}
		})
	}
	return returnValue;
}

paymentsStorage.prototype.setSelection = function(id,methodId,submethodId){
	var self = this;
	var submethodId = null;
	var method = this.getMethod(methodId,submethodId);
	var methodIndex = this.getMethod(methodId,submethodId,true);

	if(method){
		$(method.storedValues).each(function(k,v){
			if(v.id == id){
				self.resetSelection(methodId,submethodId);
				self.storedPaymentsObj[methodIndex].storedValues[k].selected = true;
			}else{
				self.storedPaymentsObj[methodIndex].storedValues[k].selected = false;
			}
		})
	}
}
paymentsStorage.prototype.getHasAliases = function(){
	return this.hasAliases;
}
paymentsStorage.prototype.cvvRequired = function(id,methodId,submethodId){
	var self = this;
	var item = self.getStoredId(id,methodId,submethodId);
	if(item && typeof item.reqs != "undefined" && item.reqs != null && typeof item.reqs.askForCVV != "undefined" && item.reqs.askForCVV == true){
		return true;
	}
	return false;
}

const availability_available = true;
const availability_unavailable = 0;
const availability_minReached = 1;
const availability_maxReached = 2;
const availability_notEnoughRemaining = 3;

var paymentsObj = function(url,options){
	var self = this;
	this.amountToAdd = 0;				 	//Importe que se va a añadir, o importe que se va a cobrar
	this.allowPayments = true;				//Establece si se puede o no realizar algún pago
	this.purchaseURL = 	url;				//"/data/?action=performPurchase";
	this.options = options;					//Para clonar el objecto
	this.usingForceMinLimit = false;		//Indica si se está usando el modo para permitir el pago con importe mínimo (

	/********** OPCIONES PARA CARRO **********/
	// se establecen en opciones:
	// options.cart: {
	//		currentBalance: 0.00,					//Saldo actual del usuario
	//		purchaseValue: 0.00,					//Valor de la compra
	//		voucherValue: 0.00						//Valor del descuento
	//		hasSubscriptionOnlyElements:true|false	//Indica si el carro tiene elementos que sólo puede adquirirse con un abono al método de pago
	// }
	this.currentBalance = 0;				//Importe con saldo previo	(tanto compras como extracciones)
	this.shoppingCart = false;				//Es o no carro
	this.usingPreviousBalance = false;		//Indica si se esta extrayendo saldo virtual
	this.voucherValue = 0;
	this.purchaseWithSuscription = false;
	/******************************************/

	/********** OPCIONES PARA RETIRADA **********/
	// se establecen en opciones:
	// options.withdraw: {
	//		currentBalance: 0.00,			//Saldo actual extraíble
	// }
	this.withdrawal = false;

	this.onSuccess = function(){}
	this.onFail = function(){}
	this.debug = false;
	this.payMethods = new Array(		//payMethodObj
/*

		{
			id: "ccard",
			uid: 33,
			name:"Tarjeta",
			fees:1.00,
			useForVouchers:false,			//Permite que se use ese método para usar cupones. Esto hace que se habilite el medio de pago cuando el importe sea 0.
			documento:"6",					//NULL|o tipo de documento (si necesita validación, se incluye el tipo de documento que se requiere, si no necesita, NULL)
			useForFundingOnly: {			//Si se establece, no finaliza compra, sino que redirige a la url indicada de ingreso de saldo con los parámetros correspondientes
				url: "{$Config->MAINURLNS}{t}/saldo/{/t}#add_cash"
			},

			limits: new Array(
				{	id:"safecard",						//id: opcional (puede ser null si no hay subtipo), si hay subtipo (como tarjeta : directo y pasarela), hay que identicarlos con un id
					uid: 3
					minLimit:10,
					maxLimit:2000,
					remaining:150,
					enabled:true,						//Opcional, si existe y está establecido a false, se cambia el método al estado de NO DISPONIBLE. Por defecto vale true.
					localToCurrencyRate: 1.32			//Opcional Si existe, indica el ratio de conversión de la divisa del método con respecto a la divisa del sistema
					allowFundsCompensation:true,
					allowForceMinLimit:true,
					allowSavePaymentData: true,
					allowedForSubscriptions: true,		//Opcional, por defecto false. Indica si el método permite pagos suscritos. Si no se permite, y si se intenta pagar un abono, muestra un mensaje de aviso.
					on_minLimitReached_callback: 		function(){}, //recibe como parametros self,method,limit,minLimit
					on_maxLimitReached_callback: 		function(){}, //recibe como parametros self,method,limit,maxLimit
					on_remainingReached_callback: 		function(){}, //recibe como parametros self,method,limit,remaining,
					on_methodNotAvailable_callback: 	function(){}, //recibe como parametros self,method,limit
					on_validValues_callback:			function(){}, //recibe como parametros self,method,limit

				},
				{	id:"trustPayments",					//id: opcional (puede ser null si no hay subtipo), si hay subtipo (como tarjeta : directo y pasarela), hay que identicarlos con un id
					uid: 4,
					minLimit:10,
					maxLimit:2000,
					remaining:150,
					enabled:true,						//Opcional, si existe y está establecido a false, se cambia el método al estado de NO DISPONIBLE. Por defecto vale true.
					localToCurrencyRate: 1.32			//Opcional Si existe, indica el ratio de conversión de la divisa del método con respecto a la divisa del sistema
					allowFundsCompensation:true,
					allowForceMinLimit:true,
					allowSavePaymentData: true,
					allowedForSubscriptions: true,		//Opcional, por defecto false. Indica si el método permite pagos suscritos. Si no se permite, y si se intenta pagar un abono, muestra un mensaje de aviso.
					on_minLimitReached_callback: 		function(){}, //recibe como parametros self,method,limit,minLimit
					on_maxLimitReached_callback: 		function(){}, //recibe como parametros self,method,limit,maxLimit
					on_remainingReached_callback: 		function(){}, //recibe como parametros self,method,limit,remaining
					on_methodNotAvailable_callback: 	function(){}, //recibe como parametros self,method,limit
					on_validValues_callback:			function(){}, //recibe como parametros self,method,limit

				}
			),
		}
*/
	)
	this.firstAvailableMethod = new Array();//Almacena el primer metodo y submetodo disponibles para pago en un array: [metodo, submétodo]: ej:[1,null] ó [1,2]...
	this.availability = {};					//Cache de disponibilidad de métodos de pago, que se usa para no generarla de nuevo. Se refresca con cada llamada a isAvailable().
	this.availabilityDetailed = {};			//Cache de disponibilidad de métodos de pago avanzada, que se usa para no generarla de nuevo. Se refresca con cada llamada a isAvailable().
											//Añade el tipo de causa por la que un elemento no pueda estar disponible
											//true, 0,1,2,3 (0: no disponible, 1: min alcanzado, 2: max alcanzado, 3: remaining alcanzado)

	/*
	this.availability =
							{	0:[true],
								1:[true,false],
								2:[false]...
							}

*/
/*
	this.availabilityDetailed =
							{	0:[true],
								1:[true,0],
								2:[1]...
							}

*/

	this.strings = {
			paymentDone:	"{t}Pago realizado con éxito.{/t}",
			wait:			"{t}Realizando pago. Espere.{/t}..",
			redirecting:	"{t}Redirigiendo...{/t}",
			validationDone: "{t}Validación realizada con éxito.{/t}"
	}

	this.paymentInProgress = false;
	this.providedDocuments = {};
/*
	this.providedDocuments = {
		1: 477392,						//método:token
		4: 929833,						//método:de pago //token:valor que devuelve una subida de documento y que lo referencia
		5: ...

	}
*/




/*
	Cuando se realiza un pago, se traza aquí el método y submétodo, para que sean accesibles desde el callback
	this.paymentInProgress = {
		method: false,
		submethod: false
	}
*/

	this.lastPaymentResult = false;
/*
	Cuando se lanza un pago, este objeto se llena con datos referentes al último estado del pago
	{
		method:,
		submethod:
	}
*/
	this.additionalPaymentParameters = null;
/*
	Lista de parametros externos opcionales que se pasarán al método performPay(). Se establece con setPaymentAdditionalFields()
*/


	this.validationMode = false;
/*
 	Si se activa con los parámetros necesarios, se ignora toda la lógica de validación. Permitiendo hacer un cargo simbólico para hacer una verificación del método de pago
 	Se pasa el método de pago para verificar, y el submétodo para que quede almacenado en la petición
	{
		method:1,
		submethod:null
	}
*/
	this.suscriptionsAllowedState = false;

	if(typeof options != "undefined"){
		if(typeof options.payMethodObj != "undefined"){ this.payMethods = options.payMethodObj }
		if(typeof options.cart != "undefined"){
			if(typeof options.cart.currentBalance != "undefined" && typeof options.cart.purchaseValue != "undefined"){
				this.currentBalance = options.cart.currentBalance;
				this.amountToAdd = options.cart.purchaseValue;
				if(typeof options.cart.voucherValue != "undefined"){
					this.voucherValue = options.cart.voucherValue;
				}
				this.shoppingCart = true;
			}
		}
		if(typeof options.withdraw != "undefined"){
			if(typeof options.withdraw.currentBalance != "undefined"){
				this.currentBalance = options.withdraw.currentBalance;
				this.withdrawal = true;
			}
		}

		if(typeof options.onSuccess != "undefined"){ this.onSuccess = options.onSuccess }
		if(typeof options.onFail != "undefined"){ this.onFail = options.onFail }
		if(typeof options.debug != "undefined" && options.debug){ this.debug = true }

		if(typeof options.strings != "undefined"){
			if(typeof options.strings.paymentDone != "undefined" ){ this.strings.paymentDone = options.strings.paymentDone }
			if(typeof options.strings.wait != "undefined" ){ this.strings.wait = options.strings.wait }
			if(typeof options.strings.redirecting != "undefined" ){ this.strings.redirecting = options.strings.redirecting }

		}
		if(typeof options.validationMode != "undefined" && typeof options.validationMode.method != "undefined"){
			this.validationMode = {
				method: options.validationMode.method
			}
			if(typeof options.validationMode.submethod != "undefined"){
				this.validationMode["submethod"] = options.validationMode.submethod
			}else{
				this.validationMode["submethod"] = null
			}
		}
	}
}
paymentsObj.prototype.clone = function(){
	const cloned =  new paymentsObj(this.url,this.options);
	let props = Object.getOwnPropertyNames(this);
	props.forEach((el,index) => {
		cloned[el] = this[el];
	})
	return cloned;
}

paymentsObj.prototype.setMethods = function(methodsObj){
	this.payMethods = methodsObj;
}

paymentsObj.prototype.setAmount = function(amount,voucher){
	//Método que
	//Establece el importe con el que se va a operar, y calcula tanto la viabilidad para cada uno de los diferentes métodos de pago
	//y obtiene el primer método disponible y viable

	var self = this;
	this.amountToAdd = amount;
	this.firstAvailableMethod = new Array();
	this.availability = {};
	this.availabilityDetailed = {};
	if(self.isShoppingCart() && typeof voucher != "undefined"){
		this.setVoucherValue(voucher);
	}

	$(this.payMethods).each(function(k,v){
		var isAvailableValue = self.isAvailable(v.id);
		self.availability[v.id] = isAvailableValue;

		if(self.firstAvailableMethod.length == 0){
			$(isAvailableValue).each(function(i,j){
				if(j){
					self.firstAvailableMethod = [v.id,v.limits[i].id]
					return false;
				}
			})
		}

	})
}
paymentsObj.prototype.getAmount = function(){
	//Método que
	//Obtiene el importe actual con el que se está trabajando
	return parseFloat(this.amountToAdd);
}
paymentsObj.prototype.setUsePreviousBalance = function(value){
	//Método que
	//Establece que va a utilizar saldo previamente disponible para realizar los cálculos y poder comunicarlo a la petición de compra

	var self = this;
	if(value === true){
		self.usingPreviousBalance = true;
	}else if(value === false){
		self.usingPreviousBalance = false;
	}
}

paymentsObj.prototype.setSubscriptionsState = function(value){
	//Método que
	//Establece si un método permite el pago suscrito (abonos)
	this.suscriptionsAllowedState = value;
}

paymentsObj.prototype.getSubscriptionsState = function(){
	//Método que
	//Devuelve siel carro tiene abonos suscritos
	return this.suscriptionsAllowedState;
}
paymentsObj.prototype.getSubscriptionsAllowed = function(methodId,subMethodId){
	//Método que
	//Devuelve si un método permite el pago suscrito (abonos)
	var self = this;
	var elem = self.getLimit(methodId,subMethodId);
	if(typeof elem.allowedForSubscriptions != "undefined" && elem.allowedForSubscriptions === true){
		return true;
	}
	return false;
}
paymentsObj.prototype.setUseForceMinLimit = function(value){
	//Método que
	//Establece que va a permitir operar aún cuando no se alcance el límite mínimo para realizar los cálculos y poder comunicarlo a la petición de compra

	var self = this;
	if(value === true){
		self.usingForceMinLimit = true;
	}else if(value === false){
		self.usingForceMinLimit = false;
	}
}
paymentsObj.prototype.getUseForceMinLimitState = function(){
	//Método que
	//Devuelve el estado del uso forzado del límite mínimo
	return 	this.usingForceMinLimit;
}
paymentsObj.prototype.getUseForceMinLimitForMethod = function(methodId,limitId){
	var self = this;
	var item = self.getLimit(methodId,limitId);
	if(typeof item.allowForceMinLimit != "undefined"){
		return item.allowForceMinLimit;
	}else{
		return null;
	}
}
paymentsObj.prototype.getAutoSubmethod = function (methodId){
	var self = this;
	var item = self.getMethod(methodId);
	if(typeof item.subMethodAuto != "undefined" && item.subMethodAuto){
		return true;
	}
	return false;
}
paymentsObj.prototype.getAmountWithFeesForMethod = function(amount,methodId,submethodId){
	//Método que
	//Obtiene el importe calculado con las comisiones de un método de pago
	if(typeof submethodId == "undefined" || (typeof subMethodId != "undefined" && submethodId == null)){
		var method = this.getMethod(methodId);
	}else{
		var method = this.getLimit(methodId,submethodId);
	}
	if(typeof method.fees != "undefined"){
		var fees = parseFloat(method.fees);
		amount = parseFloat(amount);
		if (fees > 1.00){
	 		//return (Math.round((amount + (amount * (fees/100))) * 100) / 100).toFixed(2);
			return (amount*fees).toFixed(2)
		}else{
			return amount;
		}
// 		return parseFloat(amount) + parseFloat((amount * (fees/100)));
	}else{
		return parseFloat(amount);
	}
}


paymentsObj.prototype.getAmountToPaySubstractingBalance = function(amount,balanceToSubstractFrom,methodId,submethodId){
	//Método que
	//Devuelve el importe total a pagar al sustraerle las comisiones y un balance de partida que se le pasa a la función

	var resultado = 0;
	var amountWithFees = this.getAmountWithFeesForMethod(amount,methodId,submethodId);
	resultado = amountWithFees - balanceToSubstractFrom;
	if(resultado < 0){
		resultado = amountWithFees;
	}

	return resultado;
}

paymentsObj.prototype.applyConversionRate = function(amount,methodID,submethodID){
	//Devuelve un objeto con el importe de la conversión y la divisa
	//{value:320.32,currency:"MXN"}

	if(typeof submethodID != "undefined" && submethodID != null){
		var elem = this.getLimit(methodID,submethodID);
	}else{
		var elem = this.getMethod(methodID);
	}
	if(typeof elem.localToCurrencyRate != "undefined" && elem.ISOcurrency != "undefined"){
		return {value:parseFloat(elem.localToCurrencyRate * amount),ISOcurrency:elem.ISOcurrency};
	}else{
		return {value:parseFloat(amount)}
	}
}
paymentsObj.prototype.isBelowLimit = function(amount,methodId,submethodId){
	//Devuelve si el importe está por debajo del límite.

	var self = this;
	if(typeof submethodId == "undefined" || (typeof subMethodId != "undefined" && submethodId == null)){
		var method = this.getLimit(methodId,methodId);
	}else{
		var method = this.getLimit(methodId,submethodId);
	}
	var minLimit = method.minLimit;
	if(amount < minLimit){
		return true;
	}
	return false;
}

paymentsObj.prototype.isAvailable = function(methodId,optionalAmount,applyEvents){
	//Método que
	//Obtiene la disponibilidad de cada método de pago y devuelve un array con el resumen de la disponibilidad del mismo.
	//Si optionalAmount no se pasa, se usa como referencia amount de la clase
	//Si se especifica (por ejemplo si pasamos el amount al que se le han aplicado comisiones) se usa como valor de amount
	//Lanza los eventos especificados al instanciar la clase para cada uno de los casos afectados por los límites.
	//applyEvents: ejecuta los eventos correspondientes a los casos. Por defecto es true. Si sólo queremos obtener el array con la validez, establecer a false.

	//ATENCIÓN:
	//Para no tener que llamar al método múltiples veces para consultar la disponibilidad, es preferible llamar al método getAvailability(), que obtiene
	//los resultados de la última llamada a este método, que se lanza cada vez que el importes se establece con setAmount().
	var self = this;
	var method = this.getMethod(methodId);
	var returnValue = new Array();
	var useEvents = true;
	//console.log('is-available called!')
	if(typeof optionalAmount != "undefined" && optionalAmount !== false ){
		var amount = parseFloat(optionalAmount);
	}else{
		var amount = parseFloat(self.amountToAdd);
	}

	if(typeof applyEvents != "undefined" && !applyEvents){
		useEvents = false;
	}

	if(!this.allowPayments){
		return false;
	}
	self.availabilityDetailed[methodId] = [];

	if(method){

		$(method.limits).each(function(k,v){
			const clientAvailability = self.checkClientAvailability(methodId);

			if(typeof v.enabled !="undefined" && v.enabled === false){
				self.availabilityDetailed[methodId].push(availability_unavailable);
				if(useEvents){
					v.on_methodNotAvailable_callback(self,method,v.id);
				}
				returnValue.push(false);

			}else{
				if(	(v.maxLimit != null && amount <= v.maxLimit
					&& (amount >= v.minLimit)
					&& (amount <= v.remaining || (v.remaining == null && v.maxLimit == null))
					&& (!self.isWithdrawal()  || (self.isWithdrawal() && amount <= self.currentBalance)   )) || (v.maxLimit == null && (amount >= v.minLimit || (/* Para dar métodos de sólo añadir saldo como buenos en el carro, aunque no llegue al límite */ amount < v.minLimit && self.isShoppingCart() && self.isForFundingOnly(methodId))) && (!self.isWithdrawal() || (self.isWithdrawal() && amount <= self.currentBalance )))
					/*|| 			 	(si el método es sólo para añadir saldo en un carro de la compra y ha, lo consideramos válido. Si no está en el carro se evalúa como el resto self.isShoppingCart() && self.isForFundingOnly(methodId) && !self.isWithdrawal())*/ ){
					self.availabilityDetailed[methodId].push(availability_available);


					if(typeof v.on_validValues_callback != "undefined"){		//Valores válidos
						var limit = null
						if(v.id != null){ limit = v.id; }
						if(useEvents){
							if(clientAvailability == null || clientAvailability){
								v.on_validValues_callback(self,method,limit);
							} else if(!clientAvailability){
								if(typeof v.on_unsupportedClient_callback != "undefined") v.on_unsupportedClient_callback(self,method,limit);
							}
						}
					}else if(clientAvailability === false && useEvents){
						if(typeof v.on_unsupportedClient_callback != "undefined") v.on_unsupportedClient_callback(self,method,limit);
					}
					returnValue.push(true);

				}else{
					if( (v.remaining == 0 || v.maxLimit == 0)){												//Valores inválidos	alcanzan al límite disponible
						self.availabilityDetailed[methodId].push(availability_notEnoughRemaining);

						if(typeof v.on_remainingReached_callback != "undefined"){
							var limit = null; if(v.id != null){ limit = v.id; }
							if(useEvents){
								if(clientAvailability || clientAvailability == null ){
									v.on_remainingReached_callback(self,method,limit,v.remaining);
								} else if(!clientAvailability){
									if(typeof v.on_unsupportedClient_callback != "undefined") v.on_unsupportedClient_callback(self,method,limit);
								}
							}
						}else if(clientAvailability === false && useEvents){
							if(typeof v.on_unsupportedClient_callback != "undefined") v.on_unsupportedClient_callback(self,method,limit);
						}
						returnValue.push(false);

					}else{
						if((v.maxLimit > 0 && (amount > v.maxLimit || amount > v.remaining || v.remaining <= 0)) || ( (/*self.isShoppingCart() || */ self.isWithdrawal()) && amount > self.currentBalance)){	//Valores inválidos superiores al límite //Valores inválidos alcanzan al límite disponible
							self.availabilityDetailed[methodId].push(availability_maxReached);
							if(typeof v.on_maxLimitReached_callback != "undefined"){
								var limit = null;
								if(v.id != null){ limit = v.id; }

								if(amount > v.maxLimit){
									var limitValue = v.maxLimit
								}else if(amount > v.remaining){
									var limitValue = v.remaining
								}
								if(limitValue < 0){
									limitValue = 0;
								}
								if(useEvents){
									if(clientAvailability || clientAvailability == null ){
										v.on_maxLimitReached_callback(self,method,limit,limitValue);
									} else if(!clientAvailability){
										if(typeof v.on_unsupportedClient_callback != "undefined") v.on_unsupportedClient_callback(self,method,limit);
									}
								}
							}else if(clientAvailability === false && useEvents){
								if(typeof v.on_unsupportedClient_callback != "undefined") v.on_unsupportedClient_callback(self,method,limit);
							}
							returnValue.push(false);

						}else if(amount < v.minLimit){									//Valores inválidos inferiores al límite
							self.availabilityDetailed[methodId].push(availability_minReached);

							if(typeof v.on_minLimitReached_callback != "undefined"){
								var limit = null; if(v.id != null){ limit = v.id; }
								if(useEvents){
									if(clientAvailability || clientAvailability == null ){
										v.on_minLimitReached_callback(self,method,limit,v.minLimit);
									} else if(!clientAvailability){
										if(typeof v.on_unsupportedClient_callback != "undefined") v.on_unsupportedClient_callback(self,method,limit);
									}
								}
							}else if(clientAvailability === false && useEvents){
								if(typeof v.on_unsupportedClient_callback != "undefined") v.on_unsupportedClient_callback(self,method,limit);
							}
							returnValue.push(true);

						}
					}
				}
			}

		})
		return returnValue;
	}

	return null;
	//Devuelve:
	//	null	  			método de pago no encontrado
	//	false  				no se puede pagar con ningún método
	//	[false,true...] 	estado de disponibilidad para cada subtipo
}
paymentsObj.prototype.getMethod = function(methodId){
	//Método que
	//Obtiene el objeto método correspondiente al id indicado

	var self = this;
	var value = null;
	$(this.payMethods).each(function(k,v){
		if(v.id == methodId){
			value = this
			return false;
		}
	})
	if(value != null){
		return value;
	}
	return false;
}
paymentsObj.prototype.getLimit = function(methodId,limitId){
	//Método que
	//Obtiene el objeto submétodo correspondiente a los identificadores de método y límite indicados

	var method = this.getMethod(methodId);
	var returnValue = null;
	if(method){
		$(method.limits).each(function(k,v){
			if(v.id == limitId){
				returnValue = v;
				return false;
			}
		})
	}
	if(returnValue != null){
		return returnValue;
	}
	return false;
}

paymentsObj.prototype.getSubmethodIndex = function(methodId,submethodId){
	var self = this;
	var submethod = self.getMethod(methodId);
	var valueToReturn = false;
	$(submethod.limits).each(function(k,v){
		if(v.id == submethodId){
			valueToReturn = k;
			return false;
		}
	})
	return valueToReturn;
}
paymentsObj.prototype.getBalance = function(){
	//Método que
	//Obtiene el balance disponible actual, o balance previo extraíble para los casos en los que son necesarios (carro y extracciones).

	if(this.isShoppingCart() || this.isWithdrawal()){
		return this.currentBalance;
	}
	return false;
}
paymentsObj.prototype.getCurrentAmount = function(){
	//Método que
	//Devuelve el importe con el que se va a operar y aplicar los cálculos
	return this.amountToAdd;
}
paymentsObj.prototype.setVoucherValue = function(voucherValue){
	this.voucherValue = Math.abs(voucherValue);
}

paymentsObj.prototype.getVoucherValue = function(){
	return this.voucherValue;
}
paymentsObj.prototype.isShoppingCart = function(){
	//Método que:
	//Devuelve si se está en un contexto de carro de la compra (implica la existencia de un importe de compra, y la disponibilidad de un balance previo)

	return this.shoppingCart;
}
paymentsObj.prototype.isWithdrawal = function(){
	//Método que:
	//Devuelve si este sistema de pago, se refiere a una extración de saldo (implica la existencia de un importe de extracción, y la disponibilidad de un balance previo "extraíble")

	return this.withdrawal;
}
paymentsObj.prototype.isUsingPreviousBalance = function(){
	//Método que:
	//Obtiene si se está usando saldo previamente disponible para las compras

	return this.usingPreviousBalance
}
paymentsObj.prototype.isUsingForceMinLimit = function(){
	//Método que:
	//Obtiene si se está usando el modo que permite operar por debajo del saldo mínimo

	return this.usingForceMinLimit
}
paymentsObj.prototype.isDebug = function(){
	return this.debug;
}
paymentsObj.prototype.getFirstAvailableMethod = function(){
	//Método que:
	//Obtiene el primer método de pago disponible y válido

	if(this.firstAvailableMethod.length > 0){
		return this.firstAvailableMethod;
	}
	return false;
}

paymentsObj.prototype.setPaymentAdditionalFields = function(additionalFieldsObj){
//Método que:
//Permite añadir un array de valores adicionales externos que se pasarán al método de pago.
//additionalFieldsObj = {
//	"miCampo1":4,
//	"foo":"bar",
//	"blabal":"blbele"
//}
	var self = this;
	if(typeof additionalFieldsObj === 'object'){
		self.additionalPaymentParameters = additionalFieldsObj;
	}else{
		console.log('"additionalFieldsObj" is not an object');
	}
}
paymentsObj.prototype.performPay = function(method,submethod,paymentProtocolObj,formElem,callbackOnFail){
	//Método que:
	//Obtiene el protolo de pago, y lanza la petición

	var self = this;
	var form = formElem;
	var cbf = function(){}

	this.paymentProtocolObj = paymentProtocolObj;

	var options = {
		extraFields: {
		}
	}
	if(typeof self.paymentProtocolObj.amount 				!= "undefined"){ options["extraFields"]["amount"]				= self.paymentProtocolObj.amount }
	if(typeof self.paymentProtocolObj.method 				!= "undefined"){ options["extraFields"]["method"]				= self.paymentProtocolObj.method}
	if(typeof self.paymentProtocolObj.submethod 			!= "undefined"){ options["extraFields"]["submethod"]			= self.paymentProtocolObj.submethod}
	if(typeof self.paymentProtocolObj.uid 					!= "undefined"){ options["extraFields"]["uid"]					= self.paymentProtocolObj.uid}
	if(typeof callbackOnFail 								!= "undefined"){ cbf = callbackOnFail}

	if(typeof self.paymentProtocolObj.isShoppingCart 		!= "undefined"){ options["extraFields"]["isShoppingCart"]		= self.paymentProtocolObj.isShoppingCart}
	if(typeof self.paymentProtocolObj.usePreviousBalance 	!= "undefined"){ options["extraFields"]["usePreviousBalance"]	= self.paymentProtocolObj.usePreviousBalance}
	if(typeof self.paymentProtocolObj.forceMinLimit 		!= "undefined"){ options["extraFields"]["forceMinLimit"]		= self.paymentProtocolObj.forceMinLimit}
	if(typeof self.paymentProtocolObj.storedValueID 		!= "undefined"){ options["extraFields"]["storedValueID"]		= self.paymentProtocolObj.storedValueID}
	if(typeof self.paymentProtocolObj.customValues 			!= "undefined"){ options["extraFields"]["customValues"]			= self.paymentProtocolObj.customValues}
	if(typeof self.paymentProtocolObj.saveInAgenda 			!= "undefined"){ options["extraFields"]["saveInAgenda"]			= self.paymentProtocolObj.saveInAgenda}
	if(typeof self.paymentProtocolObj.uploadToken 			!= "undefined"){ options["extraFields"]["uploadToken"]			= self.paymentProtocolObj.uploadToken}

	sendDataAsJSON: 					//Envía los datos como JSON en lugar de form,
	ignoreFormFields:					//Ignora los campos del formulario. Sirve para procesar sólo extraFields.

	options["sendDataAsJSON"] = true;
	options["ignoreFormFields"] = true;

	if(self.isWithdrawal()){
		options["extraFields"]["forceMinLimit"] = false;
	}
	// PSD2
	options["extraFields"]["screenColorDepth"] = screen.colorDepth;
	options["extraFields"]["screenwidth"] = screen.width;
	options["extraFields"]["screenheight"] = screen.height;
	options["extraFields"]["language"] = navigator.language;
	options["extraFields"]["timezoneOffset"] = new Date().getTimezoneOffset();

	if(self.isValidationMode()){
		options["extraFields"]["method"] = self.isValidationMode().method;
		options["extraFields"]["submethod"] = self.isValidationMode().submethod;
	}
/* 	if(self.getAutoSubmethod(paymentProtocolObj.method) && typeof self.paymentProtocolObj.customValues != "undefined"){
		var lastPaymentResultSubmethod = "default";
	}else if(!self.getAutoSubmethod(paymentProtocolObj.method) && typeof self.paymentProtocolObj.customValues != "undefined"){
		var lastPaymentResultSubmethod = null;
	}else{
		var lastPaymentResultSubmethod = self.paymentProtocolObj.submethod;
	} */
	if(self.getAutoSubmethod(paymentProtocolObj.method) && paymentProtocolObj?.submethod == undefined){
		var lastPaymentResultSubmethod = "default";
	}else if(!self.getAutoSubmethod(paymentProtocolObj.method) && paymentProtocolObj?.submethod == undefined){
		var lastPaymentResultSubmethod = null;
	}else{
		var lastPaymentResultSubmethod = self.paymentProtocolObj.submethod;
	}
	options["callbackOnSuccess"] = function(e){
		self.setLastPaymentResult(self.paymentProtocolObj.method,lastPaymentResultSubmethod)

		self.onSuccess(e);
		self.paymentInProgress = false;
	}
	options["callbackOnFail"] = function(e){
		self.setLastPaymentResult(self.paymentProtocolObj.method,lastPaymentResultSubmethod)
		cbf(e);
		self.onFail(e);
		self.paymentInProgress = false;
	};
	options["callbackOnError"] = self.onFail;

	options["submitBt"]={
		elem: $(formElem).find('[data-submit-payment]'),
		holdMsg: self.strings.wait,
		enableOnSuccess: true
	};
	options["statusMsg"]={
		elem: $(formElem).find('[data-status-msg]')
	};

	if(!self.isValidationMode()){
		options["statusMsg"]["ok"] = self.strings.paymentDone;
	}else{
		options["statusMsg"]["ok"] = self.strings.validationDone;
	}

	//Si hay parametros definidos por el usuario, se envia el extrafield "userDefinedFields"
	if(self.additionalPaymentParameters != null){
		options["extraFields"]["userDefinedFields"] = {}
		$.each(self.additionalPaymentParameters,function(k,v){
			options["extraFields"]["userDefinedFields"][k] = v;
		})
	}
	var payForme = new formeSubmit($(form),self.purchaseURL,options);

/*
	this.paymentProtocolObj = {
		amount:0,					//importe
		method:0,					//id método
		submethod: null,			//id submétodo|null
		usePreviousBalance: false,	//true|false
		isShoppingCart:false,		//true|false
		storedValueID:null,			//Si existe un método guardado, se le pasa el ID y NO HARÍA FALTA PASAR LOS CUSTOM VALUES
		customValues: new Array(	//lista de valores que se va a pasar al sistema de pago, si no existe un valor almacenado previo (storedValueID)
			"1239182381231",
			"03",
			"2020",
			"123"
		),
		saveInAgenda: true			//flag que define si el método se guardará para uso posterior,
		uploadToken: 33				//token que se obtiene al subir un documento para retiradas de saldo
	}
*/


}
paymentsObj.prototype.getAvailability = function(){
	//Método que:
	//Devuelve el estado de disponibilidad, desde que se lanzó la última llamada a setAmount(), de todos los métodos de pago conforme al protocolo:
	//{keyDelMetodo: array(true,false)}, <-- submétodos
	//{keyDelMetodo: array(true)}...

	return this.availability;
}

paymentsObj.prototype.getDetailedAvailability = function(methodId){
	//Método que:
	//Devuelve el estado de disponibilidad, desde que se lanzó la última llamada a setAmount(), de todos los métodos de pago conforme al protocolo:
	//{keyDelMetodo: array(true,3,0,1)}, <-- submétodos
	//{keyDelMetodo: array(true)}...
	//Devuelve codigo de error en el caso de no disponibilidad
	//true = disponible
	//0 = deshabilitado o no disponible
	//1 = min alcanzado
	//2 = max alcanzado
	//3 = importe restante alcanzado
	if(typeof methodId != "undefined"){
		return this.availabilityDetailed[methodId];
	}else{
		return this.availabilityDetailed;
	}
}
paymentsObj.prototype.getSubMethodAvailability = function(methodId,limitId){
	//Método que:
	//Devuelve si el submétodo indicado es viable. LLamar despues de haber hecho una llamada a isAvailable.
	//Acepta limitId = null si el método tuviera sólo un submétodo, por lo que devolvería la viabilidad del mismo.
	var self = this;
	var returnedValue = false;
	var limit = false
	if(methodId !== false){
		var availability = self.getAvailability();
		$.each(availability,function(k,v){
			if(k == methodId && v.length > 1){
				var method = self.getMethod(k);
				$(method.limits).each(function(limitk,limitv){
					if(limitv.id == limitId){
						if(availability[k][limitk] === true){
							returnedValue = true;
							return false;
						}
					}
				})
			}else if(k == methodId && v.length == 1){
				if(limitId == null){
					if(availability[k][0] === true){
						returnedValue = true;
						return false;
					}
				}
			}
		})
	}
	return returnedValue;
}
paymentsObj.prototype.getPaymentInProgressElems = function(){
	//Método que:
	//Si se está realizando un pago en este momento, devuelve un objeto que tiene method y submethod, indicando cuales son los métodos que se están procesando
	//en ese momento. Existe durante la ejecución del callback del forme de performPay. Antes o después valdrá false
	return this.paymentInProgress;
}
paymentsObj.prototype.initProvidedDocuments = function(){
	var self = this;
	//Inicializamos la lista de documentos que se han enviado en esta sesión de pago. Si no se ha enviado, todos los que lo requieran, serán false.
	if(self.isWithdrawal()){
		$.each(this.payMethods,function(k,v){
			if(v.documento){
				self.providedDocuments[v.id] = false;
			}
		})
	}
}
paymentsObj.prototype.getProvidedDocumentsStatus = function(methodId){
	if(typeof this.providedDocuments[methodId] != "undefined"){
		return this.providedDocuments[methodId];
	}
	return null;
}
paymentsObj.prototype.setProvidedDocumentsToken = function(methodId,token){
	var self = this;
	if(typeof this.providedDocuments[methodId] != "undefined"){
		this.providedDocuments[methodId] = token;
		self.isAvailable(methodId);
		return true;
	}else{
		return false;
	}
}
paymentsObj.prototype.setLastPaymentResult = function(methodId,limitId){
	this.lastPaymentResult = {
		method: methodId,
		submethod: limitId
	}
}
paymentsObj.prototype.getLastPaymentResult = function(){
	return this.lastPaymentResult;
}
paymentsObj.prototype.isValidationMode = function(){
	if(this.validationMode){
		return this.validationMode;
	}else{
		return false;
	}
}
paymentsObj.prototype.isForFundingOnly = function(methodId){
	var self = this;
	var method = self.getMethod(methodId);
	if(method && typeof method.useForFundingOnly != "undefined" && typeof method.useForFundingOnly.url != "undefined"){
		return method.useForFundingOnly.url;
	}else{
		return false;
	}
}
paymentsObj.prototype.canUseVirtualCash = function(method,limit,options){
	var self = this;
	var saldo = self.getBalance();
	var importePago = self.getAmount();
	var limite = limit;
	var returnExceededMinLimit = false;

	if(typeof options != "undefined"){
		if(typeof options.returnExceededMinLimit != "undefined" && options.returnExceededMinLimit === true){
			//Si se establece options.returnExceededMinLimit, devolverá -1 en lugar de false, si no se puede usar el saldo virtual
			//porque el importe de la compra, menos el saldo, quede por debajo del límite inferior del método de pago.
			//Sirve por ej. para mostrar el mensaje de por qué no se puede usar saldo virtual en determinados casos.
			returnExceededMinLimit = true;
		}
	}
	//Comprobamos si el método está disponible
	//***************
	var availabilityz = self.getDetailedAvailability([method.id]);
	var valueToReturn = true;
	if(method.id != "sv"){
		//console.log(method.id,limit.id)
		var index = self.getSubmethodIndex(method.id,limit.id);
		if(index !== false && availabilityz[index]){
			if(typeof limite.allowFundsCompensation != "undefined" && limite.allowFundsCompensation === true){
				if(saldo > 0 && saldo < importePago && importePago > limite.minLimit && importePago < limite.remaining){
					if((importePago-saldo) >= limite.minLimit){
						return true;
					}else{
						return -1;
					}
				}
			}
		}else{
			return false;
		}
	}


	return false;
}
paymentsObj.prototype.removeDocumentRequirement = function(methodId){
	var self = this;
	var method = self.getMethod(methodId);
	if(typeof self.providedDocuments[methodId] != "undefined"){
		delete self.providedDocuments[methodId];
		method.documento = false;
		return true;
	}
	return false;
}
paymentsObj.prototype.setNewDocumentRequirement = function(documentId,methodId){
	var self = this;
	var method = self.getMethod(methodId);
	var hadPreviousDocument = false;
	if(typeof method.documento != "undefined" && method.documento != null && method.documento !== false){
		hadPreviousDocument = method.documento;
	}
	if(typeof self.providedDocuments[methodId] == "undefined" || (typeof self.providedDocuments[methodId] != "undefined" && hadPreviousDocument && hadPreviousDocument != documentId)){
		self.providedDocuments[methodId] = false;	//reseteamos el estado de provisión del documento, si no existe actualmente.
		method.documento = documentId;
		return true;
	}
	return false;
}
paymentsObj.prototype.checkClientAvailability = function(methodID){
	switch (methodID){
		case "apple_pay":
			return(window.ApplePaySession ?? false);
		break;
	}
	return null;
}

var paymentsManager = function(options){

	this.paymentsObj 				= {};
	this.elem 						= "[data-payManager]";
	this.payManagerSelector 		= "[data-payManager-methods]";
	this.cashRegisterSelector 		= "[data-payManager-cashRegister]";
	this.cashRegisterValueSelector 	= "[data-paymanagerCashValue]";

	this.cashRegisterOptions	= 	{
										maxValue:99000,
										minValue:0,
										decimals:2,
										changeCallback: function(){},
										addCallback:function(){},
										remCallback:function(){}
									}

	this.msg					=	{
										selector:		"[data-msg-area]",
										titleSelector:	"[data-msg-area-title]",
										msgSelector:	"[data-msg-area-message]"
									}
	this.actionAreaSelector 			= "[data-action-area]";
	this.totalOperationSelector			= "[data-total-operation]";
	this.totalOperationValueSelector	= "[data-total-operation-value]";
	this.storedMethodsListSelector		= "[data-payment-stored-list]";
	this.usePreviousBalanceSelector		= "[data-remainingbalance-area]";

	this.defaultSelectedMethod			= false;
	this.defaultSelectedSubMethod		= false;
	this.defaultSelectSubMethodWhenStored = false; //Opcional si queremos que al desplegar un método de pago, que se muestre automáticamente el submétodo que tiene valores almacenados en la agenda
	this.currencyObj = null; 				//Opcional, objecto tipo systemCurrency (currency.js)
	this.storedPayments = {}				//almacen de datos de métodos de pago guardados
	this.documentsObj = false				//Objeto documentos necesario para la validación en el withdraw
	this.onSuccess = function(){}
	this.selectFirstAvailableMethod = false;	//Opcional si queremos que por defecto al iniciar se despliegue Saldo Virtual como método de pago si es viable. Esta opción deshabilita selectFirstAvailableMethod.
	this.selectVCFirstIfAvailable = false;	//Opcional si queremos que por defecto al iniciar se despliegue el primer método de pago viable disponible. Si selectVCFirstIfAvailable está a true, esta función se deshabilita.
	this.animations = true;
	this.readyForPurchase = {};				//Privada que establece si se pueden hacer compras o no. Se sincroniza con el método setPurchaseButtonAvailability() y permite que performPayFromStorage() y performPayFromDefault() actúen
											//Si el objeto contiene un identificador del método (y en su interior -opcionalmente- un identificador del submétodo), indica que ese método está listo para la compra
											//Si no aparece, el método no está disponible
											//De esta forma no dependemos de la interfaz, sino del valor de esta propiedad para saber si se puede continuar o no con el proceso de compra
	this.currentMethodNav = null;			//Privada null|"default"|"stored". Establece el método actual de navegacion, en modo normal o modo agenda.
	this.currentSubmethodAutoNav = null;	//Privada null|"auto"|"manual". Establece el método actual de navegacion de los autoSubmethod, en modo auto o modo manual.
	/*
	this.readyForPurchase = {
		method: array submétodos,
		"5": null,
		"2": [2,3],
		"4": [4,5]
	}*/
	if(typeof options != "undefined"){
		if(typeof options.elem != "undefined"){
			this.elem = options.elem
			this.payManagerSelector 		= $(this.elem).find(this.payManagerSelector);
			this.cashRegisterSelector 		= $(this.elem).find(this.cashRegisterSelector);
			this.cashRegisterValueSelector 	= $(this.elem).find(this.cashRegisterValueSelector);
		}
		if(typeof options.selectFirstAvailableMethod && !options.selectFirstAvailableMethod){
			this.selectFirstAvailableMethod = false;
		}
		if(typeof options.selectVCFirstIfAvailable && options.selectVCFirstIfAvailable){
			this.selectVCFirstIfAvailable = true;
			this.selectFirstAvailableMethod = false;
		}
		if(typeof options.currencyObj != "undefined"){
			this.currencyObj = options.currencyObj;
		}
		if(typeof options.cashRegister != "undefined"){
			if(typeof options.cashRegister.maxValue != "undefined"){ this.cashRegisterOptions.maxValue = options.cashRegister.maxValue }
			if(typeof options.cashRegister.minValue != "undefined"){ this.cashRegisterOptions.minValue = options.cashRegister.minValue }
			if(typeof options.cashRegister.decimals != "undefined"){ this.cashRegisterOptions.decimals = options.cashRegister.decimals }
			if(typeof options.cashRegister.changeCallback != "undefined"){ this.cashRegisterOptions.changeCallback = options.cashRegister.changeCallback }
			if(typeof options.cashRegister.addCallback != "undefined"){ this.cashRegisterOptions.addCallback = options.cashRegister.addCallback }
			if(typeof options.cashRegister.remCallback != "undefined"){ this.cashRegisterOptions.remCallback = options.cashRegister.remCallback }
		}
		if(typeof options.paymentsStorageObj != "undefined"){
			this.storedPayments = options.paymentsStorageObj
		}
		if(typeof options.documentsObj != "undefined"){
			this.documentsObj = options.documentsObj
		}
		if(typeof options.onSuccess != "undefined"){ this.onSuccess = options.onSuccess }
	}

	/**********************/
	/** CARDS NAVIGATION **/
	/**********************/
	var self = this;
	var managerRow = $(this.payManagerSelector).find('li');


	$(this.payManagerSelector).find('li:not([data-showmore]) > button').on('click',function(){
		if(!$(this).closest('li').hasClass('is-active')){
			if(self.getAnimation()){
				$(self.payManagerSelector).find('li.is-active [data-paymanagercontent]').slideUp(function(){
				}).closest('li').removeClass('is-active')
			}else{
				$(self.payManagerSelector).find('li.is-active [data-paymanagercontent]').hide().closest('li').removeClass('is-active')
			}

			var method = self.getMethodFromDOM($(this))
			var methodId = method.id
			var selectedSubm =  self.getSelectedLimitId(true);
			if(self.paymentsObj.getAutoSubmethod(method.id)){
				if(!self.storedPayments.getMethod(method.id) || (self.storedPayments.getMethod(method.id) && !self.paymentsObj.isWithdrawal() && !self.storedPayments.getShowInPayments())){
					self.switchToAutoSubmethod(method.id)
					self.switchToDefaultMethods(method.id,"default")
				}else{
					self.paymentsObj.isAvailable(method.id)
					self.unsetPaymentMethodsFromList(method.id)
				}
			}
			if(typeof $(this).closest('li').attr('data-blocked') == 'undefined'){
				if(self.getAnimation()){
					$(this).closest('li').find('[data-paymanagercontent]').slideDown(function(){}).closest('li').addClass('is-active')
				}else{
					$(this).closest('li').find('[data-paymanagercontent]').show().closest('li').addClass('is-active')
				}

				if(typeof self.storedPayments.storedPaymentsObj != "undefined" && self.storedPayments.getPaymentsObj().length > 0 ){
					//Si hay objeto de agenda y alguno de los elementos guardados para el método de pago que se está abriendo
					//tuviera la característica "selected", entonces marcamos el primero de los submétodos disponibles
					if (self.defaultSelectSubMethodWhenStored){
						if(method.limits.length > 1 && !self.paymentsObj.getAutoSubmethod(methodId)){//Si tiene autosubmethod, no entramos para evitar que se active el submetodo automáticamente)
							var isSelectedItemFromAgenda = self.storedPayments.getSelectionFromMethod(methodId);
							if(isSelectedItemFromAgenda){
								self.setDefaultSubmethod(methodId,method.limits[0].id);
								self.hideSubMethods(methodId);
							}
						}
					}
					self.setFirstAvailableStoredMethod(methodId,selectedSubm ? selectedSubm : null);

				}

			}else{
				$(this).closest('li').addClass('is-active')
			}



			if(selectedSubm){

				if(self.getForceMinAllowed(methodId,selectedSubm)){
					if(self.getForceMinStatus(methodId,selectedSubm)){
						self.paymentsObj.setUseForceMinLimit(true);
					}else{
						self.paymentsObj.setUseForceMinLimit(false);
					}
				}else{
					self.paymentsObj.setUseForceMinLimit(false);
				}
			}
		}
	})
	$(this.payManagerSelector).find('li[data-showMore] > button').on('click',function(){
		$(self.payManagerSelector).find('li[data-isFiltered="true"]').slideDown().attr('data-isFiltered','false');
		$(this).closest('li[data-showMore]').remove();
	})

	$(this.payManagerSelector).find('[data-subMethodsTabs] input[data-submethod]').on('change',function(){
		var submetodo = $(this).attr('data-submethod');
		var metodo = $(this).attr('data-method');
/*  		$(this).closest("[data-paymanagerContent]").find("[data-subMethods] > li").removeClass('is-active');
		$(this).closest("[data-paymanagerContent]").find("[data-subMethods] > li[data-value='"+submetodo+"']").addClass('is-active'); */
		self.setSubmethod(metodo,submetodo);
/* 		if(self.paymentsObj.getAutoSubmethod(metodo)){
			self.switchToDefaultMethods(metodo,submetodo);
		} */
	})





	/****************************/
	/* DOCUMENTOS				*/
	/****************************/

	if(this.documentsObj){
		this.documentsObj.setOnAddedFileCallback(function(e,docElem){
			docElem.close();
			var selectedMethod = self.getSelectedMethodId()
			var selectedLimit = self.getSelectedLimitId()
			var token = e.docToken;
			self.paymentsObj.setProvidedDocumentsToken(selectedMethod,token);
			self.setDocumentStatus(true,selectedMethod,selectedLimit);
			self.paymentsObj.isAvailable(selectedMethod)
			if(selectedLimit == false){ selectedLimit = null }
			var navMethod = self.getNavMethod(selectedMethod,selectedLimit);
			if(navMethod == "stored"){
				self.performPayFromStorage(selectedMethod,selectedLimit);
			}else if(navMethod == "default"){
				self.performPayFromDefault(selectedMethod,selectedLimit);
			}
		})
	}

	/***********************/


	this.hideAllTotalOperations();
	this.blockAllMethods();
}
paymentsManager.prototype.purgeMethods = function(){
	//Método que:
	//Obtiene los submétodos y si sólo existe uno y el identificador no se corresponde con el del método, lo convierte adaptándolo al protocolo:
	//Adopta el identificdor del padre, así unificamos todos los datos para que funcionen con el protocolo común de paymentsObj, que implica que un único submétodo se convierta en un
	//submétodo "alias" del padre, pero puede ser que en algún caso reciba un único submétodo y entonces hay que convertirlo en este alias.
	var self = this;

	$(self.paymentsObj.payMethods).each(function(k,v){
		if(v.limits.length == 1 && (v.limits[0].id != v.id)){
			v.limits[0].id = v.id;
		}
	})
	//console.log(self.paymentsObj.payMethods)
}
paymentsManager.prototype.setFirstAvailableStoredMethod = function(methodId,limitId,cleanPrevSelection = true){
	var self = this;
	var method = self.getMethod(methodId)// self.getMethodFromDOM($(this))
	var selectedSubm =  limitId;//self.getSelectedLimitId(true);
	if(typeof self.storedPayments.storedPaymentsObj != "undefined" && self.storedPayments.getPaymentsObj().length > 0 ){
		//Si hay objeto de agenda y alguno de los elementos guardados para el método de pago que se está abriendo
		//tuviera la característica "selected", entonces marcamos el primero de los submétodos disponibles
		if (self.defaultSelectSubMethodWhenStored){
			if(method.limits.length > 1 && !self.paymentsObj.getAutoSubmethod(methodId)){//Si tiene autosubmethod, no entramos para evitar que se active el submetodo automáticamente)
				var isSelectedItemFromAgenda = self.storedPayments.getSelectionFromMethod(methodId);
				if(isSelectedItemFromAgenda){
					self.setDefaultSubmethod(methodId,method.limits[0].id);
					self.hideSubMethods(methodId);
				}
			}
		}

		//Si hay métodos almacenados y son válidos y viables, se marca el primero que encuentre
		if(self.getNavMethod(methodId,selectedSubm ? selectedSubm : null) == "stored"/*  && !payments.storedPayments.getSelection(methodId,selectedSubm ? selectedSubm : null) */){


			var storedItems = self.storedPayments.getMethod(methodId,selectedSubm ? selectedSubm : null);
			var detailedAv = self.paymentsObj.getDetailedAvailability(methodId);
			for(const key in storedItems.storedValues){
				const elem = storedItems.storedValues[key]
				const submIndex = self.paymentsObj.getSubmethodIndex(elem.parentMethodId,elem.methodId);
				if(detailedAv[submIndex] === true || detailedAv[submIndex] === 1 ){
					const storedId = elem.id;
					let domItem;
					if(cleanPrevSelection){
						self.unsetPaymentMethodsFromList(methodId,selectedSubm);
					}
					if(self.paymentsObj.getAutoSubmethod(methodId) || (!self.paymentsObj.getAutoSubmethod(methodId) && selectedSubm)){
						var selectedSubm_ = selectedSubm;
						if(self.paymentsObj.getAutoSubmethod(methodId)){
							selectedSubm_ = self.getSelectedLimitId(false);
						}
						self.setPaymentMethodFromList(storedId,methodId,selectedSubm_,true);
					}else{
						self.setPaymentMethodFromList(storedId,methodId,null,true);
					}
					break;
				}
			}
		}

	}
}
paymentsManager.prototype.attachPayMethodsObj = function(paymentsObj){
	//Método que:
	//Añade el objecto paymentsObj e inicializa los valores y métodos de pago por defecto/accesibles
	var self = this;
	if(typeof paymentsObj == "undefined" || (typeof paymentsObj != "undefined" && paymentsObj.length == 0)){
		return false;
	}
	this.paymentsObj = paymentsObj;
	//if(self.paymentsObj.isWithdrawal()){
		self.storedPayments.purgeOrphans(self.paymentsObj.payMethods);
	//}
	if(!self.paymentsObj.isValidationMode()){
		if(paymentsObj.isWithdrawal()){
			this.paymentsObj.initProvidedDocuments();
		}

		//Iniciamos eventos máquina registradora
		var cashRegisterElem = 	$(this.elem).find(this.cashRegisterSelector)
		var cashRegisterValueElem = $(cashRegisterElem).find(this.cashRegisterValueSelector)

		$(cashRegisterValueElem).on("change keyup", function(){
			self.setAmount($(this).val())
			self.cashRegisterOptions.changeCallback($(this).val());

		})
		countersEvents({ 'elem': $(cashRegisterElem),'max':this.cashRegisterOptions.maxValue,'min':this.cashRegisterOptions.minValue,'decimals':this.cashRegisterOptions.decimals,
			'calculatePurchaseOptionsAfterAddCallback': function() {
				self.cashRegisterOptions.addCallback($(cashRegisterValueElem).val());
				self.setAmount( parseFloat($(cashRegisterValueElem).val()) )
			},
			'calculatePurchaseOptionsAfterRemCallback': function() {
				self.cashRegisterOptions.remCallback($(cashRegisterValueElem).val());
				self.setAmount( parseFloat($(cashRegisterValueElem).val()) ) }
			}
		);
		$(cashRegisterElem).find('input').removeAttr('disabled');
		$(cashRegisterElem).find('button').removeAttr('disabled');

		if(this.paymentsObj.isShoppingCart()){
			$(this.payManagerSelector).find('[data-substractSaldo]').off('change').on('change',function(){
				var value = $(this).prop('checked');
				self.paymentsObj.setUsePreviousBalance($(this).prop('checked'));

				$(self.payManagerSelector).find('[data-substractSaldo]').each(function(){
					var elem = $(this).prop('checked',value).closest('label');

					var limit = self.getLimitFromDOM(elem);
					var lid = null;
					var method = self.getMethodFromDOM(elem);
					if(!limit){
						limit = null;
						var originalLimit = null;

					}else{
						lid = limit.id;
						var originalLimit = lid;
					}
					if(limit == null && self.storedPayments.getMethod(method.id) && self.getNavMethod(method.id) == "stored"){
						var selected = self.storedPayments.getSelection(method.id);
						if(selected){
							var subm = selected.methodId;
							limit = self.getLimit(method.id,subm)
							lid = subm;
						}
					}

					if(limit != null || limit == null && lid != null){
						if(value === true){
							$(elem).addClass('is-active');
							if(self.paymentsObj.canUseVirtualCash(method,limit)){
								self.showTotalOperation(method.id,lid);
							};
						}else{
							$(elem).removeClass('is-active');
							self.hideTotalOperation(method.id,lid);
						}
						self.setTotalOperationForMethod(null,method.id,originalLimit)

					}
				});
				//self.setAmount(self.paymentsObj.getCurrentAmount());
			})
			this.setAmount(this.paymentsObj.getCurrentAmount());
		}

		$(this.payManagerSelector).find('[data-forcemin]').off('change').on('change',function(){
			var value = $(this).prop('checked');

			var methodObj = self.getMethodFromDOM($(this));
			var submethodObj = self.getLimitFromDOM($(this));
			if(!submethodObj){
				var subm = null
			}else{
				var subm = submethodObj.id;
			}
			if(value){
				self.setForceMinForMethod(methodObj.id,subm);
			}else{
				self.unsetForceMinForMethod(methodObj.id,subm);
			}
		})
	}

	if(!self.paymentsObj.isValidationMode()){
		//Una vez establecido el importe, analizamos el primer método disponible y lo establecemos en el panel
		if(this.selectFirstAvailableMethod){
			var famethod = self.paymentsObj.getFirstAvailableMethod();
			if(famethod){
				if(famethod[1] != null){
					self.setDefaultSubmethod(famethod[0],famethod[1]);
					self.setDefaultMethod(famethod[0]);
				}else{
					self.setDefaultMethod(famethod[0]);
				}
			}
		}else if(this.selectVCFirstIfAvailable){
			availableMethods = this.paymentsObj.getAvailability();
 			if(typeof availableMethods["sv"] != "undefined" && Array.isArray(availableMethods["sv"]) && availableMethods["sv"][0] === true){
				self.setDefaultMethod("sv");
 			}
		}
	}else{
		//Establecemos activo el método de pago para validar
		self.setAmount(0);
		if(this.selectFirstAvailableMethod){
			self.setDefaultMethod(self.paymentsObj.isValidationMode().method);
		}
		on_validValues_functions(self.paymentsObj.isValidationMode().method,self.paymentsObj.isValidationMode().submethod,self)

	}

	/*************************/
	/* storedPayments + autoSubmethod EVENTS */
	/*************************/
	//Eventos para pagos modos default / stored y submetodo automático

	$(self.paymentsObj.payMethods).each(function(kmethod,method){

		if(!self.paymentsObj.isValidationMode()){
			var methodLimits = method.limits;
		}else{
			var methodLimits = new Array({
				id:self.paymentsObj.isValidationMode().submethod
			});
		}
		if(typeof method.documento == "undefined" || !method.documento || method.documento == null){
			self.removeDocumentRequirement(method.id)
		}

		if(!self.paymentsObj.isShoppingCart() || (self.paymentsObj.isShoppingCart() && !self.paymentsObj.isForFundingOnly(method.id))){
			if(methodLimits.length > 1){
				if(self.paymentsObj.getAutoSubmethod(method.id)){
					//self.switchToAutoSubmethod(method.id)
					//self.paymentsObj.isAvailable(method.id);
					var methodElem  = self.getMethodDOMelem(method.id);
					$(methodElem).find('[data-autoSubMehod-nav]').off('change').on('change',function(){
						if($(this).prop("checked")){
							self.switchToUserChoosableSubmethod(method.id);
						}else{
							self.switchToAutoSubmethod(method.id);
						}
					})
/* 					$(methodElem).find('[data-autoSubMehod-nav="auto"]').off('click').on('click',function(){
						self.switchToAutoSubmethod(method.id);
					})
					$(methodElem).find('[data-autoSubMehod-nav="advanced"]').off('click').on('click',function(){
						self.switchToUserChoosableSubmethod(method.id);
					}) */
				}
			}
			var	m = self.getMethodDOMelem(method.id);
			if(!self.storedPayments.getMethod(method.id)){
				$(m).find('form[data-payment-storage="stored"]').find(self.usePreviousBalanceSelector).remove();
			}

			$(methodLimits).each(function(klimit,limit){
				var submethod = "default";
				if(limit != null){ submethod = limit.id}

				var methodElem  = self.getLimitDOMelem(method.id,submethod);
				var storageDefaultElem = $(methodElem).find('form[data-payment-storage="default"]');
				var abideElem = $(methodElem).find('[data-payment-storage][data-abide]')
				$(abideElem).each(function(ak,av){
					//Se instancian los abide uno a uno, para evitar problemas con agrupaciones de formularios
					new Foundation.Abide($(av))
				})

				var storageStoredElem = $(methodElem).find('form[data-payment-storage="stored"]');
				var storageDefaultElem = $(methodElem).find('form[data-payment-storage="default"]');

				$(storageDefaultElem).find('[data-payment-storage-navigation]').addClass('is-active');
				$(storageStoredElem).find('[data-payment-storage-navigation]').addClass('is-active');

				if((typeof limit.allowSavePaymentData != "undefined" && !limit.allowSavePaymentData)/*  || typeof limit.allowSavePaymentData == "undefined" || self.paymentsObj.isWithdrawal() */){
				//Si es un withdrawal, eliminamos el botón de almacenar método de pago si se requiere validación
					$(storageDefaultElem).find('[data-payment-storage-add]').remove();
				}

				if(!self.storedPayments.getMethod(method.id)){
					$(storageDefaultElem).find('[data-payment-storage-nav]').remove();
					$(storageStoredElem).find('[data-payment-storage-nav]').remove();
				}else{
					if(self.paymentsObj.isWithdrawal()){

						let dom = self.getLimitDOMelem(method.id,submethod);
						//$(storageDefaultElem).find('[data-payment-storage-navigation]').remove();
					}
				}


				//$(storageDefaultElem).on("submit",function(ev){ ev.preventDefault();});
				$(storageDefaultElem).find('[data-submit-payment]').off('click').on('click',function(){
					$(this).closest('form').submit()
				});

				$(storageDefaultElem).on('formvalid.zf.abide',function(){
					self.performPayFromDefault(method.id,limit.id)
				}).on('forminvalid.zf.abide',function(ev){
					//console.log('invalid',ev)
				}).on("submit",function(ev){
					ev.preventDefault()
				});

				$(storageDefaultElem).find('[data-payment-storage-request]').off('click').on('click',function(){
					if(typeof self.documentsObj != "undefined"){
						if(method.documento){
							if(limit.id != "default"){
								self.documentsObj.setAdditionalProperty({operationMethod:limit.uid});
							}
							self.documentsObj.open(method.documento,true)
						}
					}else{
						console.log("Objeto \"Documento\" no añadido a la clase");
					}
				});
			})
		}else{
			var methodElem  = self.getMethodDOMelem(method.id);
			var storageDefaultElem = $(methodElem).find('form[data-payment-storage="default"]');
			$(storageDefaultElem).find('[data-submit-payment]').off('click').on('click',function(){
				self.performPayFromDefault(method.id)
			});
		}
	})
	self.toggleSubscriptionsMsgs();

	/***************************/
	/** storedPayments EVENTS **/
	/***************************/
	var uniqueAgendaForMethod = true;

	if(this.storedPayments.getPaymentsObj().length > 0){
		this.storedPayments.resetAllSelections();
		this.storedPayments.purgeOrphans(this.paymentsObj.payMethods);
		$(this.storedPayments.storedPaymentsObj).each(function(k,v){
			if(!self.paymentsObj.isValidationMode()){
				var methodLimits = self.getMethod(v.methodId).limits;
				var method = v.methodId;
				var methodElem  = self.getMethodDOMelem(v.methodId);

			}else{
				var methodLimits = new Array({
					id:self.paymentsObj.isValidationMode().submethod
				});
			}
			var storedItemsElem = $(methodElem).find(self.storedMethodsListSelector);
			if(!self.paymentsObj.isValidationMode()){
				var storedPaymentsHTMLOptions = {}
			}else{
				var storedPaymentsHTMLOptions = {ignoreVaultedItems:true}
			}
			var rendered = $(storedItemsElem).html(self.storedPayments.retrieveHTMLforMethod(method,null,storedPaymentsHTMLOptions));



			$(methodLimits).each(function(limK,limV){
				var submethod = null;

				if(limV.id != null){ submethod = limV.id; }

				var methodElem  = self.getMethodDOMelem(v.methodId);
				var submethodDOMElem = self.getLimitDOMelem(v.methodId,limV.id);
				$(rendered).find('tr[data-value]').off('click').on('click',function(e){
					//debugger
					if(e.target.nodeName != "INPUT"){
						$(this).find('input[type=radio]').trigger('click');
					}
				})

				$(rendered).find('input[type=radio]').off('change').on('change',function(){
					if(!self.paymentsObj.getAutoSubmethod(v.methodId)){
						//Obtenemos datos del item pulsado
						var selectedId = parseInt($(this).closest('[data-value]').attr('data-value'));
						var thisMethod = self.getMethodFromDOM($(this))
						self.setPaymentMethodFromList(selectedId,thisMethod.id)
						var selectedSubmethod = self.storedPayments.getSelection(thisMethod.id).methodId;
						var selectedMethod = self.storedPayments.getSelection(thisMethod.id).parentMethodId;
						self.unsetForceMinForMethod(selectedMethod,null,true);
						self.showUsePreviousBalance(selectedMethod,null)

						self.paymentsObj.isAvailable(v.methodId)
						var rfp = self.getReadyForPurchase(selectedMethod,selectedSubmethod);

						//if(!self.paymentsObj.isShoppingCart()){
							//Calculamos total en el botón para items de la agenda cuando se marcan
/* 							var amountWithFees = self.getAmountWithFeesForMethod(self.paymentsObj.getAmount(),selectedMethod,selectedSubmethod)
							amountWithFees = self.paymentsObj.applyConversionRate(parseFloat(amountWithFees),selectedMethod,selectedSubmethod); */
							self.setTotalOperationForMethod(null,selectedMethod,null);
						//}


						self.setPurchaseButtonAvailability(rfp,selectedMethod)
						if(!rfp){
							self.showMsg(selectedMethod,null);
						}else{
							if(!self.paymentsObj.isBelowLimit(self.paymentsObj.getAmount(),selectedMethod,selectedSubmethod)){
								self.clearMsg(selectedMethod,null);
							}
						}
						if(self.paymentsObj.getSubscriptionsState() && !self.paymentsObj.getSubscriptionsAllowed(selectedMethod,selectedSubmethod)){
							self.showSubscriptionsMsg(selectedMethod,null);
						}else{
							self.hideSubscriptionsMsg(selectedMethod,null);
						}
						//Activamos el submétodo correspondiente para ver sus mensajes y acciones

						if(self.storedPayments.getMethod(selectedMethod)){
							if(self.storedPayments.cvvRequired(selectedId,selectedMethod) && rfp){
								self.showRequiredFields(selectedMethod,selectedSubmethod);
							}else{
								self.hideRequiredFields(selectedMethod,selectedSubmethod);
							}
						}
					}else{
						var id = parseInt($(this).closest('[data-value]').attr('data-value'));
						self.storedPayments.setSelection(id,v.methodId,submethod)
						var currentSelection = self.storedPayments.getSelection(v.methodId,submethod);
						var subm = currentSelection.methodId;
						var met = self.getMethodFromDOM($(this)).id;
						if(!self.paymentsObj.isWithdrawal()){
							if(self.getForceMinAllowed(met,subm)){
								self.paymentsObj.setUseForceMinLimit(self.getForceMinStatus(met,subm))
							}else{
								self.paymentsObj.setUseForceMinLimit(false);
							}
							if(self.paymentsObj.getSubscriptionsState() && !self.paymentsObj.getSubscriptionsAllowed(met,subm)){
								self.showSubscriptionsMsg(met,"default");
							}else{
								self.hideSubscriptionsMsg(met,"default");
							}
							//var amountWithFees = self.getAmountWithFeesForMethod(self.paymentsObj.getAmount(),met,subm)
							//amountWithFees = self.paymentsObj.applyConversionRate(parseFloat(amountWithFees),met,subm);
							self.setTotalOperationForMethod(null,met,"default");
						}

						self.paymentsObj.isAvailable(v.methodId)
					}
				})


				//Navegación entre modos default / stored

				//Si la agenda es común para un método (ignorando submétodos), se sincronizan las acciones de las agendas para que actúen como única
				//$(methodElem).find('[data-submethods] > [data-submethod]').each(function(){
							//var elem = this;

				var elem = methodElem;
				var storageStoredElem = $(elem).find('form[data-payment-storage="stored"]');
				var storageDefaultElem = $(elem).find('form[data-payment-storage="default"]');
				var simpleNavElem = $(elem).find('[data-payment-navigation]')
				$(storageDefaultElem).find('[data-payment-storage-navigation]').addClass('is-active');
				$(storageStoredElem).find('[data-payment-storage-navigation]').addClass('is-active');
				if(v.storedValues.length == 0){
					$(storageDefaultElem).find('[data-payment-storage-nav]').attr('disabled','');
				}else{
					var cvvCounter = 0;
					$(v.storedValues).each(function(kstoredValues,storedValue){
						if(storedValue.isDefault && storedValue.enabled && (!self.paymentsObj.isShoppingCart() || (!self.paymentsObj.isWithdrawal() && self.storedPayments.getShowInPayments(storedValue.parentMethodId)))){
							self.switchToStoredMethods(v.methodId,submethod);
						}
						//Buscamos si alguno de los métodos almacenados requiere CVV. Si no, eliminamos el contenedor para ese submétodo.
						if(self.storedPayments.cvvRequired(storedValue.id,v.methodId)){
							cvvCounter++;
						}
					})
					if(cvvCounter == 0){
						$(elem).find('[data-payment-stored-required]').remove();
					}
				}

				$(storageDefaultElem).find('[data-payment-storage-nav]').off('click').on('click',function(){
					self.paymentsObj.isAvailable(v.methodId)
					self.switchToStoredMethods(v.methodId,null)
					$.each(methodLimits,function(mm,nn){
						self.showStorageForMethod(v.methodId,nn.id)
					})
					self.hideSubMethods(v.methodId)
				});
				$(simpleNavElem).find('[data-payment-nav]').off('click').on('click',function(){
					self.paymentsObj.isAvailable(v.methodId)
					self.switchToStoredMethods(v.methodId,null)
					$.each(methodLimits,function(mm,nn){
						self.showStorageForMethod(v.methodId,nn.id)
					})
					self.hideSubMethods(v.methodId)
				})

				$(storageStoredElem).find('[data-payment-storage-nav]').off('click').on('click',function(){
					if(!self.paymentsObj.getAutoSubmethod(v.methodId)){
						self.switchToDefaultMethods(v.methodId,null)
						self.showSubMethods(v.methodId)
						self.clearSubmethodsSelection(v.methodId)
					}else{
						self.switchToDefaultMethods(v.methodId,"default")
					}
						self.paymentsObj.isAvailable(v.methodId);

					});



							//***************************************** */
							//Eventos para pagos modos default / stored
							//***************************************** */


						//var methodElem  = self.getLimitDOMelem(v.methodId,submethod);
						var methodElem  = self.getMethodDOMelem(v.methodId);
						var storageStoredElem = $(methodElem).find('form[data-payment-storage="stored"]');
						var storageDefaultElem = $(methodElem).find('form[data-payment-storage="default"]');
						var submethodElem  = self.getLimitDOMelem(v.methodId,submethod);
						var storageStoredElemPerSubmethod = $(submethodElem).find('form[data-payment-storage="stored"]');
						var storageDefaultElemPerSubmethod = $(submethodElem).find('form[data-payment-storage="default"]');

						$(storageStoredElem).on("submit",function(ev){ ev.preventDefault();});
						$(storageStoredElem).find('[data-submit-payment]').off('click').on('click',function(){
							$(this).closest('form').submit()
						});
						$(storageStoredElem).off("formvalid.zf.abide").on("formvalid.zf.abide", function(ev,frm) {
/* 							if(typeof v.submethodId == "undefined" || v.submethodId == null){
								submethod = self.getSelectedLimitId();
								if(!submethod){
									submethod = null;
								}
							} */
							var selected = self.storedPayments.getSelection(self.getMethodFromDOM($(frm)).id);
							self.performPayFromStorage(v.methodId,selected.methodId);
						})

						if(self.paymentsObj.getAutoSubmethod(v.methodId) && submethod != "default" ){
							//Si el autosubmétodo está establecido, el método default controla las agendas
							//De forma que eliminamos la navegación individual de cada submétodo.
/* 							var storageStoredElem = $(methodElem).find('form[data-payment-storage="stored"]');
 */							$(storageDefaultElemPerSubmethod).find('[data-payment-storage-nav]').remove();
							$(storageStoredElemPerSubmethod).find('[data-payment-storage-navigation]').remove();
						}else if(self.paymentsObj.getAutoSubmethod(v.methodId) && submethod == "default" ){
							self.switchToAutoSubmethod(v.methodId);
							self.switchToStoredMethods(v.methodId,submethod);
						}
						if(!self.paymentsObj.getAutoSubmethod(v.methodId) && self.storedPayments.getPaymentsObj().length > 0 && (self.paymentsObj.isWithdrawal() || (!self.paymentsObj.isWithdrawal() && self.storedPayments.getShowInPayments(submethod)))){
							self.switchToStoredMethods(v.methodId,submethod)
						}
			})
		})


	}
	/**********************/
	this.setAmount(this.paymentsObj.getCurrentAmount());

}
paymentsManager.prototype.getCurrencyObj = function(){
	var self = this;
	if(self.currencyObj != null){
		return self.currencyObj;
	}else{
		return false;
	}
}
paymentsManager.prototype.setSavingForMethodState = function(state,methodId,limitID,forceState){
	//Función que habilita o deshabilita el control de guardar en agenda.
	//Por defecto, si se deshabilita, la propidad de guardar en agenda que se establece en paymentsObj se pone a false, pero puede forzarse a true
	//aunque el control esté disabled, pasando el parámetro forceState a true (siempre que el método soportara previamente el guardado en agenda).

	var self = this;
	var savingSelector = "[data-payment-storage-add]";
	const savingState = forceState ?? state;

	if(typeof limitID != "undefined" && limitID != null){
		var actionMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"] ' + savingSelector);
	}else{
		var actionMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ' + savingSelector);
		actionMgrElem = actionMgrElem[0];
	}
	var prevState = self.getLimit(methodId,limitID).allowSavePaymentData;
	var input = $(actionMgrElem).find('input');
	if(!state){
		$(actionMgrElem).addClass('disabled').removeClass('is-active');
		$(input).attr('disabled','');
		if(!savingState){
			$(input).prop('checked',false);
			$(input).closest('label').removeClass('is-active');
		}else{
			if(prevState){
				$(input).prop('checked',true);
				$(input).closest('label').addClass('is-active');
			}
		}
	}else{
		$(actionMgrElem).removeClass('disabled');
		$(input).removeAttr('disabled');
		if(prevState){
			$(actionMgrElem).addClass('is-active');
			$(input).prop('checked',true);
			$(input).closest('label').addClass('is-active');
		}
	}

}

paymentsManager.prototype.disableActionsForMethod = function(methodId,limitID){
	//Método que:
	//Bloquea el bloque de acciones del método de pago y límite indicados
	var self = this;
/* 	if(self.storedPayments.getPaymentsObj().length > 0 && !self.storedPayments.getMethod(methodId)){
 */		if(typeof limitID != "undefined" && limitID != null){
			var actionMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"] ' + this.actionAreaSelector);
		}else{
			var actionMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ' + this.actionAreaSelector);
			actionMgrElem = actionMgrElem[0];
		}
		$(actionMgrElem).removeClass('is-active');
/* 	}else{
		self.allowNavOnlyActionsForMethod(methodId,limitID)
	} */
	this.setPurchaseButtonAvailability(false,methodId,limitID);
}
paymentsManager.prototype.enableActionsForMethod = function(methodId,limitID){
	//Método que:
	//Desbloquea o habilita el bloque de acciones del método de pago o límite indicado
	if(typeof limitID != "undefined" && limitID != null){
		var actionMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"] ' + this.actionAreaSelector);
	}else{
		var actionMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ' + this.actionAreaSelector);
		actionMgrElem = actionMgrElem[0];
	}
	$(actionMgrElem).removeClass('allowNavOnly').addClass('is-active');

}
paymentsManager.prototype.allowNavOnlyActionsForMethod = function(methodId,limitID){
	//Método que:
	//Deshabilita el bloque de acciones del método de pago o límite indicado, excepto la parte de navegación, que se mostraría

	if(typeof limitID != "undefined" && limitID != null){
		var actionMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"] ' + this.actionAreaSelector);
	}else{
		var actionMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ' + this.actionAreaSelector);
		actionMgrElem = actionMgrElem[0];
	}
	$(actionMgrElem).removeClass('is-active').addClass('allowNavOnly');
}
paymentsManager.prototype.removeActionsForMethod = function(methodId,limitID){
	//Método que:
	//Elimina el bloque de acciones de un método o límite indicado. Práctico para eliminar métodos deshabilitados al inicio.

	if(typeof limitID != "undefined" && limitID != null){
		var actionMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"] ' + this.actionAreaSelector);
	}else{
		var actionMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ' + this.actionAreaSelector);
		actionMgrElem = actionMgrElem[0];
	}
	$(actionMgrElem).remove();
}
paymentsManager.prototype.getAnimation = function(){
	return this.animations;
}
paymentsManager.prototype.setAnimation = function(value){
	this.animations = value;
}
paymentsManager.prototype.setAmount = function(amount,voucher){
	//Método que:
	//Establece el importe en la interfaz, lo comunica a la clase lógica y lanza los refrescos de las cajas de total con sus valores calculados.
	//Bloquea o desbloquea los métodos de pago cuando el valor es 0.
	//Además deja seleccionados los submétodos válidos por cada método, y selecciona el primer método viable si no hubiera ninguno activo.
	//Opciones:
	//autoSelectFirstAvailablableSubmethod (true):  Si false, no marca por defecto la selección automática del primer submétodo disponible

	var self = this;
	if(this.paymentsObj.isShoppingCart() && typeof voucher != "undefined"){
		this.paymentsObj.setVoucherValue(voucher);
		var hasVouchers = true;
		this.paymentsObj.setAmount(amount,this.paymentsObj.getVoucherValue());
	}else{
		this.paymentsObj.setAmount(amount,voucher);
		var hasVouchers = false;
		if(this.paymentsObj.getVoucherValue() > 0 && this.paymentsObj.isShoppingCart()){
			hasVouchers = true;
		}
	}




	if(amount == 0 && !self.paymentsObj.isValidationMode()){
		if(hasVouchers){
			this.unblockAllMethods();
		}else{
			this.blockAllMethods();
		}
	}else{
		this.unblockAllMethods();
	}

	this.setTotalOperation(amount);

	//Si la cantidad y el submétodo actual son viables, lo mantiene, si no, marca el primer
	//submétodo viable

	if((this.selectFirstAvailableMethod || this.selectVCFirstIfAvailable) && self.paymentsObj.getSubMethodAvailability(this.getSelectedMethodId(),this.getSelectedLimitId()) === false){
		if(this.selectFirstAvailableMethod){
			this.selectFirstAvailableSubmethod();
		}else if(this.selectVCFirstIfAvailable){
			if(self.paymentsObj.getSubMethodAvailability(0,null)){
				self.setDefaultMethod(0);
			}
		}
	}
	if(this.selectFirstAvailableMethod){
		var previoslySelectedMethod = this.getSelectedMethod();
		if(!previoslySelectedMethod){
			var famethod = self.paymentsObj.getFirstAvailableMethod();
			if(famethod){
				self.setDefaultMethod(famethod[0]);
				self.setDefaultSubmethod(famethod[0],famethod[1]);
			}
		}
	}

	//Comprobamos la elegibilidad y visibilidad del sistema para pagar con saldo disponible
	self.checkCanUsePreviousBalance();
}
paymentsManager.prototype.checkCanUsePreviousBalance = function(){
	var self = this;
	$(self.paymentsObj.payMethods).each(function(mkey,metodo){
		$(metodo.limits).each(function(lkey,limite){
			switch(self.paymentsObj.canUseVirtualCash(metodo,limite,{returnExceededMinLimit:true})){

				case true:
					self.showUsePreviousBalance(metodo.id,limite.id);
					if(self.paymentsObj.isUsingPreviousBalance()){
						self.showTotalOperation(metodo.id,limite.id);
					}

				break;
				case -1: //No es elegible pero porque el importe menos el saldo , es inferior al límite mínimo permitido (mostramos mensaje)
					self.hideUsePreviousBalance(metodo.id,limite.id,true);
					self.hideTotalOperation(metodo.id,limite.id);
				break;
				case false: //No es elegible
					self.hideUsePreviousBalance(metodo.id,limite.id);
					self.hideTotalOperation(metodo.id,limite.id);
				break;
			}
		})
	})
}
paymentsManager.prototype.refresh = function(animated){
	//Método que:
	//Refresca y reevalua todo

	var self = this;
	var voucher;
	if(this.paymentsObj.getVoucherValue() > 0){
		voucher = this.paymentsObj.getVoucherValue();
	}
	this.setAmount(this.paymentsObj.getAmount(),voucher);
	$(this.elem).find('[data-payment-storage] [data-status-msg]').empty().hide();
	self.toggleSubscriptionsMsgs();
}

paymentsManager.prototype.setMsg = function(methodId,limitID,title,message,optionalValuesArray){
	//Método que:
	//Establece los mensajes de aviso de disponibilidad para cada método de pago. Se suelen llamar desde las funciones de callback.
	//Puede recibir un array con valores, que se usaran como placeholders de datos ( %1,%2,%3... ) dentro del mensaje.

	if(limitID != null){
		var payMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"]');
		var elemTitle = $(payMgrElem).find(this.msg.titleSelector);
		var elemContent = $(payMgrElem).find(this.msg.msgSelector);
		var elemMsg = $(payMgrElem).find(this.msg.selector);
	}else{
		var payMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"]');
		var elemTitle = $(payMgrElem).find(this.msg.titleSelector)[0];
		var elemContent = $(payMgrElem).find(this.msg.msgSelector)[0];
		var elemMsg = $(payMgrElem).find(this.msg.selector)[0];
	}


	if(typeof optionalValuesArray != "undefined" && Array.isArray(optionalValuesArray)){
		$(optionalValuesArray).each(function(k,v){
			var placeHolder = "%"+(k+1);
			message = message.replace(new RegExp(placeHolder, 'g'), v);
		})
	}
	if(title != null){
		$(elemTitle).html(title);
	}
	$(elemContent).html(message);
	$(elemMsg).addClass('is-active');
}
paymentsManager.prototype.showMsg = function(methodId,limitID){
	//Método que:
	//Muestra la caja de mensajes de validez para un método y límite definido.

	if(typeof limitID != "undefined" && limitID != null){
		var payMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"]');
		var elemMsg = $(payMgrElem).find(this.msg.selector);
	}else{
		var payMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"]');
		var elemMsg = $(payMgrElem).find(this.msg.selector)[0];
	}
	$(elemMsg).addClass('is-active');
}
paymentsManager.prototype.clearMsg = function(methodId,limitID){
	//Método que:
	//Oculta y vacía la caja de mensajes de validez para cada método y límite indicado.

	if(typeof limitID != "undefined" && limitID != null){
		var payMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"]');
		var elemTitle = $(payMgrElem).find(this.msg.titleSelector);
		var elemContent = $(payMgrElem).find(this.msg.msgSelector);
		var elemMsg = $(payMgrElem).find(this.msg.selector);
		$(payMgrElem).find('[data-payment-storage] [data-status-msg]').empty().hide();

	}else{
		var payMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"]');
		var elemTitle = $(payMgrElem).find(this.msg.titleSelector)[0];
		var elemContent = $(payMgrElem).find(this.msg.msgSelector)[0];
		var elemMsg = $(payMgrElem).find(this.msg.selector)[0];
		$(payMgrElem).find('[data-payment-storage] [data-status-msg]').empty().hide();

	}

	$(elemTitle).empty();
	$(elemContent).empty();
	$(elemMsg).removeClass('is-active');
}
paymentsManager.prototype.getMethod = function(methodId){
	//Método que:
	//Obtiene el objeto con el método de pago indicado

	var method = this.paymentsObj.getMethod(methodId);
	if(method){
		return method;
	}
	return false;
}
paymentsManager.prototype.getMethodDOMelem = function(methodId){
	//Método que:
	//Obtiene el DOM del método de pago indicado

	var self = this;
	var elem = $(self.payManagerSelector).find("> li[data-value='"+methodId+"']");
	if(elem.length > 0){
		return $(elem);
	}
	return false;
}
paymentsManager.prototype.getMethodFromDOM = function(DOMelem){
	var mElem = $(DOMelem).closest('li[data-method][data-value]');
	var methodId = $(mElem).attr('data-value');
	if(typeof mElem != "undefined" ){
		return this.getMethod(methodId);
	}
	return false;
}
paymentsManager.prototype.getLimit = function(methodId,limitId){
	//Método que:
	//Obtiene el objeto límite indicado para un método de pago indicado

	return this.paymentsObj.getLimit(methodId,limitId);
}
paymentsManager.prototype.getLimitDOMelem = function(methodId,limitId){
	//Método que:
	//Obtiene el DOM del límite indicado para un método de pago indicado

	var self = this;
	if(limitId == null && self.paymentsObj.getAutoSubmethod(methodId)){
		limitId = "default";
	}
	var methodElem = this.getMethodDOMelem(methodId);
	if(methodElem){
		var elem = $(methodElem).find("[data-submethods] > li[data-value='"+limitId+"']");
		if(elem.length > 0){
			return $(elem);
		}
	}

	return false;
}
paymentsManager.prototype.getLimitFromDOM = function(DOMelem){
	var mElem = $(DOMelem).closest('li[data-method][data-value]');
	var methodId = $(mElem).attr('data-value');
	var method = this.getMethod(methodId);
	var submethodId = null;

	if(typeof methodId != "undefined" && method.limits.length > 0){
		if(method.limits.length > 1 || (method.limits.length == 1 && method.limits[0].id != null)){
			var elem = $(DOMelem).closest('li[data-subMethod][data-value]');
			if(typeof elem != "undefined"){
				var submethodId = $(elem).attr('data-value')
			}
		}
	}

	if(typeof mElem != "undefined" && typeof submethodId != "undefined"){
		return this.getLimit(methodId,submethodId);
	}
	return false;
}
paymentsManager.prototype.getAmountWithFeesForMethod = function(amount,methodId,subMethodId){
	//Método que:
	//Obtiene el importe con comisiones para el método e importe indicados

	return this.paymentsObj.getAmountWithFeesForMethod(amount,methodId,subMethodId);
}
paymentsManager.prototype.setTotalOperation = function(amount,currentBalance){
	//Método que:
	//Establece el importe final, en las cajas de total para todos los métodos

	var self = this;
	$(self.paymentsObj.payMethods).each(function(kMethod,method){
		$(method.limits).each(function(ksub,sub){
			var minLim = amount;
			if(amount < sub.minLimit){
				minLim = sub.minLimit;
			}
			var amountWithFees = self.getAmountWithFeesForMethod(minLim,method.id,sub.id)
			if(self.paymentsObj.isShoppingCart()){
				if(self.paymentsObj.isUsingPreviousBalance()){
					var importeAPagar = self.paymentsObj.getAmountToPaySubstractingBalance(amountWithFees,self.paymentsObj.getBalance(),method.id);
					importeAPagar = parseFloat(importeAPagar).toFixed(2)
				}else{
					var importeAPagar = amountWithFees;
					importeAPagar =parseFloat(importeAPagar).toFixed(2)
				}
				self.setTotalOperationForMethod(importeAPagar,method.id,sub.id)
			}else{
				var importeAPagar = amountWithFees;
				self.setTotalOperationForMethod(importeAPagar,method.id,sub.id)
			}

			if(self.storedPayments.getMethod(method.id) && self.getNavMethod(method.id) == "stored"){
				if(self.paymentsObj.getAutoSubmethod(method.id)){
					var s = "default"
				}else{
					var s = null;
				}
				var selected = self.storedPayments.getSelection(method.id);
				if(selected){
					var submethod = selected.parentMethodId;
					var minLim = amount;
					if(self.paymentsObj.isBelowLimit(amount,method.id,submethod)){
						minLim = self.getLimit(method.id,submethod).minLimit;
					}
					var amountWithFees = self.getAmountWithFeesForMethod(minLim,method.id,submethod);

					if(self.paymentsObj.isUsingPreviousBalance()){
						var importeAPagar = self.paymentsObj.getAmountToPaySubstractingBalance(amountWithFees,self.paymentsObj.getBalance(),method.id);
						importeAPagar = parseFloat(importeAPagar).toFixed(2)
					}else{
						var importeAPagar = amountWithFees;
						importeAPagar =parseFloat(importeAPagar).toFixed(2)
					}

					//var importeAPagar = self.paymentsObj.applyConversionRate(parseFloat(amountWithFees),method.id,submethod).toFixed(2);
					self.setTotalOperationForMethod(amountWithFees,method.id,s)
				}
			}
		})

	})
}
paymentsManager.prototype.showTotalOperation = function(methodId,limitID){
	//Método que:
	//Muestra la caja con el total de la operación en el método indicado y en el submétodo si lo hubiera

	if(typeof limitID != "undefined" && limitID != null){
		var totalOpElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"] '+ this.totalOperationSelector);
	}else{
		var totalOpElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] '+ this.totalOperationSelector);
	}
	//Deshabilitado porque esta información ahora se incluye en el botón de pago
	//$(totalOpElem).addClass('is-active')
}
paymentsManager.prototype.toggleSubscriptionsMsgs = function(){
	//Método que:
	var self = this;
	$(self.paymentsObj.payMethods).each(function(mk,m){
		$(m.limits).each(function(smk,sm){
			var isAutoSubmethod = self.paymentsObj.getAutoSubmethod(m.id);
			if(!isAutoSubmethod || isAutoSubmethod && sm.id != "default"){
				if(!self.paymentsObj.getSubscriptionsAllowed(m.id,sm.id) && self.paymentsObj.getSubscriptionsState()){
					self.showSubscriptionsMsg(m.id,sm.id);
				}else{
					self.hideSubscriptionsMsg(m.id,sm.id);
				}
			}else{
				//Si es submétodo automático:
				if(self.storedPayments.getMethod(m.id)){ //Si hay entradas en la agenda que corresponda con el método
					var currentSelection = self.storedPayments.getSelection(m.id)
					if (currentSelection){
						if(self.paymentsObj.getSubscriptionsState() && !self.paymentsObj.getSubscriptionsAllowed(m.id,sm.id)){
							self.showSubscriptionsMsg(m.id,sm.id);
						}else{
							self.hideSubscriptionsMsg(m.id,sm.id);
						}
					}else{
						self.hideSubscriptionsMsg(m.id,sm.id);
					}
				}
			}
		})
	})
}

paymentsManager.prototype.showSubscriptionsMsg = function(methodId,limitID){
	//Método que:
	var self = this;
	var item = false;
	if(limitID != null){
		var elem = self.getLimitDOMelem(methodId,limitID);
		item = $(elem).find('[data-info-autopayment]');
	}else{
		var elem = self.getMethodDOMelem(methodId);
		var found = $(elem).find('[data-info-autopayment]');
		$(found).each(function(){
			if($(this).closest('[data-submethod').length == 0){
				item = $(this);
				return false;
			}
		})
	}
	if(item){
		$(item).addClass("is-active");
	}
}

paymentsManager.prototype.hideSubscriptionsMsg = function(methodId,limitID){
	//Método que:
	var self = this;
	var item = false;
	if(limitID != null){
		var elem = self.getLimitDOMelem(methodId,limitID);
		item = $(elem).find('[data-info-autopayment]');
	}else{
		var elem = self.getMethodDOMelem(methodId);
		var found = $(elem).find('[data-info-autopayment]');
		$(found).each(function(){
			if($(this).closest('[data-submethod').length == 0){
				item = $(this);
				return false;
			}
		})
	}
	if(item){
		$(item).removeClass("is-active");
	}
}

paymentsManager.prototype.hideTotalOperation = function(methodId,limitID){
	//Método que:
	//Oculta la caja con el total de la operación en el método indicado y en el submétodo si lo hubiera


	if(typeof limitID != "undefined" && limitID != null){
		var totalOpElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"] '+ this.totalOperationSelector);
	}else{
		var totalOpElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] '+ this.totalOperationSelector);
	}
	$(totalOpElem).removeClass('is-active')
}
paymentsManager.prototype.hideAllTotalOperations = function(){
	//Método que:
	//Oculta las cajas con el total de la operación para todos los métodos

	var totalOpElems = $(this.elem).find(this.payManagerSelector).find(this.totalOperationSelector);
	$(totalOpElems).removeClass('is-active')
}
paymentsManager.prototype.showAllTotalOperations = function(){
	//Método que:
	//Muestra las cajas con el total de la operación para todos los métodos

	var totalOpElems = $(this.elem).find(this.payManagerSelector).find(this.totalOperationSelector);
	$(totalOpElems).addClass('is-active')
}
paymentsManager.prototype.showUsePreviousBalance = function(methodId,limitID){
	//Método que:
	//Muestra la caja con el selector de usar saldo previo disponible en el método indicado y en el submétodo si lo hubiera
	var self = this;
	var limit = limitID;
	if(self.storedPayments.getMethod(methodId) && self.getNavMethod(methodId) == "stored"){
		var selected = self.storedPayments.getSelection(methodId);
		var subm = selected.methodId;
		if(selected){
			limit = subm;
		}
	}

	if(typeof limitID != "undefined" && limitID != null){
		var useBalanceElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"] '+ this.usePreviousBalanceSelector);
	}else{
		var useBalanceElem = self.getMethodDOMelem(methodId);
		if(useBalanceElem){
			useBalanceElem = $(useBalanceElem).find('[data-payment-storage="stored"].is-active').find(this.usePreviousBalanceSelector)
		}
	}

	var checkAvailability = self.paymentsObj.canUseVirtualCash(self.getMethod(methodId),self.getLimit(methodId,limit),{returnExceededMinLimit:true});

	if(checkAvailability === true ){
		$(useBalanceElem).addClass('is-active').attr('data-remainingbalance-area','').find('input').removeAttr('disabled');
	}else if (checkAvailability == -1){
		self.hideUsePreviousBalance(methodId,limit,true)
	}
}
paymentsManager.prototype.hideUsePreviousBalance = function(methodId,limitID,dontHideButShowReason){
	//Método que:
	//Oculta la caja con el selector de usar saldo previo disponible en el método indicado y en el submétodo si lo hubiera
	//Si se indica dontHideButShowReason, muestra la caja pero la marca como no disponible e inhabilita el input
	var self = this;

	var showWhyCantBeUsed = false;
	if(typeof dontHideButShowReason != "undefined" && dontHideButShowReason === true){
		showWhyCantBeUsed = true;
	}
	if(typeof limitID != "undefined" && limitID != null){
		var useBalanceElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"] '+ this.usePreviousBalanceSelector);
	}else{
		var useBalanceElem = self.getMethodDOMelem(methodId)
		if(useBalanceElem){
			useBalanceElem =  	$(useBalanceElem).find('[data-payment-storage="stored"].is-active').find(this.usePreviousBalanceSelector);
		}
	}

	if(!showWhyCantBeUsed){
		$(useBalanceElem).removeClass('is-active')
	}else{
		$(useBalanceElem).addClass('is-active').attr('data-remainingbalance-area','unavailable');
		$(useBalanceElem).find('input').attr('disabled','disabled')
	}
}
paymentsManager.prototype.unsetUsePreviousBalance = function(methodId,limitID){
	var self = this;
	if(typeof limitID != "undefined" && limitID != null){
		var useBalanceElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"] '+ this.usePreviousBalanceSelector);
	}else{
		var useBalanceElem = self.getMethodDOMelem(methodId)
		if(useBalanceElem){
			useBalanceElem = $(useBalanceElem).find('[data-payment-storage="stored"].is-active').find(this.usePreviousBalanceSelector);
		}
	}
	$(useBalanceElem).prop('checked',false).closest('label').removeClass('is-active');
	$(useBalanceElem).trigger('change');
}

paymentsManager.prototype.setTotalOperationForMethod = function(amountToShow,methodId,limitID){
	//Método que:
	//Establece el importe total para la caja de total para un método/submétodo concreto. Si se pasa null, reestablece el importe total.
	var self = this;

/* 	if(typeof limitID != "undefined" && limitID != null){
		var totalOpElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"] '+ this.totalOperationValueSelector);
	}else{
		var totalOpElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] '+ this.totalOperationValueSelector);
	} */

	if(typeof limitID != "undefined" && limitID != null){
		if(self.storedPayments.getMethod(methodId) && (self.storedPayments.getShowInPayments(methodId) || (!self.storedPayments.getShowInPayments(methodId) && self.paymentsObj.isWithdrawal())) && self.getNavMethod(methodId) == "stored"){
			var totalOpElem = self.getMethodDOMelem(methodId);
			var selected = self.storedPayments.getSelection(methodId);
			if(selected && selected.methodId != limitID){
				return false;
			}
			if(totalOpElem){
				totalOpElem = $(totalOpElem).find('[data-payment-storage="stored"].is-active [data-amount]');
			}
		}else{
			var totalOpElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] ul[data-submethods] > li[data-value="'+limitID+'"] [data-amount]');
		}
	}else{
		if(self.storedPayments.getMethod(methodId) && (self.storedPayments.getShowInPayments(methodId) || (!self.storedPayments.getShowInPayments(methodId) && self.paymentsObj.isWithdrawal())) && self.getNavMethod(methodId) == "stored"){
			var totalOpElem = self.getMethodDOMelem(methodId);
			if(totalOpElem){
				totalOpElem = $(totalOpElem).find('[data-payment-storage="stored"].is-active [data-amount]');
			}
		}
		//	var totalOpElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] [data-amount]');
	}
	if(typeof limitID == "undefined" || (typeof limitID != "undefined" && limitID == null) && self.getNavMethod(methodId) == "stored"){
		var selected = self.storedPayments.getSelection(methodId);
		var subm = null;
		if(selected){
			var subm = selected.methodId;
		}
	}else{
		var subm = limitID;
	}

	if(amountToShow == null){

		var minLim = self.paymentsObj.getAmount();
		if(self.paymentsObj.isBelowLimit(minLim,methodId,subm)){
			minLim = self.getLimit(methodId,subm).minLimit;
		}
		//console.log(methodId,subm,minLim)
		var amountWithFees = self.getAmountWithFeesForMethod(minLim,methodId,subm)
		if(self.paymentsObj.isShoppingCart()){
			if(self.paymentsObj.isUsingPreviousBalance()){
				var importeAPagar = self.paymentsObj.getAmountToPaySubstractingBalance(minLim,self.paymentsObj.getBalance(),methodId,subm);
				importeAPagar = parseFloat(importeAPagar).toFixed(2)
			}else{
				var importeAPagar = amountWithFees;
				importeAPagar =parseFloat(importeAPagar).toFixed(2)
			}
			var amount = importeAPagar;

		}else{
			var amount = amountWithFees;
		}
	}else{
		var amount = amountToShow;
	}

	var conversionObj = self.paymentsObj.applyConversionRate(parseFloat(amount),methodId,limitID);
	amount = conversionObj.value;

	if(typeof totalOpElem != "undefined"){
		if(!self.getCurrencyObj()){
			$(totalOpElem).text(amount.formatMoney(2,",","."));
		}else{
			if(self.getCurrencyObj().getISOCurrency() != conversionObj.ISOcurrency){
				amount = self.getCurrencyObj().getMoneda(parseFloat(amount),conversionObj.ISOcurrency);
			}else{
				amount = self.getCurrencyObj().getMoneda(parseFloat(amount));
			}
			$(totalOpElem).text(amount);
		}
	}

}
paymentsManager.prototype.setDefaultMethod = function(methodId){
	//Método que:
	//Selecciona el método indicado en la caja de métodos de pago
	var elem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"]');
		$(elem).find('>button').click();
		this.defaultSelectedMethod = methodId;
}
paymentsManager.prototype.setDefaultSubmethod = function(methodId,limitID){
	//Método que:
	//Selecciona el submétodo indicado en la caja de métodos de pago,

/* 	var elem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"] [data-submethodstabs] input[type="radio"][data-submethod="'+limitID+'"][data-method="'+methodId+'"]');
	$(elem).prop('checked','checked').change(); */
	this.setSubmethod(methodId,limitID);
	this.defaultSelectedSubMethod = methodId;
}
paymentsManager.prototype.setSubmethod = function(methodId,limitID){
	//Método que:
	//Selecciona el submétodo indicado en la caja de métodos de pago,
	var self = this;

		var subMethod = self.getLimitDOMelem(methodId,limitID);
		var method = self.getMethodDOMelem(methodId);
		var forceMinStatus = self.getForceMinStatus(methodId,limitID);
		/* self.paymentsObj.setUseForceMinLimit(forceMinStatus); */
		var limits = self.getMethod(methodId).limits;
		var limitIndex = null;
		limits.map((e,k) => { if(limitID == e.id) limitIndex = k});



		if(self.paymentsObj.getDetailedAvailability(methodId)[limitIndex] === 1 || self.paymentsObj.getDetailedAvailability(methodId)[limitIndex] === true){
			if(forceMinStatus){
				self.setForceMinForMethod(methodId,limitID);
			}else{
				self.unsetForceMinForMethod(methodId,limitID);
			}
		}


		self.setTotalOperationForMethod(null,methodId,limitID);
		$(subMethod).closest("[data-paymanagerContent]").find("[data-subMethods] > li").removeClass('is-active');
		$(subMethod).addClass('is-active');
		$(method).find('[data-payment-navigation]').removeClass('is-active');
}

paymentsManager.prototype.unsetSubmethod = function(methodId){
	this.clearSubmethodsSelection(methodId);
}

paymentsManager.prototype.setSubscriptionsState = function(value){
	//Método que
	//Establece si un método permite el pago suscrito (abonos)
	this.paymentsObj.setSubscriptionsState(value);
	this.toggleSubscriptionsMsgs();
}

paymentsManager.prototype.blockMethod =  function(methodId,animated){
	//Método que:
	//Bloquea las acciones de un método indicado, inhabilitando el botón de pago.
	var animation = this.getAnimation();
	if(typeof animated != "undefined"){ animation = animated;}
	var payMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"]')
	$(payMgrElem).find('>button').attr('disabled','');
	if(animation){
		$(payMgrElem).find('[data-paymanagercontent]').slideUp();
	}else{
		$(payMgrElem).find('[data-paymanagercontent]').hide();
	}
	$(payMgrElem).attr('data-blocked','');
	$(payMgrElem).removeClass('.is-active');
	//this.setLimitsBadgeStatus(false,[0,1],methodId);

}
paymentsManager.prototype.blockAllMethods =  function(animated){
	//Método que:
	//Bloquea las acciones de todos los métodos, deshabilitando los botones de pago
	var self = this;
	var animation = this.getAnimation();
	if(typeof animated != "undefined"){ animation = animated;}
	var payMgrElems = $(this.elem).find(this.payManagerSelector).find('> li[data-value]')
	$(payMgrElems).each(function(){
		//$(this).attr('data-status','');
		$(this).find('>button').attr('disabled','');
		if(animation){
			$(this).find('[data-paymanagercontent]').slideUp();
		}else{
			$(this).find('[data-paymanagercontent]').hide();
		}
		$(this).attr('data-blocked','');
// 		$(this).removeClass('is-active');
	})


}
paymentsManager.prototype.unblockMethod =  function(methodId,animated){
	//Método que:
	//Desbloquea las acciones de un método indicado, habilitando el botón de pago
	var self = this;
	var animation = this.getAnimation();
	if(typeof animated != "undefined"){ animation = animated;}
	var classHTML = "";

	if(methodId == this.defaultSelectedMethod){
		classHTML = "is-active";
	}
	var payMgrElem = $(this.elem).find(this.payManagerSelector).find('> li[data-value="'+methodId+'"]')
	$(payMgrElem).find('>button').removeAttr('disabled','');

	if($(payMgrElem).hasClass('is-active') || (!$(payMgrElem).hasClass('is-active') && methodId == this.defaultSelectedMethod)){
		if(animation){
			$(payMgrElem).find('[data-paymanagercontent]').slideDown();
		}else{
			$(payMgrElem).find('[data-paymanagercontent]').show();
		}
		//self.paymentsObj.isAvailable(methodId);
	}
	$(payMgrElem).removeAttr('data-blocked');
}
paymentsManager.prototype.unblockAllMethods =  function(animated){
	//Método que:
	//Desbloquea las acciones de todos los métodos, habilitando el botón de pago

	var self = this;
	var animation = this.getAnimation();
	if(typeof animated != "undefined"){ animation = animated;}
	var payMgrElems = $(this.elem).find(this.payManagerSelector).find('> li[data-value]');
	var activeElems = $(this.elem).find(this.payManagerSelector).find('> li[data-value].is-active').length;
	$(payMgrElems).each(function(k,v){
		$(v).find('>button').removeAttr('disabled','');
		if(activeElems == 0){
			if($(v).attr('data-value') == this.defaultSelectedMethod){
				if(animation){
					$(v).find('[data-paymanagercontent]').slideDown();
				}else{
					$(v).find('[data-paymanagercontent]').show();
				}

			}
		}else{
			if($(v).hasClass("is-active")){
				if(animation){
					$(v).find('[data-paymanagercontent]').slideDown();
				}else{
					$(v).find('[data-paymanagercontent]').show();
				}
			}
		}
		$(v).removeAttr('data-blocked');
	})
}
paymentsManager.prototype.selectFirstAvailableSubmethod = function(methodId){
	//Método que:
	//Selecciona el primer submétodo de pago disponible y válido para el método indicado

	var self = this;

	$.each(this.paymentsObj.getAvailability(),function(k,v){
		if(v.length > 1){
			$(v).each(function(xk,xv){
				if(xv === true){
					var method = self.getMethod(k);
					var subMethod = method.limits[xk];
					self.setDefaultSubmethod(k,subMethod.id);
					return false;
				}
			})
		}
	})

}
paymentsManager.prototype.getSelectedMethod = function(){
	//Método que:
	//Obtiene el método de pago que se está mostrando actualmente

	var self = this;
	var elem = $(self.payManagerSelector).find("> li[data-value].is-active");
	if($(elem).length > 0){
		return $(elem);
	}else{
		return false;
	}
}
paymentsManager.prototype.getSelectedMethodId = function(){
	//Método que:
	//Obtiene el método de pago Id que se está mostrando actualmente

	var self = this;
	var elem = $(self.payManagerSelector).find("> li[data-value].is-active");
	if($(elem).length > 0){
		var methodId = $(elem).attr('data-value');
		if(typeof methodId != "undefined"){
			return methodId;
		}
	}else{
		return false;
	}
}
paymentsManager.prototype.getSelectedLimitId = function(ignoreDefault){
	//Método que:
	//Obtiene el submétodo de pago que se está mostrando actualmente
	//IgnoreDefault (false).
	//Por defecto, si el autoSubmethod está activado para un método,  getSelectedLimitId devolverá "default" si algún submétodo estuviera mostrándose
	//ya que los submétodos se muestran (junto al submétodo 'default'), para mostrar la lógica de validez de una entrada en la agenda
	//Si establecemos esta propiedad a true, ignoramos el submétodo default aunque existiera, y mostrarmos cuál de los submétodos estaría activo en ese momento.

	var self = this;
	var elem = self.getSelectedMethod();
	var methodId = self.getSelectedMethodId();
	var ignoreDef = false;
	if(typeof ignoreDefault != "undefined" && ignoreDefault){
		ignoreDef = true;
	}
	if(elem){
		if(!self.paymentsObj.getAutoSubmethod(methodId)){
			var limitId = $(elem).find('[data-submethods] > [data-submethod].is-active').attr('data-value');
			if(typeof limitId != "undefined" ){
				return limitId;
			}
		}else{
			var limitId = $(elem).find('[data-submethods] > [data-submethod].is-active');
			if(limitId.length > 0){
				var valueToReturn = false;
				$(limitId).each(function(k,v){
					if($(v).attr('data-value') == "default" && !ignoreDef){
						valueToReturn = "default";
						return false;
					}else{
						valueToReturn = $(v).attr('data-value');
					}
				})
				return valueToReturn;
			}

		}
	}
	return false;
}
paymentsManager.prototype.clearSubmethodsSelection = function(methodId){
	var self = this;
	var elem = self.getMethodDOMelem(methodId);
	if(self.getMethod(methodId).limits.length > 1){
		$(elem).find('[data-paymanagercontent] [data-submethodsTabs] input').prop('checked',false);
		$(elem).find('[data-paymanagercontent] [data-submethods] li[data-submethod]').removeClass('is-active');
		if(self.storedPayments.getMethod(methodId) && self.getNavMethod(methodId) == "default" && !self.paymentsObj.getAutoSubmethod(methodId)){
			$(elem).find('[data-payment-navigation]').addClass('is-active');
		}
	}
}
paymentsManager.prototype.getNavAutoSubmethod = function(){
	//Devuelve si el método tiene activo el submétodo automático (auto), o si el usuario tiene activo el modo manual (manual).
	//Devuelve false si el modo Automático no es aplicable para el método
	var self = this;
	if(self.currentSubmethodAutoNav != null){
		return self.currentSubmethodAutoNav;
	}else{
/* 		var elem = self.getMethodDOMelem(methodId);
		if(self.getMethod(methodId).limits.length > 1 && self.paymentsObj.getAutoSubmethod(methodId)){
			var smActive = $(elem).find('[data-paymanagercontent] [data-submethods] [data-submethod].is-active');
			if($(smActive).length > 0 && $(smActive).attr('data-value') == "default"){
				return "auto";
			}else{
				return "manual";
			}
		}else{ */
			return false;
/* 		}
 */	}
}

paymentsManager.prototype.switchToAutoSubmethod = function(methodId){
	var self = this;
	self.currentSubmethodAutoNav = "auto";
	self.hideSubMethods(methodId,true)
	self.showSubMethod(methodId,"default")
	self.paymentsObj.setUseForceMinLimit(false);

	self.setSubmethod(methodId,"default");
	var elem = self.getMethodDOMelem(methodId);

	self.unsetPaymentMethodsFromList(methodId);
	$(elem).find('[data-autoSubMehod-nav="advanced"]').addClass('is-active');
	$(elem).find('[data-autoSubMehod-nav="auto"]').removeClass('is-active')
	$(elem).find('[data-autoSubMehod-nav]').prop('checked',false)
	self.switchToStoredMethods(methodId,"default");
	//self.hideUsePreviousBalance(methodId,"default")
	self.unsetUsePreviousBalance(methodId,"default")
	self.paymentsObj.isAvailable(methodId);

	//Si la agenda tiene elementos marcados, volvemos a lanzar el change para activar los métodos
/* 	var inputId = self.storedPayments.getSelection(methodId)
	var submethod = "safecharge";
	if(inputId){
		var submethodElem = self.getLimitDOMelem(methodId,"default");
		var inputElem = $(submethodElem).find(self.storedMethodsListSelector).find('[data-value="' + inputId.id + '"] input');
		$(inputElem).trigger('change');
	} */
}

paymentsManager.prototype.switchToUserChoosableSubmethod = function(methodId){
	var self = this;
	self.currentSubmethodAutoNav = "manual";
	self.showSubMethods(methodId,true)
	self.hideSubMethod(methodId,"default")

	self.clearSubmethodsSelection(methodId);
	var elem = self.getMethodDOMelem(methodId);
	self.paymentsObj.setUseForceMinLimit(false);
	$(elem).find('[data-autoSubMehod-nav="advanced"]').removeClass('is-active');
	$(elem).find('[data-autoSubMehod-nav="auto"]').addClass('is-active');
	$(elem).find('[data-autoSubMehod-nav]').prop('checked',true);
	self.paymentsObj.isAvailable(methodId);

}

paymentsManager.prototype.getNavMethod = function(methodId,limitID){
	var self = this;
	if(self.currentMethodNav != null && typeof methodId == "undefined" && typeof limitID == "undefined"){
		return self.currentMethodNav;
	}else{
		if(limitID != null){
			var elem = this.getLimitDOMelem(methodId,limitID);
		}else{
			var elem = this.getMethodDOMelem(methodId);
		}
		var storedElem = $(elem).find('[data-payment-storage].is-active');
		if($(storedElem).length > 0){
			if($(storedElem).attr('data-payment-storage') == "stored"){
				return "stored";
			}else{
				return "default";
			}
		}else{
			if(self.currentMethodNav != null){
				return self.currentMethodNav;
			}
		}
	}

}

paymentsManager.prototype.switchToStoredMethods = function(methodId,limitID){
	//Método que:
	//Cambia la pantalla a la de métodos de pago almacenados y activa la opción de la agenda con el método favorito establecida en el objeto si no hay nada marcado de una acción previa
	var self = this;
	self.currentMethodNav = "stored";

	if(self.paymentsObj.getAutoSubmethod(methodId) && self.getNavAutoSubmethod(methodId) == "auto"){
		autoSubmethodInProgress = true;
		var elemn = this.getLimitDOMelem(methodId,"default");
	}else{
		var elemn = this.getMethodDOMelem(methodId);
	}

	if(self.storedPayments.getMethod(methodId)){
		var storedElem = $(elemn).find('[data-payment-storage="stored"]');
		var items = $(storedElem).find('tr[data-value]');

		$(elemn).find('[data-payment-storage]').removeClass('is-active');
		$(elemn).find('[data-payment-storage="stored"]').addClass('is-active');
		if(!self.paymentsObj.getAutoSubmethod(methodId)){
			self.hideSubMethods(methodId,true);
		}else{
			self.hideSubscriptionsMsg(methodId,"default");
			//self.enableActionsForMethod(methodId,"default")
		}
		self.unsetPaymentMethodsFromList(methodId);
		var currentSelection = self.storedPayments.getSelection(methodId);

		//Añadir lógica para los selectores de ForceMinAllowed
		if(currentSelection){
			self.setPurchaseButtonAvailability(self.getReadyForPurchase(methodId,currentSelection.methodId),methodId);
			self.showUsePreviousBalance(methodId,limitID);
		}else{
			self.hideForceMin(false,methodId);
			self.setPurchaseButtonAvailability(false,methodId);
			/* self.hideUsePreviousBalance(methodId,limitID); */
			self.unsetUsePreviousBalance(methodId,limitID);
			self.setFirstAvailableStoredMethod(methodId,limitID)
		}
	}
}


paymentsManager.prototype.switchToDefaultMethods = function(methodId,limitID){
	//Método que:
	//Cambia la pantalla a la de métodos de pago normales
	var self = this;
	self.currentMethodNav = "default";
	var autoSubmethodInProgress = false;
	if(self.paymentsObj.getAutoSubmethod(methodId) && self.getNavAutoSubmethod(methodId) == "auto"){
		autoSubmethodInProgress = true;
		var elemn = this.getLimitDOMelem(methodId,"default");
		var limit = "default"
	}else{
		var elemn = this.getMethodDOMelem(methodId);
		var limit = limitID
	}
	$(elemn).find('[data-payment-storage]').removeClass('is-active');
	$(elemn).find('[data-payment-storage="default"]').addClass('is-active');
	self.unsetPaymentMethodsFromList(methodId);
	if(autoSubmethodInProgress){
		self.unsetForceMinForMethod(methodId,limit,true);
		if(self.paymentsObj.getUseForceMinLimitForMethod(methodId,limit)){
			//Mostramos el selector, si no fuera necesario por los límites, la llamada a isAvalailable ya se encargará de ocultarlo
			self.showForceMin(methodId,limit);
		}
		if(self.paymentsObj.getSubscriptionsState() && !self.paymentsObj.getSubscriptionsAllowed(methodId,limitID)){
			self.showSubscriptionsMsg(methodId,limitID);
		}else{
			self.hideSubscriptionsMsg(methodId,limitID);
		}
		self.paymentsObj.isAvailable(methodId);
	}else{
		self.clearSubmethodsSelection(methodId);
		self.showSubMethods(methodId,true);
		self.showInfoArea(methodId,limit);
		if(self.getMethod(methodId).limits.length == 1){
			self.setSubmethod(methodId,self.getMethod(methodId).limits[0].id);
		}
	}

	if(self.getReadyForPurchase(methodId,limitID)){
		if(self.paymentsObj.isWithdrawal()){
			//Si es retirada, comprobamos los requerimientos de documentos
			var docStatus = self.paymentsObj.getProvidedDocumentsStatus(methodId);
			if(docStatus == null || typeof docStatus == "number" || self.getNavMethod(methodId,limitID) == "stored"){
				self.setPurchaseButtonAvailability(true,methodId,limitID);
			}else{
				self.setPurchaseButtonAvailability(false,methodId,limitID);
			}
		}
	}
	self.clearMsg(methodId,null)


}

paymentsManager.prototype.showStorageForMethod = function(methodId,limitID){
	var self = this;
	if(typeof limitID != "undefined" && limitID != null){
		var elem = this.getLimitDOMelem(methodId,limitID);
	}else{
		var elem = this.getMethodDOMelem(methodId);
	}
	var currentNavMethod = self.getNavMethod(methodId,limitID);
	$(elem).find('[data-payment-storage="'+currentNavMethod+'"]').show()//.addClass('is-active');
}
paymentsManager.prototype.hideStorageForMethod = function(methodId,limitID){
	var self = this;
	if(typeof limitID != "undefined" && limitID != null){
		var elem = this.getLimitDOMelem(methodId,limitID);
	}else{
		var elem = this.getMethodDOMelem(methodId);
	}
	$(elem).find('[data-payment-storage]').hide()//.removeClass('is-active');
}
paymentsManager.prototype.showMethod = function(methodId){
	var self = this;
	var elem = this.getMethodDOMelem(methodId);
	$(elem).removeAttr('data-isVisible');
}
paymentsManager.prototype.hideMethod = function(methodId){
	var self = this;
	var elem = this.getMethodDOMelem(methodId);
	$(elem).attr('data-isVisible',false);
}
paymentsManager.prototype.showSubMethod = function(methodId,subMethodId){
	//Función que muestra el bloque de contenido de un submétodo de pago
	var self = this;
	var method = self.getLimitDOMelem(methodId,subMethodId);
		$(method).removeAttr('data-isVisible');
}
paymentsManager.prototype.hideSubMethod = function(methodId,subMethodId){
	//Función que oculta la lista de submétodos de un método indicado
	//Si se pasa withContent == true, también se oculta todo el bloque de contenido de los submétodos
	var self = this;
	var method = self.getLimitDOMelem(methodId,subMethodId);
	$(method).attr('data-isVisible',false);
}
paymentsManager.prototype.showSubMethods = function(methodId,withContent){
	//Función que muestra la lista de submétodos de un método indicado
	//Si se pasa withContent == true, también se muestra todo el bloque de contenido de los submétodos
	var self = this;
	var method = self.getMethodDOMelem(methodId);
	$(method).find('[data-submethodstabs]').show();
	if(typeof withContent != "undefined" && withContent){
		$(method).find('[data-submethods] > [data-submethod]').removeAttr('data-isVisible');
	}
}
paymentsManager.prototype.hideSubMethods = function(methodId,withContent){
	//Función que oculta la lista de submétodos de un método indicado
	//Si se pasa withContent == true, también se oculta todo el bloque de contenido de los submétodos
	var self = this;
	var method = self.getMethodDOMelem(methodId);
	$(method).find('[data-submethodstabs]').hide();
	$(method).find('[data-payment-navigation]').removeClass('is-active');
	if(typeof withContent != "undefined" && withContent){
		$(method).find('[data-submethods] > [data-submethod]').attr('data-isVisible',false);
	}
}

paymentsManager.prototype.setPaymentMethodFromList = function(id,methodId,limitID,launchChangeEvent){
	//Método que:
	//Busca en el DOM un elemento de la agenda, y lo marca como activo
	//launchChangeEvent: si es true, no sólo marca el método de pago, además lanza el evento change del input
	var self = this;
	if(typeof limitID != "undefined" && limitID != null){
		var elem = this.getLimitDOMelem(methodId,limitID);
	}else{
		var elem = this.getMethodDOMelem(methodId);
	}

	$(elem).find(self.storedMethodsListSelector).find('[data-value="'+id+'"]:not(.disabled) label').addClass('is-active').find('input[data-paymentMethodSelector]:not([disabled])').prop('checked',true);
	self.storedPayments.setSelection(id,methodId);
	if(typeof launchChangeEvent != "undefined" && launchChangeEvent === true){
		$(elem).find(self.storedMethodsListSelector).find('[data-value="'+id+'"]:not(.disabled) label').find('input[data-paymentMethodSelector]:not([disabled])').trigger("change");
	}else{
		if(typeof self.storedPayments.storedPaymentsObj != "undefined"){
			if(self.storedPayments.cvvRequired(id,methodId,limitID)){
				self.showRequiredFields(methodId,limitID);
			}else{
				self.hideRequiredFields(methodId,limitID);
			}
		}
	}

}
paymentsManager.prototype.unsetPaymentMethodsFromList = function(methodId,limitID){
	//Método que:
	//Busca en el DOM los elementos de la agenda, y los desmarca como activo para el método y submétodo indicados

	var self = this;
	if(typeof limitID != "undefined" && limitID != null){
		var elem = this.getLimitDOMelem(methodId,limitID);
		/* self.hideUsePreviousBalance(methodId,limitID) */
		self.unsetUsePreviousBalance(methodId,limitID);
	}else{
		var elem = this.getMethodDOMelem(methodId);
/* 		self.hideUsePreviousBalance(methodId)
 */		self.unsetUsePreviousBalance(methodId,limitID);

	}
	self.hideRequiredFields(methodId);
	self.storedPayments.resetSelection(methodId,limitID);
	if(self.paymentsObj.getAutoSubmethod(methodId) && self.getNavAutoSubmethod() == "auto" && self.getNavMethod("stored")){
		self.setPurchaseButtonAvailability(false,methodId,"default");
	}else if(!self.paymentsObj.getAutoSubmethod(methodId) && self.getNavMethod("stored")){
		self.setPurchaseButtonAvailability(false,methodId,null);
	}
	$(elem).find(self.storedMethodsListSelector).find('[data-value] label').removeClass('is-active').find('input').prop('checked',false);
}
paymentsManager.prototype.getSavingForLaterStatus = function(methodId,limitID){
	//Método que:
	//Obtiene el estado del CHECK de "guardar para más tarde"

	var self = this;
	var domElem = self.getLimitDOMelem(methodId,limitID);
	var savingForLaterElem = $(domElem).find('[data-payment-storage-add] input');
	if($(savingForLaterElem).length > 0){
		return $(savingForLaterElem).prop('checked');
	}

	return false;
}
paymentsManager.prototype.setPurchaseButtonAvailability = function(state,methodId,limitID,setOnInactiveItems){
	var self = this;
	var onInactive = false;
	if(typeof limitID != "undefined" && limitID != null){
		var elem = self.getLimitDOMelem(methodId,limitID);
		var activePaymentFormBt = $(elem).find('form[data-payment-storage] [data-submit-payment]');
	}else{
		var elem = self.getMethodDOMelem(methodId);
		var activePaymentFormBt = $(elem).find('form[data-payment-storage].is-active [data-submit-payment]');

	}
/* 	var activePaymentFormBt = $(elem).find('form[data-payment-storage].is-active [data-submit-payment]');
 */

	if(state){
		$(activePaymentFormBt).removeAttr('disabled');
		self.setReadyForPurchase(true,methodId,limitID);
	}else{
		$(activePaymentFormBt).attr('disabled','');
		self.setReadyForPurchase(false,methodId,limitID);
	}
}
paymentsManager.prototype.setLimitsBadgeStatus = function(state,elemIndex,methodId){
	//Método que:
	//Activa o desactiva la animación en los límites. Sirve, por ejemplo, para que parpadee el indicador de límite minimo cuando occure algo con él.
	//Hay que indicar en elemIndex el índice del elemento, si hay 3 <dd> y queremos activar el segundo, elemIndex sería 1.
	//elemIndex tambien puede ser un array, para cambiar varios valores

	var self = this;
	var limit = self.getMethodDOMelem(methodId);

	if(Array.isArray(elemIndex) ){
		$(elemIndex).each(function(k,v){
			var elem = $(limit).find("[data-limits] dd").eq(v);
			if(state === true){
				$(elem).addClass('is-active');
			}else{
				$(elem).removeClass('is-active');
			}
		})
	}else{
		var elem = $(limit).find("[data-limits] dd").eq(elemIndex);
		if(state === true){
			$(elem).addClass('is-active');
		}else{
			$(elem).removeClass('is-active');
		}
	}

}
paymentsManager.prototype.setForceMinForMethod_legacy = function(methodId,limitID){
	//Método que:
	//Establece que se pueda operar cuando no se llega al límite mínimo
	var self = this;
	if(self.getForceMinAllowed(methodId,limitID)){
		if(!self.paymentsObj.isWithdrawal()){
			self.setPurchaseButtonAvailability(true,methodId,limitID);
			if(self.storedPayments.getMethod(methodId) && !self.paymentsObj.getAutoSubmethod(methodId)){
				//Sincronizamos el botón de acción de la agenda común
				//self.setPurchaseButtonAvailability(true,methodId);
			}
		}else{
			//Si es retirada, comprobamos los requerimientos de documentos
/* 			var docStatus = self.paymentsObj.getProvidedDocumentsStatus(methodId);
			if(docStatus == null || typeof docStatus == "number" || self.getNavMethod(methodId,limitID) == "stored"){
				self.setPurchaseButtonAvailability(true,methodId,limitID);
				if(self.storedPayments.getMethod(methodId) && !self.paymentsObj.getAutoSubmethod(methodId)){
					//Sincronizamos el botón de acción de la agenda común
					self.setPurchaseButtonAvailability(true,methodId);
				}
			}else{
				self.setPurchaseButtonAvailability(false,methodId,limitID);
				if(self.storedPayments.getMethod(methodId) && !self.paymentsObj.getAutoSubmethod(methodId)){
					//Sincronizamos el botón de acción de la agenda común
					self.setPurchaseButtonAvailability(false,methodId);
				}
			} */
		}
	}
	self.paymentsObj.setUseForceMinLimit(true);
	self.enableActionsForMethod(methodId,limitID);

	//Comprobamos si esta activo el selector de saldo mínimo para el método indicado, para no mostrar el total de operación donde no se deba
	if(self.storedPayments.getMethod(methodId) && !self.paymentsObj.getAutoSubmethod(methodId) && self.getNavMethod(methodId,limitID) == "stored"){
		var selected = self.storedPayments.getSelection(methodId);
		var subm = selected.methodId;
		if(selected){
			var limitMin = self.getLimit(methodId,subm).minLimit;
			if(self.getForceMinAllowed(methodId,limitID)){//if($(elem).find('[data-forcemin-area].is-active').length > 0){
				self.setReadyForPurchase(true,methodId,subm); //Como setPurchasButtonAvailabilty afecta globalmente, forzamos esto para que se aplique al método almacenado seleccionado
				var importeAPager = self.getAmountWithFeesForMethod(limitMin,methodId,limitID);
				self.setTotalOperationForMethod(importeAPager,methodId,limitID);
				self.showTotalOperation(methodId,limitID);
			}
		}
	}else{

/* 		var limitMin = self.getLimit(methodId,limitID).minLimit;
 */		//var elem = self.getLimitDOMelem(methodId,limitID);
		if(self.getForceMinAllowed(methodId,limitID)){//if($(elem).find('[data-forcemin-area].is-active').length > 0){

			if(self.storedPayments.getMethod(methodId) && self.paymentsObj.getAutoSubmethod(methodId) && self.getNavMethod(methodId,limitID) == "stored"){
				var selected = self.storedPayments.getSelection(methodId);
				var subm = selected.methodId;
				self.setReadyForPurchase(true,methodId,subm);//Como setPurchasButtonAvailabilty afecta globalmente, forzamos esto para que se aplique al método almacenado seleccionado
				var limitMin = self.getLimit(methodId,subm).minLimit;
			}else{
				var subm = limitID;
				var limitMin = self.getLimit(methodId,limitID).minLimit;
			}
			var importeAPager = self.getAmountWithFeesForMethod(limitMin,methodId,subm);
			self.setTotalOperationForMethod(importeAPager,methodId,limitID);
			self.showTotalOperation(methodId,limitID);
		}
	}


}
paymentsManager.prototype.setForceMinForMethod = function(methodId,limitID){
	//Método que:
	//Establece que se pueda operar cuando no se llega al límite mínimo
	var self = this;
		if(!self.paymentsObj.isWithdrawal()){
			self.setPurchaseButtonAvailability(true,methodId,limitID);
		}
	self.paymentsObj.setUseForceMinLimit(true);
	self.enableActionsForMethod(methodId,limitID);
	//Comprobamos si esta activo el selector de saldo mínimo para el método indicado, para no mostrar el total de operación donde no se deba
	if(self.storedPayments.getMethod(methodId) && !self.paymentsObj.getAutoSubmethod(methodId) && self.getNavMethod(methodId,limitID) == "stored"){
		var selected = self.storedPayments.getSelection(methodId);
		var subm = selected.methodId;
		if(selected){
			var limitMin = self.getLimit(methodId,subm).minLimit;
			var importeAPager = self.getAmountWithFeesForMethod(limitMin,methodId,limitID);
			self.setReadyForPurchase(true,methodId,subm);
			self.setTotalOperationForMethod(importeAPager,methodId,limitID);
			self.showTotalOperation(methodId,limitID);
		}
	}else{
		if(self.storedPayments.getMethod(methodId) && self.paymentsObj.getAutoSubmethod(methodId) && self.getNavMethod(methodId,limitID) == "stored"){
			var selected = self.storedPayments.getSelection(methodId);
			var subm = selected.methodId;
			var limitMin = self.getLimit(methodId,subm).minLimit;
			self.setReadyForPurchase(true,methodId,subm);
			if(selected){
				var importeAPager = self.getAmountWithFeesForMethod(limitMin,methodId,subm);
				self.setTotalOperationForMethod(importeAPager,methodId,limitID);
				self.showTotalOperation(methodId,limitID);
			}
		}else{
			var subm = limitID;
			var limitMin = self.getLimit(methodId,limitID).minLimit;
			self.setReadyForPurchase(true,methodId,subm);

			var importeAPager = self.getAmountWithFeesForMethod(limitMin,methodId,subm);
			self.setTotalOperationForMethod(importeAPager,methodId,limitID);
			self.showTotalOperation(methodId,limitID);
		}

	}
}

paymentsManager.prototype.unsetForceMinForMethod_legacy = function(methodId,limitID,enableVisuals){
	//Método que:
	//Desactiva que se pueda operar cuando no se llega al límite mínimo
	//Si enableVisuals está a true, se busca el input y se desmarca
	var self = this;
	var subm = limitID;

	if(self.getForceMinAllowed(methodId,limitID)){
		self.setPurchaseButtonAvailability(false,methodId,limitID);
		if(self.storedPayments.getMethod(methodId) && self.getNavMethod(methodId,limitID) == "stored"){
			//Sincronizamos el botón de acción de la agenda común
			//--- self.setPurchaseButtonAvailability(false,methodId,limitID);
			var selected = self.storedPayments.getSelection(methodId);
			var subm = selected.methodId;

			if(!self.paymentsObj.getAutoSubmethod(methodId)){
				if(selected){
					self.setReadyForPurchase(false,methodId,subm);
				}
			}
		}
	}
	self.hideTotalOperation(methodId,limitID);
	var importeAPager = self.getAmountWithFeesForMethod(self.paymentsObj.getAmount(),methodId,subm);
	self.setTotalOperationForMethod(importeAPager,methodId,limitID);
	self.paymentsObj.setUseForceMinLimit(false);
	if(typeof enableVisuals != "undefined" && enableVisuals){
		if(limitID != null && limitID){
			var elem = self.getLimitDOMelem(methodId,limitID);
			var bt = $(elem).find('[data-forcemin]');
		}else{
			var elem = self.getMethodDOMelem(methodId);
			var bt = $(elem).find('[data-forcemin]')[0];
		}
		$(bt).prop('checked',false).closest('label').removeClass('is-active');
	}
}
paymentsManager.prototype.unsetForceMinForMethod = function(methodId,limitID,enableVisuals){
	//Método que:
	//Desactiva que se pueda operar cuando no se llega al límite mínimo
	//Si enableVisuals está a true, se busca el input y se desmarca
	var self = this;
	var subm = limitID;

		self.setPurchaseButtonAvailability(false,methodId,limitID);
		if(self.storedPayments.getMethod(methodId) && self.getNavMethod(methodId,limitID) == "stored"){
			//Sincronizamos el botón de acción de la agenda común
			//--- self.setPurchaseButtonAvailability(false,methodId,limitID);
			var selected = self.storedPayments.getSelection(methodId);
			var subm = selected.methodId;

			if(!self.paymentsObj.getAutoSubmethod(methodId)){
				if(selected){
					self.setReadyForPurchase(false,methodId,subm);
				}
			}
		}
	self.hideTotalOperation(methodId,limitID);
	var importeAPager = self.getAmountWithFeesForMethod(self.paymentsObj.getAmount(),methodId,subm);
	self.setTotalOperationForMethod(importeAPager,methodId,limitID);
	self.paymentsObj.setUseForceMinLimit(false);
	if(typeof enableVisuals != "undefined" && enableVisuals){
		if(limitID != null && limitID){
			var elem = self.getLimitDOMelem(methodId,limitID);
			var bt = $(elem).find('[data-forcemin]');
		}else{
			var elem = self.getMethodDOMelem(methodId);
			var bt = $(elem).find('[data-forcemin]')[0];
		}
		$(bt).prop('checked',false).closest('label').removeClass('is-active');
	}
}
paymentsManager.prototype.showInfoArea = function(methodId,limitID){
	var elem = this.getLimitDOMelem(methodId,limitID);
	$(elem).find('[data-info-area]').addClass('is-active');
}
paymentsManager.prototype.hideInfoArea = function(methodId,limitID){
	var elem = this.getLimitDOMelem(methodId,limitID);
	$(elem).find('[data-info-area]').removeClass('is-active');
}
paymentsManager.prototype.showForceMin = function(methodId,limitID){
	if(limitID != null){
		var elem = $(this.getLimitDOMelem(methodId,limitID)).find('[data-forcemin-area]');
	}else{
		var elem = this.getMethodDOMelem(methodId).find('[data-forcemin-area]')[0];
	}
	$(elem).addClass('is-active');
}
paymentsManager.prototype.hideForceMin = function(methodId,limitID){
	if(limitID != null){
		var elem = $(this.getLimitDOMelem(methodId,limitID)).find('[data-forcemin-area]');
	}else{
		var elem = this.getMethodDOMelem(methodId).find('[data-forcemin-area]')[0];
	}
	$(elem).removeClass('is-active')
}
paymentsManager.prototype.showDocuments = function(status,methodId,limitID){
	if(limitID != null){
		var elem = $(this.getLimitDOMelem(methodId,limitID)).find('[data-payment-storage-validation]');
	}else{
		var elem = $(this.getMethodDOMelem(methodId)).find('[data-payment-storage-validation]')[0];
	}
	if(status){
		$(elem).addClass('is-active')
	}else{
		$(elem).removeClass('is-active')
	}
}

paymentsManager.prototype.getForceMinAllowed_legacy = function(methodId,limitID){
	//Devuelve si el método tiene opción para forzar compra por debajo del límite
	if(limitID != null && limitID != false){
		var elem = this.getLimitDOMelem(methodId,limitID);
		if($(elem).find('[data-forcemin-area]').hasClass('is-active')){
			return true;
		}
	}else{
		var elem = this.getMethodDOMelem(methodId);
		if($($(elem).find('[data-forcemin-area]')[0]).hasClass('is-active')){
			return true;
		}
	}

	return false;
}
paymentsManager.prototype.getForceMinAllowed = function(methodId,limitID){
	return true;
}

paymentsManager.prototype.getForceMinStatus_legacy = function(methodId,limitID){
	//Devuelve si el usuario ha activada o desactivada la compra por debajo del límite
	if(this.getForceMinAllowed(methodId,limitID)){
		if(limitID != null && limitID != false){
			var elem = this.getLimitDOMelem(methodId,limitID);
			elem = $(elem).find('[data-forcemin]');
		}else{
			var elem = this.getMethodDOMelem(methodId);
			elem = $(elem).find('[data-forcemin]')[0];
		}
		if($(elem).prop('checked')){
			return true;
		}else{
			return false;
		}
	}
	return false;
}
paymentsManager.prototype.getForceMinStatus = function(methodId,limitID){
	//Devuelve si el usuario ha activada o desactivada la compra por debajo del límite
	return true;
}
paymentsManager.prototype.performPayFromStorage = function(methodId,limitID){
	//Método que:
	//Parsea los elementos del formulario de la interfaz para pagos a través de la agenda, y los pasa al objeto de compras conforme a un protocolo


	//Obtenemos método seleccionado
	var self = this;

	if(!self.getReadyForPurchase(methodId,limitID)){
		return false;
	}

	var selectedId = self.storedPayments.getSelection(methodId,limitID).id;
	var formElem  = self.getMethodDOMelem(methodId).find('form[data-payment-storage="stored"]');
	var valuesArray = {};

/* 	if(self.getForceMinStatus(methodId,limitID)){
		self.paymentsObj.setUseForceMinLimit(true);
	}else{
		self.paymentsObj.setUseForceMinLimit(false);
	}
 */
	$(formElem).find('[data-payment-field]:visible').each(function(k,v){
		var fieldKey = $(v).attr('data-payment-field')
		var fieldValue = $(v).val();
		valuesArray[fieldKey] = fieldValue;
		/* valuesArray.push($(v).val()); */
	})
	if(valuesArray.length == 0){
		valuesArray = null;
	}
	//Aunque esté establecido el uso del saldo existente, si el método de pago seleccionado no lo soporta por límites, lo reevaluamos.
	var usePrevBalance = false;
	var method = self.getMethod(methodId);
	var limit = self.getLimit(methodId,limitID);

	if(self.paymentsObj.isUsingPreviousBalance() && self.paymentsObj.canUseVirtualCash(method,limit)){
		usePrevBalance = true;
	}

	var paymentProtocol = {
			amount:self.paymentsObj.getCurrentAmount(),
			method:methodId,
			submethod:limitID,
			usePreviousBalance: usePrevBalance,
			forceMinLimit: self.paymentsObj.isUsingForceMinLimit(),
			isShoppingCart:self.paymentsObj.isShoppingCart(),
			storedValueID:self.storedPayments.getSelection(methodId,limitID).id,
			customValues: valuesArray,
			saveInAgenda: false,
	}
	//Si autosubmetodo es auto, enviamos sólo el submétodo
	//Si autosubmetodo es auto, enviamos sólo el submétodo
	if(self.paymentsObj.getAutoSubmethod(methodId)){
		if(limit.id == "default"){
			paymentProtocol["uid"] = method.uid;
		}else{
			paymentProtocol["uid"] = limit.uid;
		}
	}else{
		paymentProtocol["uid"] = limit.uid;
	}
	self.paymentsObj.performPay(methodId,limitID,paymentProtocol,$(formElem),function(){
		self.unblockAllMethods(false);
	});
	self.blockAllMethods(false);
	self.unblockMethod(methodId,false);
}
paymentsManager.prototype.performPayFromDefault = function(methodId,limitID){
	//Método que:
	//Parsea los elementos del formulario de la interfaz para pagos normales, y los pasa al objeto de compras conforme a un protocolo


	//Obtenemos método seleccionado
	var self = this;
	var forFunding = self.paymentsObj.isForFundingOnly(methodId)
	var amount = self.paymentsObj.getCurrentAmount();

/* 	if(!self.paymentsObj.isShoppingCart() || (self.paymentsObj.isShoppingCart() && !self.paymentsObj.isForFundingOnly())){ //Si es un pago instantáneo, seguimos evaluando. Si no lo es, ignoramos validaciones y le hacemos continuar.
		if(!self.getReadyForPurchase(methodId)){
			return false;
		}
		limitID = null;
		var formElem = self.getMethodDOMelem(methodId).find('form[data-payment-storage="default"]');
	}else{ */
	if(forFunding && self.paymentsObj.isShoppingCart()){
		//Si es sólo para añadir fondos, redirigimos, si no, continuamos con el pago
		var url = forFunding;
		var pathParams = "method="+methodId+"&amount=" + amount;
		var paramPos = url.indexOf("?");
		var hashPos = url.indexOf("#");
		var hashString = "";
		if(hashPos != -1){
			var hashString = url.substring(hashPos, url.length);
			var url = url.substring(0,hashPos);
		}
		if(paramPos == -1){
			pathParams = "?" + pathParams;
		}else{
			pathParams = "&" + pathParams;
		}
		url = url + pathParams + hashString;
		window.location.href=url;
	}


	if(!self.getReadyForPurchase(methodId,limitID) ){
		return false;
	}

		var formElem = $(self.getLimitDOMelem(methodId,limitID)).find('form[data-payment-storage="default"]');
/* 	}
 */

	var valuesArray = {};

	if(self.getForceMinStatus(methodId,limitID)){
		self.paymentsObj.setUseForceMinLimit(true);
	}else{
		self.paymentsObj.setUseForceMinLimit(false);
	}

	$(formElem).find('[data-payment-field]').each(function(k,v){
		var fieldKey = $(v).attr('data-payment-field')
		var fieldValue = $(v).val();
		valuesArray[fieldKey] = fieldValue;
		/* valuesArray.push($(v).val()); */
	})

	var saveInAgendaStatus = false;
	if(!self.paymentsObj.isWithdrawal()){ //Si es withdrawal, siempre lo almacenamos por el tema de la validación de documentos
										//Ademas obtenemos el token del fichero enviado para la validación.
		saveInAgendaStatus = self.getSavingForLaterStatus(methodId,limitID);
	}else{
		saveInAgendaStatus = true;
		var uploadToken = self.paymentsObj.getProvidedDocumentsStatus(methodId);
	}

	//Aunque esté establecido el uso del saldo existente, si el método de pago seleccionado no lo soporta por límites, lo reevaluamos.
	var usePrevBalance = false;
	var method = self.getMethod(methodId);
	var limit = self.getLimit(methodId,limitID);

	if(self.paymentsObj.isUsingPreviousBalance() && self.paymentsObj.canUseVirtualCash(method,limit)){
		usePrevBalance = true;
	}

	var paymentProtocol = {
			amount:amount,
			method:methodId,
			submethod:limitID,
			usePreviousBalance: usePrevBalance,
			forceMinLimit: self.paymentsObj.isUsingForceMinLimit(),
			isShoppingCart:self.paymentsObj.isShoppingCart(),
			storedValueID:null,
			customValues: valuesArray,
			saveInAgenda: saveInAgendaStatus
	}
	//Si autosubmetodo es auto, enviamos sólo el submétodo
	if(self.paymentsObj.getAutoSubmethod(methodId)){
		if(limit.id == "default"){
			paymentProtocol["uid"] = method.uid;
		}else{
			paymentProtocol["uid"] = limit.uid;
		}
	}else{
		paymentProtocol["uid"] = limit.uid;
	}
	if(typeof uploadToken != "undefined" && uploadToken != null){	//Si existe token de subida de documento, se adjunta
		paymentProtocol["uploadToken"] = uploadToken;
	}


	if(!forFunding || forFunding && !self.paymentsObj.isShoppingCart()){
		self.paymentsObj.performPay(methodId,limitID,paymentProtocol,$(formElem),function(){
			self.unblockAllMethods(false);
		});
		self.blockAllMethods(false);
		self.unblockMethod(methodId,false);
	}
}
paymentsManager.prototype.setPaymentAdditionalFields = function(additionalFieldsObj){
	//Método que:
	//Permite añadir un array de valores adicionales externos que se pasarán al método de pago.
	//additionalFieldsObj = {
	//	"miCampo1":4,
	//	"foo":"bar",
	//	"blabal":"blbele"
	//}
	var self = this;
	self.paymentsObj.setPaymentAdditionalFields(additionalFieldsObj);
}
paymentsManager.prototype.setReadyForPurchase = function(state,methodId,limitID){
	var self = this;
	if(typeof self.readyForPurchase[methodId] != "undefined"){
		if(self.readyForPurchase[methodId] != null){
			var limitIndex = false;
			if(limitID != null){
				limitIndex = self.readyForPurchase[methodId].indexOf(limitID);
				if (limitIndex != -1){
					if(state === false){
						self.readyForPurchase[methodId].splice(limitIndex,1);
						if(self.readyForPurchase[methodId].length == 0){
							delete self.readyForPurchase[methodId];
						}
					}
				}else{
					if(state === true){
						self.readyForPurchase[methodId].push(limitID);
					}
				}
			}
		}else{
			if (state === false){
				delete self.readyForPurchase[methodId];
			}
		}
	}else{
		if(state === true){
			if(typeof limitID != "undefined" && limitID != null){
				self.readyForPurchase[methodId] = [limitID];
			}else{
				self.readyForPurchase[methodId] = null;
			}
		}
	}
}
paymentsManager.prototype.getReadyForPurchase = function(methodId,limitID){
	var self = this;
	if(typeof self.readyForPurchase[methodId] != "undefined"){
		if(self.readyForPurchase[methodId] != null){
			if(limitID != null){
				if(self.readyForPurchase[methodId].indexOf(limitID) != -1){
					return true;
				}else{
					return false;
				}
			}else{
				//Si no hay límite, se evaluan todos los submétodos si los hubiera
				//console.log(self.readyForPurchase);
				var expected = self.getMethod(methodId).limits.length;
				if(self.readyForPurchase[methodId].length != expected){
					return false;
				}else{
					return true;
				}
			}

		}else{
			return true;
		}
	}
	return false;
}
paymentsManager.prototype.getPaymentInProgressElems = function(){
	//Método que:
	//Si se está realizando un pago en este momento, devuelve un objeto que tiene method y submethod, indicando cuales son los métodos que se están procesando
	//en ese momento. Existe durante la ejecución del callback del forme de performPay de paymentsObj. Antes o después valdrá false
	return self.paymentsObj.getPaymentInProgressElems();

}
paymentsManager.prototype.setDocumentStatus = function(status,methodId,limitID){
	var self = this;

	if (typeof limitID != "undefined" && limitID){
		var docBoxElem = self.getLimitDOMelem(methodId,limitID)
	}else{
		var docBoxElem = self.getMethodDOMelem(methodId)
	}

	var docValElem = $(docBoxElem).find('[data-payment-storage-validation] [data-payment-storage-request]')
	switch(status){
		case true:
			$(docValElem).attr('data-status',1).html(self.documentsObj.strings.waitingForApproval);
		break;
		case "init":
			$(docValElem).attr('data-status',0).html(self.documentsObj.strings.send);
		break;
		default:
			$(docValElem).attr('data-status',0).html(self.documentsObj.strings.waitingForApproval);
		break;
	}
}
paymentsManager.prototype.setNewDocumentRequirement = function(documentId,methodId){

	//Función que establece un nuevo requerimiento de documento para un método indicado

	var self = this;
	self.paymentsObj.setNewDocumentRequirement(documentId,methodId);
	var methodDOM = self.getMethodDOMelem(methodId);
	$(methodDOM).find('[data-payment-storage-validation]').addClass('is-active');
	self.refresh();
}
paymentsManager.prototype.removeDocumentRequirement = function(methodId){

	//Función que elimina el requerimiento de un documento para un método indicado

	var self = this;
	self.paymentsObj.removeDocumentRequirement(methodId);
	var methodDOM = self.getMethodDOMelem(methodId);
	$(methodDOM).find('[data-payment-storage-validation]').removeClass('is-active');
	self.refresh();
}
paymentsManager.prototype.isValidationMode = function(){
	var self = this;

	if(self.paymentsObj.isValidationMode()){
		return self.paymentsObj.isValidationMode();
	}else{
		return false;
	}
}
paymentsManager.prototype.isDebug = function(){
	return this.paymentsObj.isDebug();
}

/* paymentsManager.prototype.getStorageSelectedDOM = function(methodId,limitID){
	var self = this;
	var elem = self.getLimitDOMelem(methodId,limitID);
		var domElem = $(elem).find(self.storedMethodsListSelector).find("[data-value='" + selectedId + "'");
		if($(domElem).length > 0){
			return domElem;
		}
	}
	return false;

} */
paymentsManager.prototype.setNavElemStatus = function(state,methodId,subMethodId){
	//Añade un estado a los tabs de los submetodos
	//0: error
	//2: warning
	//null: elimina estados previos
	var self = this;
	var elem = self.getMethodDOMelem(methodId);
	var item = $(elem).find('[data-submethodstabs] [data-submethod="' + subMethodId + '"]').closest('label');
	if(state != null){
		$(item).attr('data-status',state);
	}else{
		$(item).removeAttr('data-status');
	}
	return false;
}

paymentsManager.prototype.showRequiredFields = function(methodId,subMethodId){
	//Muestra y habilita la validación del bloque de campos adicionales requeridos (CVV) para los métodos stored
	var self = this;
	if(self.paymentsObj.getAutoSubmethod(methodId) && self.getNavAutoSubmethod() == "auto" && self.getNavMethod() == "stored" &&  self.storedPayments.getPaymentsObj().length > 0){
		var selected  = self.storedPayments.getSelection(methodId);
		var submethod = selected.methodId;
		if(subMethodId == submethod){
			var elem = self.getLimitDOMelem(methodId,"default");
		}
	}else{
		if(typeof subMethodId != "undefined" && subMethodId != null){
			var elem = self.getLimitDOMelem(methodId,subMethodId);
		}else{
			var elem = self.getMethodDOMelem(methodId);
		}
	}

	$(elem).find('[data-payment-stored-required]').addClass('is-visible');
	$(elem).find('[data-payment-stored-required] [required]').removeAttr('data-abide-ignore');

}
paymentsManager.prototype.hideRequiredFields = function(methodId,subMethodId){
	//Oculta y deshabilita la validación del bloque de campos adicionales requeridos (CVV) para los métodos stored
	//Muestra y habilita la validación del bloque de campos adicionales requeridos (CVV) para los métodos stored
	var self = this;
/* 	if(self.paymentsObj.getAutoSubmethod(methodId) && self.getNavAutoSubmethod() == "auto" && self.getNavMethod() == "stored" &&  self.storedPayments.getPaymentsObj().length > 0){
		var selected  = self.storedPayments.getSelection(methodId);
		var submethod = selected.methodId;
		if(subMethodId == submethod){
			var elem = self.getLimitDOMelem(methodId,"default");
		}
	}else{
		var elem = self.getLimitDOMelem(methodId,subMethodId);
	} */
	if(typeof subMethodId != "undefined" && subMethodId != null){
		var elem = self.getLimitDOMelem(methodId,subMethodId);
	}else{
		var elem = self.getMethodDOMelem(methodId);
	}
	$(elem).find('[data-payment-stored-required]').removeClass('is-visible');
	$(elem).find('[data-payment-stored-required] [required]').attr('data-abide-ignore','');
}


paymentsManager.prototype.setStorageElemStatus = function(state,affectedSubmethods,methodId,submethod){
	//Añade un estado a los elementos de la agenda
	//0: error
	//2: warning
	//null: elimina estados previos

	var self = this;
	if(typeof submethod != "undefined" && submethod != null){
		var elem = self.getLimitDOMelem(methodId,submethod);
	}else{
		var elem = self.getMethodDOMelem(methodId);
	}

	$(self.storedPayments.getMethod(methodId).storedValues).each(function(k,v){
		if(v.methodId == affectedSubmethods){
			var item = 	$(elem).find(self.storedMethodsListSelector).find('[data-value="' + v.id + '"]');
			$(item).attr('data-status',state);
		}
	})
	return false;
}

function on_methodNotAvailable_functions(methodID,limitID,paymentsManagerObj,options){
/* 	console.log('not available',limitID) */
	var strings = {
		unavailableMethodTitle:	"{t}Método de pago no disponible{/t}",
		unavailableMethodMsg:	"<p>{t}Este método de pago no está disponible para los items de tu compra actual{/t}</p>",
	}

	if(typeof options != "undefined"){
		if(typeof options.strings != "undefined"){
			if(typeof options.strings.unavailableMethodTitle != "undefined") 	{ strings.unavailableMethodTitle = options.strings.unavailableMethodTitle }
			if(typeof options.strings.unavailableMethodMsg != "undefined") 	{ strings.unavailableMethodMsg = options.strings.unavailableMethodMsg }
		}
	}

	var elem = paymentsManagerObj.getMethodDOMelem(methodID);
	if(!paymentsManagerObj.storedPayments.getMethod(methodID) && paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
		paymentsManagerObj.clearMsg(methodID,null)
	}
	if(!paymentsManagerObj.paymentsObj.isWithdrawal()){
		paymentsManagerObj.setMsg(methodID,limitID,strings.unavailableMethodTitle,strings.unavailableMethodMsg)
		paymentsManagerObj.hideTotalOperation(methodID,limitID);
		paymentsManagerObj.hideForceMin(methodID,limitID);
		paymentsManagerObj.disableActionsForMethod(methodID,limitID);
		paymentsManagerObj.hideRequiredFields(methodID,limitID);
		paymentsManagerObj.setNavElemStatus(0,methodID,limitID);
		paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,limitID);
		paymentsManagerObj.setStorageElemStatus(0,limitID,methodID);

		if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
			paymentsManagerObj.setStorageElemStatus(0,limitID,methodID,"default");
			if(paymentsManagerObj.getNavAutoSubmethod(methodID) == "auto"){
				if(paymentsManagerObj.getNavMethod(methodID) == "stored"){
					var selected  = paymentsManagerObj.storedPayments.getSelection(methodID);
					var submethod = selected.methodId;
					if(limitID == submethod){
						paymentsManagerObj.setMsg(methodID,"default",strings.unavailableMethodTitle,strings.unavailableMethodTitleMsg);
						paymentsManagerObj.hideForceMin(methodID,"default");
						paymentsManagerObj.hideTotalOperation(methodID,"default");
						paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,"default")
						paymentsManagerObj.hideRequiredFields(methodID,"default");

					}
				}else if(paymentsManagerObj.getNavMethod(methodID) == "default"){
					var defaultIndexItem = paymentsManagerObj.paymentsObj.getSubmethodIndex(methodID,"default");
					if(!paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID)[defaultIndexItem]){
						if(paymentsManagerObj.storedPayments.getMethod(methodID)){
							paymentsManagerObj.allowNavOnlyActionsForMethod(methodID,"default")
						}
					}else{
						paymentsManagerObj.enableActionsForMethod(methodID,"default");
					}
				}
			}
		}
	}else{
		paymentsManagerObj.disableActionsForMethod(methodID,limitID);
		if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
			var navMethod = paymentsManagerObj.getNavMethod(methodID);
			if(paymentsManagerObj.storedPayments.getMethod(methodID) && navMethod == "stored"){
				var lim = "default"
				var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
				if(selected && selected.methodId == limitID){
					paymentsManagerObj.hideRequiredFields(methodID)
				}else{
					selected = false;
				}
				paymentsManagerObj.clearMsg(methodID,lim)

			}else{
				var lim = limitID;
			}

		}else{
			var navMethod = paymentsManagerObj.getNavMethod(methodID);
			paymentsManagerObj.clearMsg(methodID,null);

			if(paymentsManagerObj.storedPayments.getMethod(methodID) && navMethod == "stored"){
				var lim = null;
				var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
				if(selected && selected.methodId == limitID){
					paymentsManagerObj.hideRequiredFields(methodID)
				}else{
					selected = false;
				}
			}else{
				var lim = limitID;
			}

		}
		paymentsManagerObj.showDocuments(false,methodID,lim);

		if(!paymentsManagerObj.storedPayments.getMethod(methodID) || navMethod != "stored" || selected){
			paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,lim);
			paymentsManagerObj.setMsg(methodID,lim,strings.unavailableMethodTitle,strings.unavailableMethodMsg);
			paymentsManagerObj.setReadyForPurchase(false,methodID,lim)
		}

		if(paymentsManagerObj.storedPayments.getMethod(methodID)){
			paymentsManagerObj.setStorageElemStatus(0,limitID,methodID,lim);
			if(navMethod != "stored"){
				paymentsManagerObj.allowNavOnlyActionsForMethod(methodID,lim);
			}
		}else{
			paymentsManagerObj.disableActionsForMethod(methodID,lim)

		}
		paymentsManagerObj.setNavElemStatus(0,methodID,lim);
		paymentsManagerObj.hideInfoArea(methodID,lim)
	}
	//Escenarios:
	//Tanto si es autosubmétodo como si no, evaluamos la viabilidad global del método,
	//ya que si no es viable se deshabilitan todas las acciones en todos los casos.

	var method = paymentsManagerObj.getMethod(methodID);
	var submethods = JSON.parse(JSON.stringify(method.limits));
	var submethodsCount = 0;
	var expectedMethods = 0;
	//Como la viabilidad se evalua por submetódo tenemos que saber cuando se han evaluado todos
	//excepto "default" si es autosubmétodo. No lo tenemos en cuenta.
	expectedMethods = method.limits.length;
	submethodsCount = paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID).length;
	if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
		//Si es autosubmétodo, ignoramos el caso default
		if(paymentsManagerObj.getNavAutoSubmethod() != "manual" && paymentsManagerObj.getNavMethod(methodID,limitID) != "default"){
			expectedMethods = expectedMethods - 1;
			submethodsCount = submethodsCount - 1;
		}
	}
	//Si el número de submétodos evaluados coincide con el número de submétodos, es que hemos terminado de evaluarlos
	//todos. Realizamos las acciones pertinentes que afecten a todos los submétodos.
	if(expectedMethods == submethodsCount){
		//Si es autosubmétodo excluimos el caso default, para ignorar su estado en getDetailedAvailability()
		var defaultIndex = null;
		if(paymentsManagerObj.getNavAutoSubmethod() != "manual" && paymentsManagerObj.getNavMethod(methodID,limitID) != "default"){
			$(submethods).each(function(k,v){
				if(v.id == "default"){
					defaultIndex = k;
				}
			})
			if(defaultIndex != null){
				submethods.splice(defaultIndex,1);
			}
		}
		//Iniciamos el recuento para obtener si todos los submétodos comparte este mismo caso

		var falseElems = 0;
		var thisKindElems = 0;
		var critical = 0;
		$(paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID)).each(function(k,v){
			if(v === availability_unavailable){
				thisKindElems ++;
			}else if(v === availability_maxReached || v === availability_unavailable || v === availability_notEnoughRemaining){
				critical ++;
			}else if(v !== availability_available){
				falseElems++;
			}
		})
		if(thisKindElems === submethods.length){
			//Si todos los submétodos pertenecen a este caso
			//Deshabilitamos las acciones globales
			paymentsManagerObj.setMsg(methodID,null,strings.unavailableMethodTitle,strings.unavailableMethodMsg);
			paymentsManagerObj.disableActionsForMethod(methodID,null);
			$(elem).attr('data-status',"0");
			paymentsManagerObj.unsetPaymentMethodsFromList(methodID,null)
			paymentsManagerObj.unsetPaymentMethodsFromList(methodID,"default")
		}else if(critical == submethods.length){
			$(elem).attr('data-status',"0");
		}else{
			//Si existen elementos no válidos aunque no sean de este tipo
			$(elem).attr('data-status',"2");
		}
	}
}


function on_minLimitReached_functions_legacy(methodID,limitID,paymentsManagerObj,limitValue,options){
	//Esta versión "legacy", mantiene las limitaciones de pagos que no alcanzan el mínimo, y solicita al usuario permiso para
	//realizar compras marcando una opción.
	//La versión actual, permite la compra por el mínimo establecido sin consultar.
	//console.log("min",methodID,limitID)
	var strings = {
		minLimitReachedTitle:	"{t}La compra <strong>no alcanza el mínimo</strong> para este método{/t}",
		minLimitReachedMsg:		"<p>{t}El importe de compra es inferior al importe mínimo aceptado en este método de pago:{/t} <strong>%1</strong></p><p>{t}Puedes utilizar otro método de pago o bien añadir más artículos hasta alcanzar el mínimo. También puedes añadir la cantidad mínima como Saldo Virtual y usarlo en cualquier momento{/t}</p>",
	}
	if(typeof options != "undefined"){
		if(typeof options.strings != "undefined"){
			if(typeof options.strings.minLimitReachedTitle != "undefined") 	{ strings.minLimitReachedTitle = options.strings.minLimitReachedTitle }
			if(typeof options.strings.minLimitReachedMsg != "undefined") 	{ strings.minLimitReachedMsg = options.strings.minLimitReachedMsg }
		}
	}
	var referenceValue = limitValue;/* paymentsManagerObj.getLimit(methodID,limitID).minLimit; */
	var elem = paymentsManagerObj.getMethodDOMelem(methodID);
	var limit = paymentsManagerObj.getLimit(methodID,limitID);
	if(!paymentsManagerObj.storedPayments.getMethod(methodID) && paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
		paymentsManagerObj.clearMsg(methodID,null)
	}

	if(!paymentsManagerObj.getCurrencyObj()){
		var currencyValue = referenceValue+"€";
	}else{
		var currencyValue = paymentsManagerObj.getCurrencyObj().getMoneda(parseFloat(referenceValue));
	}

	paymentsManagerObj.setMsg(methodID,limitID,strings.minLimitReachedTitle,strings.minLimitReachedMsg,[currencyValue]);
	if(!paymentsManagerObj.paymentsObj.isWithdrawal()){

		if(limit.allowForceMinLimit){
			if(paymentsManagerObj.storedPayments.getMethod(methodID) && paymentsManagerObj.getNavMethod(methodID) == "stored"){
				var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
				if(selected && selected.methodId == limitID){
					paymentsManagerObj.showForceMin(methodID,null);
				}else{
					if(!selected){
						paymentsManagerObj.hideForceMin(methodID,null);
					}
				}
			}else{
				paymentsManagerObj.showForceMin(methodID,limitID);
			}
			paymentsManagerObj.setNavElemStatus(2,methodID,limitID);
			paymentsManagerObj.setStorageElemStatus(2,limitID,methodID);
			$(elem).attr('data-status',"2");
		}else{
			if(paymentsManagerObj.storedPayments.getMethod(methodID) && paymentsManagerObj.getNavMethod(methodID) == "stored"){
				var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
				if(selected && selected.methodId == limitID){
					paymentsManagerObj.hideForceMin(methodID,null);
				}
			}else{
				paymentsManagerObj.hideForceMin(methodID,limitID);
			}
			paymentsManagerObj.hideForceMin(methodID,limitID);
			paymentsManagerObj.setNavElemStatus(0,methodID,limitID);
			paymentsManagerObj.setStorageElemStatus(0,limitID,methodID);
			$(elem).attr('data-status',"0");
		}

		if(paymentsManagerObj.paymentsObj.getUseForceMinLimitForMethod(methodID,limitID)){
			if(paymentsManagerObj.paymentsObj.isUsingForceMinLimit()){
					paymentsManagerObj.setPurchaseButtonAvailability(true,methodID,limitID);
					paymentsManagerObj.showTotalOperation(methodID,limitID);
					paymentsManagerObj.paymentsObj.setUseForceMinLimit(true);
					paymentsManagerObj.setStorageElemStatus(1,limitID,methodID);

			}else{
				paymentsManagerObj.hideTotalOperation(methodID,limitID);
				paymentsManagerObj.paymentsObj.setUseForceMinLimit(false);
				paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,limitID);
				paymentsManagerObj.hideRequiredFields(methodID,limitID);
				paymentsManagerObj.setStorageElemStatus(2,limitID,methodID);
			}
		}else{
			if(!paymentsManagerObj.storedPayments.getMethod(methodID)){
				paymentsManagerObj.disableActionsForMethod(methodID,limitID);
			}else{
				paymentsManagerObj.allowNavOnlyActionsForMethod(methodID,limitID)
			}
			paymentsManagerObj.setStorageElemStatus(2,limitID,methodID);
			paymentsManagerObj.paymentsObj.setUseForceMinLimit(false);
			paymentsManagerObj.hideTotalOperation(methodID,limitID);
			paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,limitID);
			paymentsManagerObj.hideRequiredFields(methodID,limitID);

		}

		if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
			if(limit.allowForceMinLimit){
				paymentsManagerObj.setStorageElemStatus(2,limitID,methodID,"default");
				/* paymentsManagerObj.showForceMin(methodID,"default"); */
			}else{
				paymentsManagerObj.setStorageElemStatus(0,limitID,methodID,"default");
				/* paymentsManagerObj.hideForceMin(methodID,"default"); */

			}

			if(paymentsManagerObj.getNavAutoSubmethod(methodID) == "auto" && paymentsManagerObj.getNavMethod(methodID) == "stored"){
				var selected  = paymentsManagerObj.storedPayments.getSelection(methodID);
				var submethod = selected.methodId;
				paymentsManagerObj.enableActionsForMethod(methodID,"default");

				if(limitID == submethod){
					if(limit.allowForceMinLimit){
						paymentsManagerObj.showForceMin(methodID,"default");
					}else{
						paymentsManagerObj.hideForceMin(methodID,"default");
					}
					paymentsManagerObj.setMsg(methodID,"default",strings.minLimitReachedTitle,strings.minLimitReachedMsg,[currencyValue]);
					if(paymentsManagerObj.getForceMinStatus(methodID,"default")){
						paymentsManagerObj.setPurchaseButtonAvailability(true,methodID,"default")
						paymentsManagerObj.showTotalOperation(methodID,"default");
						//paymentsManagerObj.showRequiredFields(methodID,"default");
						paymentsManagerObj.paymentsObj.setUseForceMinLimit(true);

					}else{
						paymentsManagerObj.hideTotalOperation(methodID,"default");
						paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,"default")
						paymentsManagerObj.hideRequiredFields(methodID,"default");

						paymentsManagerObj.paymentsObj.setUseForceMinLimit(false);
					}
				}
			}else if(paymentsManagerObj.getNavAutoSubmethod(methodID) == "auto" && paymentsManagerObj.getNavMethod(methodID) == "default"){
				if(limit.allowForceMinLimit && limitID == "default"){
					if(paymentsManagerObj.paymentsObj.getUseForceMinLimitState()){
						paymentsManagerObj.enableActionsForMethod(methodID,"default");
					}else{
						if(paymentsManagerObj.storedPayments.getMethod(methodID)){
							paymentsManagerObj.allowNavOnlyActionsForMethod(methodID,"default");
						}
					}
				}else{
					var defaultIndexItem = paymentsManagerObj.paymentsObj.getSubmethodIndex(methodID,"default");
					if(!paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID)[defaultIndexItem] && paymentsManagerObj.storedPayments.getMethod(methodID)){
						paymentsManagerObj.allowNavOnlyActionsForMethod(methodID,"default")
					}else{
						paymentsManagerObj.enableActionsForMethod(methodID,"default");
					}
				}
			}
		}else{
			var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
			if(selected && selected.methodId == limitID){
				paymentsManagerObj.setMsg(methodID,null,strings.minLimitReachedTitle,strings.minLimitReachedMsg,[currencyValue]);
			}
		}
	}else{
		if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
			var navMethod = paymentsManagerObj.getNavMethod(methodID);
			if(paymentsManagerObj.storedPayments.getMethod(methodID) && navMethod == "stored"){
				var lim = "default"
				var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
				if(selected && selected.methodId == limitID){
					paymentsManagerObj.hideRequiredFields(methodID)
				}else{
					selected = false;
				}
				paymentsManagerObj.clearMsg(methodID,lim)

			}else{
				var lim = limitID;
			}

		}else{
			var navMethod = paymentsManagerObj.getNavMethod(methodID);
			paymentsManagerObj.clearMsg(methodID,null);

			if(paymentsManagerObj.storedPayments.getMethod(methodID) && navMethod == "stored"){
				var lim = null;
				var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
				if(selected && selected.methodId == limitID){
					paymentsManagerObj.hideRequiredFields(methodID)
				}else{
					selected = false;
				}
			}else{
				var lim = limitID;
			}

		}
		if(!paymentsManagerObj.storedPayments.getMethod(methodID) || navMethod != "stored" || selected){
			paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,lim);
			paymentsManagerObj.setMsg(methodID,lim,strings.minLimitReachedTitle,strings.minLimitReachedMsg,[currencyValue]);
			paymentsManagerObj.setReadyForPurchase(false,methodID,lim)
		}

		if(paymentsManagerObj.storedPayments.getMethod(methodID)){
			paymentsManagerObj.setStorageElemStatus(0,limitID,methodID,lim);
			if(navMethod != "stored"){
				paymentsManagerObj.allowNavOnlyActionsForMethod(methodID,lim);
			}
		}else{
			paymentsManagerObj.disableActionsForMethod(methodID,lim)

		}
		paymentsManagerObj.setNavElemStatus(0,methodID,lim);
		paymentsManagerObj.hideInfoArea(methodID,lim)
	}
	//Escenarios:
	//Tanto si es autosubmétodo como si no, evaluamos la viabilidad global del método,
	//ya que si no es viable se deshabilitan todas las acciones en todos los casos.

	var method = paymentsManagerObj.getMethod(methodID);
	var submethods = JSON.parse(JSON.stringify(method.limits));
	var submethodsCount = 0;
	var expectedMethods = 0;
	//Como la viabilidad se evalua por submetódo tenemos que saber cuando se han evaluado todos
	//excepto "default" si es autosubmétodo. No lo tenemos en cuenta.
	expectedMethods = method.limits.length;
	submethodsCount = paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID).length;
	if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
		//Si es autosubmétodo, ignoramos el caso default
		if(paymentsManagerObj.getNavAutoSubmethod() != "manual" && paymentsManagerObj.getNavMethod(methodID,limitID)!= "default"){
			expectedMethods = expectedMethods - 1;
			submethodsCount = submethodsCount - 1;
		}
	}
	//Si el número de submétodos evaluados coincide con el número de submétodos, es que hemos terminado de evaluarlos
	//todos. Realizamos las acciones pertinentes que afecten a todos los submétodos.
	if(expectedMethods == submethodsCount){
		//Si es autosubmétodo excluimos el caso default, para ignorar su estado en getDetailedAvailability()
		var defaultIndex = null;
		if(paymentsManagerObj.getNavAutoSubmethod() != "manual" && paymentsManagerObj.getNavMethod(methodID,limitID) != "default"){
			$(submethods).each(function(k,v){
				if(v.id == "default"){
					defaultIndex = k;
				}
			})
			if(defaultIndex != null){
				submethods.splice(defaultIndex,1);
			}
		}
		//Iniciamos el recuento para obtener si todos los submétodos comparte este mismo caso

		var falseElems = 0;
		var thisKindElems = 0;
		var critical = 0;
		$(paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID)).each(function(k,v){
			if(k != defaultIndex || defaultIndex == null){
				if(v === availability_minReached){
					thisKindElems ++;
				}else if(v === availability_maxReached || v === availability_unavailable || v === availability_notEnoughRemaining){
					critical ++;
				}else if(v !== availability_available){
					falseElems++;
				}
			}
		})
		if(thisKindElems == submethods.length){
			//Si todos los submétodos pertenecen a este caso
			//Deshabilitamos las acciones globales
			//Comprobamos que todos los limites no permitan el forzado por el mínimo importe
			var nonPermitted = 0;
			$(submethods).each(function(k,v){
				if(!v.allowForceMinLimit){
					nonPermitted++;
				}
			})
			if(nonPermitted == submethods.length){
				paymentsManagerObj.setMsg(methodID,null,strings.minLimitReachedTitle,strings.minLimitReachedMsg,[currencyValue]);
				paymentsManagerObj.disableActionsForMethod(methodID,null);
				$(elem).attr('data-status',"0");
				paymentsManagerObj.setLimitsBadgeStatus(true,0,methodID);
				paymentsManagerObj.unsetPaymentMethodsFromList(methodID,null)
				paymentsManagerObj.unsetPaymentMethodsFromList(methodID,"default")
				if(paymentsManagerObj.paymentsObj.isWithdrawal()){
					paymentsManagerObj.disableActionsForMethod(methodID)
				}
			}

		}else if(critical == submethods.length){
			$(elem).attr('data-status',"0");
		}else if(falseElems > 0){
			//Si existen elementos no válidos aunque no sean de este tipo
			$(elem).attr('data-status',"2");
			paymentsManagerObj.setLimitsBadgeStatus(true,0,methodID)
		}else{
			//Si existen elementos no válidos aunque no sean de este tipo
			$(elem).attr('data-status',"2");
		}
	}
}
function on_minLimitReached_functions(methodID,limitID,paymentsManagerObj,limitValue,options){
	//La versión actual, permite la compra por el mínimo establecido sin consultar.
	//console.log("min",methodID,limitID)
	var strings = {
		minLimitReachedTitle:	null,
		minLimitReachedMsg:		"{t}El importe mínimo es de:{/t} <strong>%1</strong>. {t}La diferencia <strong>(%2)</strong> se añadirá a tu Saldo Virtual{/t} </p>",
	}
	if(typeof options != "undefined"){
		if(typeof options.strings != "undefined"){
			if(typeof options.strings.minLimitReachedTitle != "undefined") 	{ strings.minLimitReachedTitle = options.strings.minLimitReachedTitle }
			if(typeof options.strings.minLimitReachedMsg != "undefined") 	{ strings.minLimitReachedMsg = options.strings.minLimitReachedMsg }
		}
	}

	var newOptions = {
		minLimitNotReached: true,
		minLimitCurrencyValue:limitValue,
		strings:{
			minLimitReachedMsg: strings.minLimitReachedMsg
		}
	}
	if(!paymentsManagerObj.paymentsObj.isWithdrawal()){
		on_validValues_functions(methodID,limitID,paymentsManagerObj,newOptions);
		return;
	}else{
		var elem = paymentsManagerObj.getMethodDOMelem(methodID);
		var limit = paymentsManagerObj.getLimit(methodID,limitID);
		if(!paymentsManagerObj.storedPayments.getMethod(methodID) && paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
			paymentsManagerObj.clearMsg(methodID,null)
		}
		if(!paymentsManagerObj.getCurrencyObj()){
			var currencyValue = limitValue+"€";
		}else{
			var currencyValue = paymentsManagerObj.getCurrencyObj().getMoneda(parseFloat(limitValue));
		}
		paymentsManagerObj.setMsg(methodID,limitID,strings.minLimitReachedTitle,strings.minLimitReachedMsg,[currencyValue]);
		paymentsManagerObj.showDocuments(false,methodID,limitID);

		if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
			var navMethod = paymentsManagerObj.getNavMethod(methodID);
			if(paymentsManagerObj.storedPayments.getMethod(methodID) && navMethod == "stored"){
				var lim = "default"
				var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
				if(selected && selected.methodId == limitID){
					paymentsManagerObj.hideRequiredFields(methodID)
				}else{
					selected = false;
				}
				paymentsManagerObj.clearMsg(methodID,lim)
			}else{
				var lim = limitID;
			}

		}else{
			var navMethod = paymentsManagerObj.getNavMethod(methodID);
			paymentsManagerObj.clearMsg(methodID,null);

			if(paymentsManagerObj.storedPayments.getMethod(methodID) && navMethod == "stored"){
				var lim = null;
				var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
				if(selected && selected.methodId == limitID){
					paymentsManagerObj.hideRequiredFields(methodID)
				}else{
					selected = false;
				}
			}else{
				var lim = limitID;
			}

		}
		paymentsManagerObj.showDocuments(false,methodID,lim);

		if(!paymentsManagerObj.storedPayments.getMethod(methodID) || navMethod != "stored" || selected){
			paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,lim);
			paymentsManagerObj.setMsg(methodID,lim,strings.minLimitReachedTitle,strings.minLimitReachedMsg,[currencyValue]);
			paymentsManagerObj.setReadyForPurchase(false,methodID,lim)
		}

		if(paymentsManagerObj.storedPayments.getMethod(methodID)){
			paymentsManagerObj.setStorageElemStatus(0,limitID,methodID,lim);
			if(navMethod != "stored"){
				paymentsManagerObj.allowNavOnlyActionsForMethod(methodID,lim);
			}
		}else{
			paymentsManagerObj.disableActionsForMethod(methodID,lim)

		}
		paymentsManagerObj.setNavElemStatus(0,methodID,lim);
		paymentsManagerObj.hideInfoArea(methodID,lim)

		//Escenarios:
		//Tanto si es autosubmétodo como si no, evaluamos la viabilidad global del método,
		//ya que si no es viable se deshabilitan todas las acciones en todos los casos.

		var method = paymentsManagerObj.getMethod(methodID);
		var submethods = JSON.parse(JSON.stringify(method.limits));
		var submethodsCount = 0;
		var expectedMethods = 0;
		//Como la viabilidad se evalua por submetódo tenemos que saber cuando se han evaluado todos
		//excepto "default" si es autosubmétodo. No lo tenemos en cuenta.
		expectedMethods = method.limits.length;
		submethodsCount = paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID).length;
		if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
			//Si es autosubmétodo, ignoramos el caso default
			if(paymentsManagerObj.getNavAutoSubmethod() != "manual" && paymentsManagerObj.getNavMethod(methodID,limitID)!= "default"){
				expectedMethods = expectedMethods - 1;
				submethodsCount = submethodsCount - 1;
			}
		}
		//Si el número de submétodos evaluados coincide con el número de submétodos, es que hemos terminado de evaluarlos
		//todos. Realizamos las acciones pertinentes que afecten a todos los submétodos.
		if(expectedMethods == submethodsCount){
			//Si es autosubmétodo excluimos el caso default, para ignorar su estado en getDetailedAvailability()
			var defaultIndex = null;
			if(paymentsManagerObj.getNavAutoSubmethod() != "manual" && paymentsManagerObj.getNavMethod(methodID,limitID) != "default"){
				$(submethods).each(function(k,v){
					if(v.id == "default"){
						defaultIndex = k;
					}
				})
				if(defaultIndex != null){
					submethods.splice(defaultIndex,1);
				}
			}
			//Iniciamos el recuento para obtener si todos los submétodos comparte este mismo caso

			var falseElems = 0;
			var thisKindElems = 0;
			var critical = 0;
			$(paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID)).each(function(k,v){
				if(k != defaultIndex || defaultIndex == null){
					if(v === availability_minReached){
						thisKindElems ++;
					}else if(v === availability_maxReached || v === availability_unavailable || v === availability_notEnoughRemaining){
						critical ++;
					}else if(v !== availability_available){
						falseElems++;
					}
				}
			})
			if(thisKindElems == submethods.length){
				//Si todos los submétodos pertenecen a este caso
				//Deshabilitamos las acciones globales
				//Comprobamos que todos los limites no permitan el forzado por el mínimo importe
				var nonPermitted = 0;
				$(submethods).each(function(k,v){
					if(!v.allowForceMinLimit){
						nonPermitted++;
					}
				})
				if(nonPermitted == submethods.length){
					//Si todos los submetodos no llegan al mínimo, obtenemos el mínimo más pequeño de todos , para mostrar en el mensaje.
					let minimal = submethods.reduce( (minValue,value) => { if(value.minLimit < minValue || minValue == 0) { return value.minLimit } else {return minValue}},0);
					if(!paymentsManagerObj.getCurrencyObj()){
						var currencyValue = minimal+"€";
					}else{
						var currencyValue = paymentsManagerObj.getCurrencyObj().getMoneda(parseFloat(minimal));
					}
					paymentsManagerObj.setMsg(methodID,null,strings.minLimitReachedTitle,strings.minLimitReachedMsg,[currencyValue]);
					paymentsManagerObj.disableActionsForMethod(methodID,null);
					$(elem).attr('data-status',"0");
					paymentsManagerObj.setLimitsBadgeStatus(true,0,methodID);
					paymentsManagerObj.unsetPaymentMethodsFromList(methodID,null)
					paymentsManagerObj.unsetPaymentMethodsFromList(methodID,"default")
					if(paymentsManagerObj.paymentsObj.isWithdrawal()){
						paymentsManagerObj.disableActionsForMethod(methodID)
					}
				}

			}else if(critical == submethods.length){
				$(elem).attr('data-status',"0");
			}else if(falseElems > 0){
				//Si existen elementos no válidos aunque no sean de este tipo
				$(elem).attr('data-status',"2");
				paymentsManagerObj.setLimitsBadgeStatus(true,0,methodID)
			}else{
				//Si existen elementos no válidos aunque no sean de este tipo
				$(elem).attr('data-status',"2");
			}
		}
	}

}

function on_maxLimitReached_functions(methodID,limitID,paymentsManagerObj,limitValue,options){
	//console.log("max",methodID,limitID)

	var strings = {
		maxLimitReachedTitle:	"{t}La compra <strong>supera el máximo</strong> disponible para este método{/t}",
		maxLimitReachedMsg:		"<p>{t}En este momento el importe máximo que puedes pagar usando este método de pago es:{/t} <strong>%1</strong></p>"+
								 "<p><u>{t}¿Por qué este límite?{/t}</u></p>"+
								 "<p{t}>Este límite se establece para evitar un uso inadecuado de tus métodos de pago, y se tienen en cuenta: pagos realizados en los últimos 30 días, tiempo que llevas jugando, que hayas validado tu teléfono por SMS, etc. <strong>Para garantizar tu seguridad, tu gestor en %1 va a revisar tu cuenta para intentar aumentarlo</strong>{/t}</p>"+
								 "<p>{t}Mientras tanto, puedes utilizar otros métodos de pago{/t}</p>",
		notEnoughVCTitle:		"{t}Saldo virtual <strong>insuficiente</strong> para efectuar esta compra{/t}",
		notEnoughVCMsg:			"<p>{t}Pero no te preocupes, puedes «Añadir Saldo Virtual» o puedes intentarlo con otro método de pago{/t}</p>",
		maxTransferableReachedTitle: "<p>{t}No dispones de suficientes fondos transferibles{/t}</p>",
		maxTransferableReachedMsg: "<p>{t}Recuerda que sólo son transferibles los fondos provenientes de premios. Intenta extraer un importe menor.{/t}</p>"
	}
	if(typeof options != "undefined"){
		if(typeof options.strings != "undefined"){
			if(typeof options.strings.maxLimitReachedTitle != "undefined") 			{ strings.maxLimitReachedTitle = options.strings.maxLimitReachedTitle }
			if(typeof options.strings.maxLimitReachedMsg != "undefined") 			{ strings.maxLimitReachedMsg = options.strings.maxLimitReachedMsg }
			if(typeof options.strings.notEnoughVCTitle != "undefined") 				{ strings.notEnoughVCTitle = options.strings.notEnoughVCTitle }
			if(typeof options.strings.notEnoughVCMsg != "undefined") 				{ strings.notEnoughVCMsg = options.strings.notEnoughVCMsg }
			if(typeof options.strings.maxTransferableReachedTitle != "undefined")	{ strings.maxTransferableReachedTitle = options.strings.maxTransferableReachedTitle }
			if(typeof options.strings.maxTransferableReachedMsg != "undefined")		{ strings.maxTransferableReachedMsg = options.strings.maxTransferableReachedMsg }

		}
	}

	var elem = paymentsManagerObj.getMethodDOMelem(methodID);
	var referenceValue = limitValue;
	if(!paymentsManagerObj.getCurrencyObj()){
		var currencyValue = referenceValue+"€";
	}else{
		var currencyValue = paymentsManagerObj.getCurrencyObj().getMoneda(parseFloat(referenceValue));
	}


	if(methodID == "sv"){	//Saldo Virtual
		paymentsManagerObj.setMsg(methodID,limitID,strings.notEnoughVCTitle,strings.notEnoughVCMsg);
		paymentsManagerObj.disableActionsForMethod(methodID,limitID);
		paymentsManagerObj.setLimitsBadgeStatus(true,0,0);
		$(elem).attr('data-status',"0");
		return false;
	}else{
		if(!paymentsManagerObj.storedPayments.getMethod(methodID) && paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
			paymentsManagerObj.clearMsg(methodID,null)
		}
		if(!paymentsManagerObj.paymentsObj.isWithdrawal()){


			paymentsManagerObj.setMsg(methodID,limitID,strings.maxLimitReachedTitle,strings.maxLimitReachedMsg,[currencyValue])

			paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,limitID);
			if(!paymentsManagerObj.storedPayments.getMethod(methodID) || (paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID) && limitID == "default")){
				paymentsManagerObj.disableActionsForMethod(methodID,limitID);
			}else{
				if(paymentsManagerObj.storedPayments.getMethod(methodID)){
					paymentsManagerObj.allowNavOnlyActionsForMethod(methodID,limitID)
				}
			}

			paymentsManagerObj.setNavElemStatus(0,methodID,limitID);
			paymentsManagerObj.hideUsePreviousBalance(methodID,limitID);
			paymentsManagerObj.setStorageElemStatus(0,limitID,methodID,limitID);

			if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
				paymentsManagerObj.setStorageElemStatus(0,limitID,methodID,"default");
				if(paymentsManagerObj.getNavAutoSubmethod(methodID) == "auto"){
					if(paymentsManagerObj.getNavMethod(methodID) == "stored"){
						var selected  = paymentsManagerObj.storedPayments.getSelection(methodID);
						var submethod = selected.methodId;
						if(limitID == submethod){
							paymentsManagerObj.setMsg(methodID,"default",strings.maxLimitReachedTitle,strings.maxLimitReachedMsg,[currencyValue]);
							paymentsManagerObj.hideForceMin(methodID,"default");
							paymentsManagerObj.hideTotalOperation(methodID,"default");
							paymentsManagerObj.hideRequiredFields(methodID,"default");
							paymentsManagerObj.hideUsePreviousBalance(methodID,"default");
							paymentsManagerObj.enableActionsForMethod(methodID,"default");
							paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,"default")
							paymentsManagerObj.hideRequiredFields(methodID)
						}
					}else if(paymentsManagerObj.getNavMethod(methodID) == "default"){
						var defaultIndexItem = paymentsManagerObj.paymentsObj.getSubmethodIndex(methodID,"default");
						if(paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID)[defaultIndexItem] !== true){
							if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID) && limitID == "default"){
								paymentsManagerObj.disableActionsForMethod(methodID,"default");
							}else{
								if(paymentsManagerObj.storedPayments.getMethod(methodID)){
									paymentsManagerObj.allowNavOnlyActionsForMethod(methodID,limitID)//,"default")
								}
							}

						}else{
							paymentsManagerObj.enableActionsForMethod(methodID,"default");
						}
					}
				}
			}else{
				var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
				if(selected && selected.methodId == limitID){
					paymentsManagerObj.setMsg(methodID,null,strings.maxLimitReachedTitle,strings.maxLimitReachedMsg,[currencyValue]);
					paymentsManagerObj.hideRequiredFields(methodID)
				}
			}
		}else{

			if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
				var navMethod = paymentsManagerObj.getNavMethod(methodID);
				if(paymentsManagerObj.storedPayments.getMethod(methodID) && navMethod == "stored"){
					var lim = "default"
					var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
					if(selected && selected.methodId == limitID){
						paymentsManagerObj.hideRequiredFields(methodID)
					}else{
						selected = false;
					}
				}else{
					var lim = limitID;
				}
			}else{
				var navMethod = paymentsManagerObj.getNavMethod(methodID);
				paymentsManagerObj.clearMsg(methodID,null);

				if(paymentsManagerObj.storedPayments.getMethod(methodID) && navMethod == "stored"){
					var lim = null;
					var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
					if(selected && selected.methodId == limitID){
						paymentsManagerObj.hideRequiredFields(methodID)
					}else{
						selected = false;
					}
				}else{
					var lim = limitID;
				}

			}
			paymentsManagerObj.showDocuments(false,methodID,lim);

			if(!paymentsManagerObj.storedPayments.getMethod(methodID) || navMethod != "stored" || selected){
				paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,lim);
				paymentsManagerObj.setMsg(methodID,lim,strings.maxLimitReachedTitle,strings.maxLimitReachedMsg,[currencyValue]);
				paymentsManagerObj.setReadyForPurchase(false,methodID,lim)
			}

			if(paymentsManagerObj.storedPayments.getMethod(methodID)){
				paymentsManagerObj.setStorageElemStatus(0,limitID,methodID,lim);
				if(navMethod != "stored"){
					paymentsManagerObj.allowNavOnlyActionsForMethod(methodID,lim);
				}
			}else{
				paymentsManagerObj.disableActionsForMethod(methodID,lim)

			}
			paymentsManagerObj.setNavElemStatus(0,methodID,lim);
			paymentsManagerObj.hideInfoArea(methodID,lim)
		}
	}
	paymentsManagerObj.hideForceMin(methodID,limitID);
	paymentsManagerObj.hideRequiredFields(methodID,limitID);
	paymentsManagerObj.setLimitsBadgeStatus(true,1,methodID,limitID);
	paymentsManagerObj.hideTotalOperation(methodID,limitID);
	paymentsManagerObj.setStorageElemStatus(0,limitID,methodID);

	//Escenarios:
	//Tanto si es autosubmétodo como si no, evaluamos la viabilidad global del método,
	//ya que si no es viable se deshabilitan todas las acciones en todos los casos.

	var method = paymentsManagerObj.getMethod(methodID);
	var submethods = JSON.parse(JSON.stringify(method.limits));
	var submethodsCount = 0;
	var expectedMethods = 0;
	//Como la viabilidad se evalua por submetódo tenemos que saber cuando se han evaluado todos
	//excepto "default" si es autosubmétodo. No lo tenemos en cuenta.
	expectedMethods = method.limits.length;
	submethodsCount = paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID).length;
	if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
		//Si es autosubmétodo, ignoramos el caso default
		if(paymentsManagerObj.getNavAutoSubmethod() != "manual" && paymentsManagerObj.getNavMethod(methodID,limitID) != "default"){
			expectedMethods = expectedMethods - 1;
			submethodsCount = submethodsCount - 1;
		}
	}
	//Si el número de submétodos evaluados coincide con el número de submétodos, es que hemos terminado de evaluarlos
	//todos. Realizamos las acciones pertinentes que afecten a todos los submétodos.
	if(expectedMethods == submethodsCount){
		//Si es autosubmétodo excluimos el caso default, para ignorar su estado en getDetailedAvailability()
		var defaultIndex = null;
		if(paymentsManagerObj.getNavAutoSubmethod() != "manual" && paymentsManagerObj.getNavMethod(methodID,limitID) != "default"){
			$(submethods).each(function(k,v){
				if(v.id == "default"){
					defaultIndex = k;
				}
			})
			if(defaultIndex != null){
				submethods.splice(defaultIndex,1);
			}
		}
		//Iniciamos el recuento para obtener si todos los submétodos comparte este mismo caso

		var falseElems = 0;
		var thisKindElems = 0;
		var critical = 0;
		$(paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID)).each(function(k,v){
			if(k != defaultIndex || defaultIndex == null){
				if(v === availability_maxReached){
					thisKindElems ++;
				}else if(v === availability_maxReached || v === availability_unavailable || v === availability_notEnoughRemaining){
					critical ++;
				}else if(v !== availability_available){
					falseElems++;
				}
			}
		})
		if(thisKindElems == submethods.length){
			//Si todos los submétodos pertenecen a este caso
			//Deshabilitamos las acciones globales
			if(!paymentsManagerObj.paymentsObj.isWithdrawal()){
				paymentsManagerObj.setMsg(methodID,null,strings.maxLimitReachedTitle,strings.maxLimitReachedMsg,[currencyValue]);
			}else{
				paymentsManagerObj.setMsg(methodID,null,strings.maxTransferableReachedTitle,strings.maxTransferableReachedMsg,[currencyValue]);
			}
			paymentsManagerObj.unsetPaymentMethodsFromList(methodID,null)
			paymentsManagerObj.unsetPaymentMethodsFromList(methodID,"default")
			paymentsManagerObj.disableActionsForMethod(methodID,null);

			$(elem).attr('data-status',"0");
			paymentsManagerObj.setLimitsBadgeStatus(true,0,methodID);
		}else if(critical == submethods.length){
			$(elem).attr('data-status',"0");
		}else if(falseElems > 0){
			//Si existen elementos no válidos aunque no sean de este tipo
			$(elem).attr('data-status',"2");
			paymentsManagerObj.setLimitsBadgeStatus(true,0,methodID)
		}else{
			//Si existen elementos no válidos aunque no sean de este tipo
			$(elem).attr('data-status',"2");
		}
	}


}

function on_remainingReached_functions(methodID,limitID,paymentsManagerObj,limitValue,options){
	//console.log("rem",methodID,limitID)

	var strings = {
		remainingReachedTitle:	"{t}Método de pago deshabilitado{/t}",
		remainingReachedMsg:	"<p>{t}Para utilizar este método de pago, debes contactar con nuestro <a href='%1'>equipo de atención al cliente</a>{/t}</p>"+
								 "<p><strong>{t}Te recomendamos utilizar otros métodos de pago, como transferencia bancaria{/t}</strong></p>",
		notEnoughVCTitle:		"{t}Saldo virtual <strong>insuficiente</strong> para efectuar esta compra{/t}",
		notEnoughVCMsg:			"<p>{t}Pero no te preocupes, puedes «Añadir Saldo Virtual» o puedes intentarlo con otro método de pago{/t}</p>",

	}
	if(typeof options != "undefined"){
		if(typeof options.strings != "undefined"){
			if(typeof options.strings.remainingReachedTitle != "undefined") 	{ strings.remainingReachedTitle = options.strings.remainingReachedTitle }
			if(typeof options.strings.remainingReachedMsg != "undefined") 		{ strings.remainingReachedMsg = options.strings.remainingReachedMsg }
			if(typeof options.strings.notEnoughVCTitle != "undefined") 				{ strings.notEnoughVCTitle = options.strings.notEnoughVCTitle }
			if(typeof options.strings.notEnoughVCMsg != "undefined") 				{ strings.notEnoughVCMsg = options.strings.notEnoughVCMsg }
		}
	}
	var elem = paymentsManagerObj.getMethodDOMelem(methodID);

	if(methodID == "sv"){	//Saldo Virtual
		paymentsManagerObj.setMsg(methodID,limitID,strings.notEnoughVCTitle,strings.notEnoughVCMsg);
		paymentsManagerObj.disableActionsForMethod(methodID,limitID);
		paymentsManagerObj.hideTotalOperation(methodID,limitID);
		paymentsManagerObj.setLimitsBadgeStatus(false,0,0);
		$(elem).attr('data-status',"0");
		return false;
	}
	if(!paymentsManagerObj.storedPayments.getMethod(methodID) && paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
		paymentsManagerObj.clearMsg(methodID,null)
	}
	if(!paymentsManagerObj.paymentsObj.isWithdrawal()){

		paymentsManagerObj.paymentsObj.setUseForceMinLimit(false)
		paymentsManagerObj.hideForceMin(methodID,limitID);
		paymentsManagerObj.setMsg(methodID,limitID,strings.remainingReachedTitle,strings.remainingReachedMsg);
		if(!paymentsManagerObj.storedPayments.getMethod(methodID)){
			paymentsManagerObj.disableActionsForMethod(methodID,limitID);
		}else{
			paymentsManagerObj.allowNavOnlyActionsForMethod(methodID,limitID)
		}
		paymentsManagerObj.setNavElemStatus(0,methodID,limitID);
		paymentsManagerObj.hideRequiredFields(methodID,limitID);
		paymentsManagerObj.setStorageElemStatus(0,limitID,methodID);

		if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
			paymentsManagerObj.setStorageElemStatus(0,limitID,methodID,"default");
			if(paymentsManagerObj.getNavAutoSubmethod(methodID) == "auto"){
				if(paymentsManagerObj.getNavMethod(methodID) == "stored"){
					paymentsManagerObj.clearMsg(methodID,"default");
					var selected  = paymentsManagerObj.storedPayments.getSelection(methodID);
					var submethod = selected.methodId;
					if(limitID == submethod){
						paymentsManagerObj.setMsg(methodID,"default",strings.remainingReachedTitle,strings.remainingReachedMsg);
						paymentsManagerObj.hideForceMin(methodID,"default");
						paymentsManagerObj.enableActionsForMethod(methodID,"default");
						paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,"default");
						paymentsManagerObj.hideRequiredFields(methodID,limitID);

					}
				}else if(paymentsManagerObj.getNavMethod(methodID) == "default"){
					var defaultIndexItem = paymentsManagerObj.paymentsObj.getSubmethodIndex(methodID,"default");
					if(!paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID)[defaultIndexItem]){
						if(paymentsManagerObj.storedPayments.getMethod(methodID)){
							paymentsManagerObj.allowNavOnlyActionsForMethod(methodID,"default")
						}
					}
				}
			}
		}
	}else{
		if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
			var navMethod = paymentsManagerObj.getNavMethod(methodID);
			if(paymentsManagerObj.storedPayments.getMethod(methodID) && navMethod == "stored"){
				var lim = "default"
				var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
				if(selected && selected.methodId == limitID){
					paymentsManagerObj.hideRequiredFields(methodID)
				}else{
					selected = false;
				}
				paymentsManagerObj.clearMsg(methodID,lim)
			}else{
				var lim = limitID;
			}

			if(!paymentsManagerObj.storedPayments.getMethod(methodID) || navMethod != "stored" || selected){

			}
		}else{
			var navMethod = paymentsManagerObj.getNavMethod(methodID);
			paymentsManagerObj.clearMsg(methodID,null);
			if(paymentsManagerObj.storedPayments.getMethod(methodID) && navMethod == "stored"){
				var lim = null;
				if(selected && selected.methodId == limitID){
					paymentsManagerObj.hideRequiredFields(methodID)
				}else{
					selected = false;
				}
			}else{
				var lim = limitID;

			}
		}
		paymentsManagerObj.showDocuments(false,methodID,lim);

		if(!paymentsManagerObj.storedPayments.getMethod(methodID) || navMethod != "stored" || selected){
			paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,lim);
			paymentsManagerObj.setReadyForPurchase(false,methodID,lim)
			paymentsManagerObj.setMsg(methodID,lim,strings.remainingReachedTitle,strings.remainingReachedMsg);
		}

		if(paymentsManagerObj.storedPayments.getMethod(methodID)){
			paymentsManagerObj.setStorageElemStatus(0,limitID,methodID,lim);
			if(navMethod != "stored"){
				paymentsManagerObj.allowNavOnlyActionsForMethod(methodID,lim);
			}
		}else{
			paymentsManagerObj.disableActionsForMethod(methodID,lim)
		}
		paymentsManagerObj.hideInfoArea(methodID,lim)
	}
	//Escenarios:
	//Tanto si es autosubmétodo como si no, evaluamos la viabilidad global del método,
	//ya que si no es viable se deshabilitan todas las acciones en todos los casos.

	var method = paymentsManagerObj.getMethod(methodID);
	var submethods = JSON.parse(JSON.stringify(method.limits));
	var submethodsCount = 0;
	var expectedMethods = 0;
	//Como la viabilidad se evalua por submetódo tenemos que saber cuando se han evaluado todos
	//excepto "default" si es autosubmétodo. No lo tenemos en cuenta.
	expectedMethods = method.limits.length;
	submethodsCount = paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID).length;
	if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
		//Si es autosubmétodo, ignoramos el caso default
		if(paymentsManagerObj.getNavAutoSubmethod() != "manual" && paymentsManagerObj.getNavMethod(methodID,limitID) != "default"){
			expectedMethods = expectedMethods - 1;
			submethodsCount = submethodsCount - 1;
		}
	}
	//Si el número de submétodos evaluados coincide con el número de submétodos, es que hemos terminado de evaluarlos
	//todos. Realizamos las acciones pertinentes que afecten a todos los submétodos.
	if(expectedMethods == submethodsCount){
		//Si es autosubmétodo excluimos el caso default, para ignorar su estado en getDetailedAvailability()
		var defaultIndex = null;
		if(paymentsManagerObj.getNavAutoSubmethod() != "manual" && paymentsManagerObj.getNavMethod(methodID,limitID) != "default"){

			$(submethods).each(function(k,v){
				if(v.id == "default"){
					defaultIndex = k;
				}
			})
			if(defaultIndex != null){
				submethods.splice(defaultIndex,1);
			}
		}
		//Iniciamos el recuento para obtener si todos los submétodos comparte este mismo caso

		var falseElems = 0;
		var thisKindElems = 0;
		var critical = 0;
		$(paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID)).each(function(k,v){
			if(k != defaultIndex || defaultIndex == null){
				if(v === availability_notEnoughRemaining){
					thisKindElems ++;
				}else if(v === availability_maxReached || v === availability_unavailable || v === availability_notEnoughRemaining){
					critical ++;
				}else if(v !== availability_available){
					falseElems++;
				}
			}
		})
		if(thisKindElems == submethods.length){
			//Si todos los submétodos pertenecen a este caso
			//Deshabilitamos las acciones globales
			paymentsManagerObj.setMsg(methodID,null,strings.remainingReachedTitle,strings.remainingReachedMsg);
			paymentsManagerObj.disableActionsForMethod(methodID,null);
			$(elem).attr('data-status',"0");
			paymentsManagerObj.setLimitsBadgeStatus(false,[0,0],methodID);
			paymentsManagerObj.unsetPaymentMethodsFromList(methodID,null)
			paymentsManagerObj.unsetPaymentMethodsFromList(methodID,"default")

		}else if(critical == submethods.length){
				$(elem).attr('data-status',"0");
		}else if(falseElems > 0){
			//Si existen elementos no válidos aunque no sean de este tipo
			$(elem).attr('data-status',"0");
			paymentsManagerObj.setLimitsBadgeStatus(false,[0,0],methodID)
		}else{
			//Si existen elementos no válidos aunque no sean de este tipo
			$(elem).attr('data-status',"2");
		}
	}


}

function on_unsupportedClient_functions(methodID,limitID,paymentsManagerObj,options){
	//console.log("val",methodID,limitID)
	var elem = paymentsManagerObj.getMethodDOMelem(methodID);
	var metodo = paymentsManagerObj.paymentsObj.getMethod(methodID);
	var strings = {
		applePayUnavailableTitle: options?.strings?.applePayUnavailableTitle ??	'<p>{t}No está disponible en este navegador{/t}</p>',
		applePayUnavailableMsg:	options?.strings?.applePayUnavailableMsg ??		'<p>{t}Usa un Safari y un dispositivo Apple compatible para realizar pagos con Apple Pay (https://support.apple.com/HT208531).{/t}</p>'
	}
	if(methodID == "apple_pay"){
		paymentsManagerObj.setMsg("apple_pay",limitID,strings.applePayUnavailableTitle,strings.applePayUnavailableMsg);
		let	m = paymentsManagerObj.getMethodDOMelem("apple_pay");
		let sm = paymentsManagerObj.getLimitDOMelem("apple_pay",limitID);
		$(m).find('form[data-payment-storage] [data-submit-payment]').remove();
	}
}

function on_validValues_functions(methodID,limitID,paymentsManagerObj,options){
	//console.log("val",methodID,limitID)
	var elem = paymentsManagerObj.getMethodDOMelem(methodID);
	var metodo = paymentsManagerObj.paymentsObj.getMethod(methodID);
	var minLimitNotReached = false;
	var minLimitCurrencyValue = 0;
	var vcToFundStr = "";
	var currencyValStr = "";
	var strings = {
		minLimitReachedMsg:		"<p>{t}El importe mínimo es de:{/t} <strong>%1</strong>. {t}La diferencia <strong>(%2)</strong> se añadirá a tu Saldo Virtual{/t} </p>",
	}

	if(typeof options != "undefined"){
		if(typeof options.minLimitNotReached != "undefined" && options.minLimitNotReached === true){ minLimitNotReached = true;	}
		if(typeof options.minLimitCurrencyValue != "undefined" ){ minLimitCurrencyValue = options.minLimitCurrencyValue	}
		if(typeof options.strings != "undefined"){
			if(typeof options.strings.minLimitReachedMsg != "undefined") 	{ strings.minLimitReachedMsg = options.strings.minLimitReachedMsg }
		}
	}
	if((!paymentsManagerObj.storedPayments.getMethod(methodID) || (!paymentsManagerObj.paymentsObj.isWithdrawal() && paymentsManagerObj.storedPayments.getMethod(methodID) && !paymentsManagerObj.storedPayments.getShowInPayments(methodID))) && paymentsManagerObj.getMethod(methodID).limits.length == 1){
		paymentsManagerObj.switchToDefaultMethods(methodID,limitID)
	}

	paymentsManagerObj.clearMsg(methodID,limitID)
	if(minLimitNotReached){
		var am = paymentsManagerObj.paymentsObj.getAmount();
		if(!paymentsManagerObj.getCurrencyObj()){
			currencyValStr = minLimitCurrencyValue + "€";
			vcToFundStr = minLimitCurrencyValue-am + "€";
		}else{
			currencyValStr = paymentsManagerObj.getCurrencyObj().getMoneda(parseFloat(minLimitCurrencyValue));
			vcToFundStr = paymentsManagerObj.getCurrencyObj().getMoneda(parseFloat(minLimitCurrencyValue-am));
		}

		paymentsManagerObj.setMsg(methodID,limitID,null,strings.minLimitReachedMsg,[currencyValStr,vcToFundStr]);
		paymentsManagerObj.setForceMinForMethod(methodID,limitID);
	}
	paymentsManagerObj.enableActionsForMethod(methodID,limitID);
	paymentsManagerObj.hideTotalOperation(methodID,limitID);
	paymentsManagerObj.hideForceMin(methodID,limitID);
	paymentsManagerObj.setNavElemStatus(null,methodID,limitID);
	paymentsManagerObj.showUsePreviousBalance(methodID,limitID);

	if(!paymentsManagerObj.isValidationMode()){

		if(!paymentsManagerObj.paymentsObj.isWithdrawal()){
			if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
				paymentsManagerObj.setStorageElemStatus(null,limitID,methodID,"default");
				if(paymentsManagerObj.getNavAutoSubmethod(methodID) == "auto"){
					if(paymentsManagerObj.storedPayments.getMethod(methodID)){

						if(paymentsManagerObj.getNavMethod(methodID) == "stored"){
							var selected  = paymentsManagerObj.storedPayments.getSelection(methodID);
							var submethod = selected.methodId;
							if(limitID == submethod){
								paymentsManagerObj.clearMsg(methodID,"default")
								if(minLimitNotReached){
									paymentsManagerObj.setMsg(methodID,"default",null,strings.minLimitReachedMsg,[currencyValStr,vcToFundStr]);
									paymentsManagerObj.setForceMinForMethod(methodID,"default");
								}
								paymentsManagerObj.enableActionsForMethod(methodID,"default");
								paymentsManagerObj.hideTotalOperation(methodID,"default");
								paymentsManagerObj.hideForceMin(methodID,"default");
								paymentsManagerObj.setPurchaseButtonAvailability(true,methodID,"default")
								paymentsManagerObj.setReadyForPurchase(true,methodID,submethod)
								paymentsManagerObj.showUsePreviousBalance(methodID,"default");
								if(paymentsManagerObj.storedPayments.cvvRequired(selected.id,selected.parentMethodId,submethod)){
									paymentsManagerObj.showRequiredFields(methodID,submethod);
								}else{
									paymentsManagerObj.hideRequiredFields(methodID);
								}
							}else{
								paymentsManagerObj.clearMsg(methodID,null)
							}
						}else if (paymentsManagerObj.getNavMethod(methodID) == "default"){
							paymentsManagerObj.setPurchaseButtonAvailability(true,methodID,limitID);
							if(minLimitNotReached){
/* 								paymentsManagerObj.setMsg(methodID,limitID,null,strings.minLimitReachedMsg,[currencyValStr,vcToFundStr]);
 */								paymentsManagerObj.setForceMinForMethod(methodID,limitID);
							}

						}
					}else{
						paymentsManagerObj.enableActionsForMethod(methodID,limitID);
						paymentsManagerObj.clearMsg(methodID,limitID)
						paymentsManagerObj.clearMsg(methodID,null)
						paymentsManagerObj.setPurchaseButtonAvailability(true,methodID,limitID);
						if(minLimitNotReached){
							paymentsManagerObj.setMsg(methodID,limitID,null,strings.minLimitReachedMsg,[currencyValStr,vcToFundStr]);
							paymentsManagerObj.setForceMinForMethod(methodID,limitID);
						}
					}
				}else{
					paymentsManagerObj.enableActionsForMethod(methodID,limitID);
					paymentsManagerObj.switchToDefaultMethods(methodID,limitID);
					paymentsManagerObj.setPurchaseButtonAvailability(true,methodID,limitID);
					if(minLimitNotReached){
						paymentsManagerObj.setForceMinForMethod(methodID,limitID);
					}
				}
			}else{
				paymentsManagerObj.setPurchaseButtonAvailability(true,methodID,limitID);
				if(minLimitNotReached){
					paymentsManagerObj.setForceMinForMethod(methodID,limitID);
					//paymentsManagerObj.setMsg(methodID,null,null,strings.minLimitReachedMsg,[currencyValStr,vcToFundStr]);

				}
				var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
/* 				if(!selected){
					paymentsManagerObj.clearMsg(methodID,null) */
				if(minLimitNotReached && selected && selected.methodId == limitID){
					paymentsManagerObj.setMsg(methodID,null,null,strings.minLimitReachedMsg,[currencyValStr,vcToFundStr]);
					paymentsManagerObj.showMsg(methodID,null);
				}else if(minLimitNotReached && !selected && paymentsManagerObj.storedPayments.getMethod(methodID) && paymentsManagerObj.getNavMethod(methodID) == "stored"){
					paymentsManagerObj.clearMsg(methodID,null);
				}else if(selected && selected.methodId == limitID){
					if(minLimitNotReached){
						paymentsManagerObj.setMsg(methodID,null,null,strings.minLimitReachedMsg,[currencyValStr,vcToFundStr]);
					}else{
						paymentsManagerObj.clearMsg(methodID,null)
					}

				}
			}
		}else{
			paymentsManagerObj.enableActionsForMethod(methodID,limitID);
			var isValid = true;
				if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
					var eLID = "default"
					var sLID = "default";
					var navMethod = paymentsManagerObj.getNavMethod(methodID);
					paymentsManagerObj.setStorageElemStatus(1,limitID,methodID,eLID);
					var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
					paymentsManagerObj.clearMsg(methodID,limitID)
					if(paymentsManagerObj.storedPayments.getMethod(methodID) && navMethod == "stored"){
						eLID = "default"
						if(!selected){
							paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,"default");
							paymentsManagerObj.clearMsg(methodID,null)
							isValid = false;
						}else if(selected && selected.methodId == limitID){
							paymentsManagerObj.clearMsg(methodID,null)
							paymentsManagerObj.setPurchaseButtonAvailability(true,methodID,"default");
							paymentsManagerObj.setReadyForPurchase(true,methodID,selected.methodId);
						}
					}else{
						eLID = limitID;
						paymentsManagerObj.clearMsg(methodID,null)
						paymentsManagerObj.setPurchaseButtonAvailability(true,methodID,limitID);
						paymentsManagerObj.setReadyForPurchase(true,methodID,limitID);

					}
				}else{
					var eLID = limitID;
					var sLID = null;
					var navMethod = paymentsManagerObj.getNavMethod(methodID);
					var selected = paymentsManagerObj.storedPayments.getSelection(methodID);
					if(paymentsManagerObj.storedPayments.getMethod(methodID) && navMethod == "stored"){
						eLID = null;
						if(!selected){
							paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,null);
							paymentsManagerObj.clearMsg(methodID,null)
							isValid = false;
						}else if(limitID == selected.methodId){
							paymentsManagerObj.setPurchaseButtonAvailability(true,methodID,null);
							paymentsManagerObj.setReadyForPurchase(true,methodID,selected.methodId)
							paymentsManagerObj.setStorageElemStatus(1,limitID,methodID,null);
						}
					}else{
						eLID = limitID
						paymentsManagerObj.setPurchaseButtonAvailability(true,methodID,limitID);
						paymentsManagerObj.setReadyForPurchase(true,methodID,limitID)
						paymentsManagerObj.setStorageElemStatus(1,limitID,methodID,limitID);
					}

				}


			paymentsManagerObj.showDocuments(true,methodID,eLID);

			if(paymentsManagerObj.getNavMethod(methodID,eLID) == "default"){
				var docStatus = paymentsManagerObj.paymentsObj.getProvidedDocumentsStatus(methodID);
				if((docStatus == null || typeof docStatus == "number") && isValid){
					paymentsManagerObj.setPurchaseButtonAvailability(true,methodID,eLID);
				}else{
					paymentsManagerObj.setPurchaseButtonAvailability(false,methodID,eLID);
				}
			}

		}


		//Escenarios:
		//Tanto si es autosubmétodo como si no, evaluamos la viabilidad global del método,
		//ya que si no es viable se deshabilitan todas las acciones en todos los casos.

		var method = paymentsManagerObj.getMethod(methodID);
		var submethods = JSON.parse(JSON.stringify(method.limits));
		var submethodsCount = 0;
		var expectedMethods = 0;
		//Como la viabilidad se evalua por submetódo tenemos que saber cuando se han evaluado todos
		//excepto "default" si es autosubmétodo. No lo tenemos en cuenta.
		expectedMethods = method.limits.length;
		submethodsCount = paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID).length;
		if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
			//Si es autosubmétodo, ignoramos el caso default, excepto si está establecido el submetodo en manual y la navegación default, entonces
			//lo tenemos que tener en cuenta.
			if(paymentsManagerObj.getNavAutoSubmethod() != "manual" && paymentsManagerObj.getNavMethod(methodID,limitID) != "default"){
				expectedMethods = expectedMethods - 1;
				submethodsCount = submethodsCount - 1;
			}
		}
		//Si el número de submétodos evaluados coincide con el número de submétodos, es que hemos terminado de evaluarlos
		//todos. Realizamos las acciones pertinentes que afecten a todos los submétodos.
		//if(expectedMethods == submethodsCount){
			//Si es autosubmétodo excluimos el caso default, para ignorar su estado en getDetailedAvailability()
			var defaultIndex = null;
			if(paymentsManagerObj.getNavAutoSubmethod() != "manual" && paymentsManagerObj.getNavMethod(methodID,limitID) != "default"){
				$(submethods).each(function(k,v){
					if(v.id == "default"){
						defaultIndex = k;
					}
				})
				if(defaultIndex != null){
					submethods.splice(defaultIndex,1);
				}
			}
			//Iniciamos el recuento para obtener si todos los submétodos comparte este mismo caso

			var falseElems = 0;
			var thisKindElems = 0;
			var critical = 0;
			var thisKindButMinReached = 0; //Como permitimos comprar si no llega al min, lo tenemos en cuenta aunque lo permitamos, para comprobaciones posteriores
			$(paymentsManagerObj.paymentsObj.getDetailedAvailability(methodID)).each(function(k,v){
				if(k != defaultIndex || defaultIndex == null){
					if(v === availability_available || v === availability_minReached){
						thisKindElems ++;
						if(v === availability_minReached){
							thisKindButMinReached ++;
						}
					}else if(v === availability_maxReached || v === availability_unavailable || v === availability_notEnoughRemaining){
						critical ++;
					}else if(v !== availability_available){
						falseElems++;
					}
				}
			})

/* 			paymentsManagerObj.clearMsg(methodID,null);
 */			paymentsManagerObj.enableActionsForMethod(methodID,null);
			$(elem).attr('data-status',"1");
			paymentsManagerObj.setLimitsBadgeStatus(false,[0,1],methodID);
			if(paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
				paymentsManagerObj.setStorageElemStatus(null,limitID,methodID,"default");
			}else{
				paymentsManagerObj.setStorageElemStatus(null,limitID,methodID,null);
			}

			if(thisKindElems == submethods.length){
				//Si todos los submétodos pertenecen a este caso
				//Deshabilitamos las acciones globales
/* 				paymentsManagerObj.clearMsg(methodID,null);
				paymentsManagerObj.enableActionsForMethod(methodID,null);
				$(elem).attr('data-status',"1");
				paymentsManagerObj.setLimitsBadgeStatus(false,[0,1],methodID);
				paymentsManagerObj.setStorageElemStatus(null,limitID,methodID,limitID); */
			}else if(critical == submethods.length){
					$(elem).attr('data-status',"0");
			}else{
				//Si existen elementos no válidos aunque no sean de este tipo
				$(elem).attr('data-status',"2");
				paymentsManagerObj.setLimitsBadgeStatus(false,[0,0],methodID)
				paymentsManagerObj.enableActionsForMethod(methodID,null);
			}

			if(expectedMethods == submethodsCount && thisKindElems == submethods.length && !paymentsManagerObj.paymentsObj.getAutoSubmethod(methodID)){
				if(thisKindButMinReached == 0){
					paymentsManagerObj.clearMsg(methodID);
				}
			}

		//}
	}else{
		//Si estamos en modo validación del método, aceptamos todo
		var elem = paymentsManagerObj.getMethodDOMelem(methodID);
		$(elem).attr('data-status',"1");
		paymentsManagerObj.setPurchaseButtonAvailability(true,methodID,limitID);
	}
}

function on_success_functions(e,paymentsManagerObj,options){
	if(typeof e != "undefined" && (typeof e.url != "undefined" || (typeof e.params != "undefined" && typeof e.params.url)) || typeof e.type != "undefined" ){
		//Como existe una redirección durante el pago, evitamos el mensaje de pago completado.
		var elemsObj = paymentsManagerObj.paymentsObj.getLastPaymentResult();
		if(elemsObj.submethod != null){
			var elemsDOM = paymentsManagerObj.getLimitDOMelem(elemsObj.method,elemsObj.submethod);
			$(elemsDOM).find('[data-status-msg]').html(paymentsManagerObj.paymentsObj.strings.wait);

		}else{
			var elemsDOM = paymentsManagerObj.getMethodDOMelem(elemsObj.method);
			$(elemsDOM).find('[data-payment-storage].is-active [data-status-msg]').html(paymentsManagerObj.paymentsObj.strings.wait);

		}
		//window.location.href = e.url;
	}
}

function on_fail_functions(e,paymentsManagerObj,options){
}

function toObject(arr) {
  var rv = {};
  for (var i = 0; i < arr.length; ++i)
    rv[i] = arr[i];
  return rv;
}


/************************************/
/* CLASE PARA CONTADORES DE BONUSES */
/************************************/
var fundingBonuses = function(minToStartApplying,maxBonusValue,percentageToBonify,currencyObj,options = {}){
	this.inputValue = 0;
	this.minToStartApplying = minToStartApplying;
	this.maxBonusValue = maxBonusValue;
	this.percentageToBonify = percentageToBonify;
	this.bonusValue = 0;
	this.currencyOb = null;
	if(typeof currencyObj != "undefined"){
		this.currencyOb = currencyObj;
	}
}
fundingBonuses.prototype.setValue = function(inputValue,renderElem){
	this.inputValue = parseFloat(inputValue);
	var	bonusValue = ((this.inputValue * this.percentageToBonify) / 100);
	var maxCalculated = ((this.maxBonusValue * this.percentageToBonify) / 100);
	if(this.inputValue >= this.minToStartApplying && bonusValue <= maxCalculated){
		this.bonusValue = bonusValue;
	}else if (this.inputValue < this.minToStartApplying) {
		this.bonusValue = 0;
	}else if (this.inputValue > this.maxBonusValue){//this.maxBonusValue){
		this.bonusValue = maxCalculated;//this.maxBonusValue;
	}
	if(typeof renderElem != "undefined"){
		this.renderValue($(renderElem));
	}else{
		return bonusValue;
	}
}
fundingBonuses.prototype.renderValue = function(elem){
	var self = this;
	if(!self.getCurrencyObj()){
		$(elem).html(this.bonusValue.formatMoney(2, '.', ','))
	}else{
		var amount = self.getCurrencyObj().getMoneda(parseFloat(this.bonusValue),null,{wrapper:"small"});
		$(elem).html(amount);
	}
}
fundingBonuses.prototype.getCurrencyObj = function(){
	var self = this;
	if(self.currencyOb != null){
		return self.currencyOb;
	}else{
		return false;
	}
}



var cardGateway = function(URL,importe,tpvId,options){
	/*
		Importe del carro,
		ID de nuestro tpv,
		id(number) de la cuenta PaySafe asociada a una tarjeta,
		single-use-key de Paysafe,
	*/
		this.isDebug = false;

		this.merchantAPIurl = URL;
		this.tpvId = tpvId;
		this.amount = importe;
		this.currency = "EUR";

		this.onErrorCallback = function(){}
		this.onSuccessCallback = function(){}
		this.onCloseCallback = function(e){}
		this.onGatewayLoadCallback = function(e){}
		this.instance = null;
		this.token = null;
		var self = this;

		this.render = false;
	/*
		//Si hay que renderizar contenido externo:
		render: {
			openInPopup:false|{			//si se abre en popup, hay que pasar el método y submétodo para poder acceder desde el modal a los items de los métodos
				method:1,
				submethod:2,
				injectionMethod: iframe|html
				callbackOnClosePopup:function(){}
			},
			selectorToInject: '[data-payment-externals][data-method="'+usedMethods.method+'"][data-submethod="'+usedMethods.submethod+'"] iframe[data-gateway]',

		}
	*/


		this.companyInfo = {};
		this.billingCycle = false; //Si hay pago recurrente
	/*
		billingCycle: {
			endDate: "2020-01-26",
			frequency: 5
		}
	*/
		this.language = "en_US";

		this.gatewayErrorStrings = {
			9064: "{t}La pasarela de pago está tardando en responder. Por favor, reinténtalo en unos segundos{/t}",
			9043: "{t}El nombre del titular no es válido{/t}",
			9044: "{t}El país del titular no es válido{/t}",
			9045: "{t}El código postal del titular no es válido{/t}",
			9064: "{t}Parece que hay dificultades para mostrar la pasarela de pago. Por favor reinténtalo en unos segundos, o prueba a recargar la página y a repetir la operación. En ambos casos asegúrate de que tu navegador esté actualizado y no esté bloqueando elementos.{/t}",
			9110: "{t}Ha habido un problema al iniciar el pago 3D secure. Prueba a reintentarlo pasados unos minutos, o prueba a recargar la página y a repetir la operación. En ambos casos asegúrate de que tu navegador esté actualizado y no esté bloqueando elementos.{/t}",
			"default": "{t}Ha ocurrido un error al procesar el pago. Contacte con soporte{/t}"
		}

		this.card = false;
		this.neteller = false;
		this.skrill = false;
		this.nuvei_sdk = false;
		this.nuvei_gateway = false;
	/*		"card": {
				"merchantAccountID":12345511,
				"cardHolderName":"John Doe",
				"usePreviousBalance: true|false|optional
			}
	*/
	/*		"neteller": {
				"consumerId":"neteller.account@example.org",
				"detail1Description":"Details 1 description",
				"detail1Text":"Details 1 text"
			}
	*/
	/*		"skrill": {
				"transactionId":""	//Referencia compra
				"amount":""
				"payFromEmail":"",
				"payToEmail":"",
				"returnUrl":"" 	//URL para ir en COMPRAOK
				"cancelUrl":"" 	//URL para ir en COMPRAKO
				"renderTo":""	//iFrame selector to render checkout

			}
	*/

		this.popUpSelector = '[data-paymentsPopup]';


		if(typeof options != "undefined" ){

			if(typeof options.render != "undefined"){
				this.render = {}
				if(typeof options.render.selectorToInject != "undefined"){
					this.render["selectorToInject"] = options.render.selectorToInject;
				}
				if(typeof options.render.openInPopup != "undefined" && options.render.openInPopup != false){

					this.render["openInPopup"] = {}
					this.render.openInPopup["method"] = options.render.openInPopup.method;
					this.render.openInPopup["submethod"] = options.render.openInPopup.submethod;
					if(typeof options.render.openInPopup.injectionMethod != "undefined"){
						this.render.openInPopup["injectionMethod"] = options.render.openInPopup.injectionMethod;
					}else{
						this.render.openInPopup["injectionMethod"] = "iframe";
					}
					if(typeof options.render.openInPopup.callbackOnClosePopup != "undefined"){
						this.render.openInPopup["callbackOnClosePopup"] = options.render.openInPopup.callbackOnClosePopup;
					}else{
						this.render.openInPopup["callbackOnClosePopup"] = function(){}
					}
					this.render.openInPopup["submethod"] = options.render.openInPopup.submethod;
					if(typeof options.render.openInPopup.width != "undefined"){
						this.render.openInPopup["width"] =  options.render.openInPopup.width;
					}
					if(typeof options.render.openInPopup.height != "undefined"){
						this.render.openInPopup["height"] =  options.render.openInPopup.height;
					}
					if(typeof options.render.openInPopup.allowClose != "undefined" && options.render.openInPopup.allowClose === true){
						this.render.openInPopup.allowClose =  true;
					}else{
						this.render.openInPopup["allowClose"] =  false;
					}
					var iframeDom = this.popUpSelector+" "+this.render.selectorToInject;
					if(this.render.openInPopup.injectionMethod == "iframe"){
						$(this.popUpSelector).attr('data-iframed','')
						if( $(iframeDom).find('iframe').length == 0 ){
							$(iframeDom).append("<iframe></iframe>");
						}
					}else if(this.render.openInPopup.injectionMethod == "html"){
						$(iframeDom).empty();
						$(iframeDom).append("<div data-injectedContent></div>");
					}
					var prevStyle = "";


						if(typeof this.render.openInPopup.width != "undefined"){
							if(typeof $(this.popUpSelector).attr('style') != "undefined"){
								var prevStyle = $(this.popUpSelector).attr('style');
							}
							$(this.popUpSelector).attr('style',prevStyle + " ;max-width:"+this.render.openInPopup.width+"!important");
						}
						if(typeof this.render.openInPopup.height != "undefined"){
							if(typeof $(this.popUpSelector).attr('style') != "undefined"){
								var prevStyle = $(this.popUpSelector).attr('style');
							}
							$(this.popUpSelector).attr('style',prevStyle + " ;max-height:"+this.render.openInPopup.height+"!important");
						}

					$(document).on('open.zf.reveal',this.popUpSelector,function(){
						if(!Foundation.MediaQuery.atLeast('medium') && typeof $(self.popUpSelector).attr('data-iframed') != "undefined"){
							$(iframeDom+":visible").css('padding-top',$(self.popUpSelector+":visible").find('[data-modal-title]').outerHeight()+"px")
						}
						$(self.popUpSelector).closest('.reveal-overlay').appendTo('body');
	// 					if(self.render.openInPopup.) añadir aqui parametro de quitar o mostrar boton de cierre
						if(!self.render.openInPopup.allowClose){
							$(self.popUpSelector).find('[data-core_reveal-close]').remove();
						}
					})
					$(document).off('closed.zf.reveal',this.popUpSelector).on('closed.zf.reveal',this.popUpSelector,function(){
						$(iframeDom).removeAttr('style');
						$(self.popUpSelector).removeAttr('data-iframed')
						self.render.openInPopup.callbackOnClosePopup();
						$(iframeDom).find('iframe').remove();
					})

				}else{
					this.render["openInPopup"] = false;
				}

			}

			if(typeof options.company != "undefined" && typeof options.company.name != "undefined"){
				this.companyInfo["name"] = options.company.name;
			}

			if(typeof options.company != "undefined" && typeof options.company.logoURL != "undefined"){
				this.companyInfo["logoURL"] = options.company.logoURL;
			}

			if(typeof options.company != "undefined" && typeof options.company.color != "undefined"){
				this.companyInfo["color"] = options.company.color;
			}
			if(typeof options.currency != "undefined"){
				this.currency = options.currency;
			}
			if(typeof options.language != "undefined"){
				if(options.language == "es_ES" || options.language == "fr_CA")
				this.language = options.language;
			}

			if(typeof options.onErrorCallback != "undefined"){
				this.onErrorCallback = options.onErrorCallback;
			}

			if(typeof options.onSuccessCallback != "undefined"){
				this.onSuccessCallback = options.onSuccessCallback;
			}
			if(typeof options.onResultCallback != "undefined"){	//Algunas plataformas usan un callback único para resultados de la operación
				this.onResultCallback = options.onResultCallback;
			}
			if(typeof options.onCloseCallback != "undefined"){
				this.onCloseCallback = options.onCloseCallback;
			}

			if(typeof options.onGatewayLoadCallback != "undefined"){
				this.onGatewayLoadCallback = options.onGatewayLoadCallback;
			}

			if(typeof options.gatewayErrorStrings != "undefined"){
				this.gatewayErrorStrings = options.gatewayErrorStrings;
			}

			if(typeof options.billingCycle != "undefined"){
				this.billingCycle = options.billingCycle;
			}

			if(typeof options.debug != "undefined" && options.debug === true){
				this.isDebug = true;
			}



			if(typeof options.card != "undefined"){
				if(typeof options.card.merchantAccountID != "undefined" && typeof options.card.cardHolderName){
					self.card = {}
					self.card["merchantAccountID"] = options.card.merchantAccountID;
					self.card["cardHolderName"] = options.card.cardHolderName;
					self.card["key"] =  options.card.key;
					self.card["zip"] =  options.card.zip;
					self.card["country"] = 	 options.card.country;
					self.card["state"] = 	 options.card.state;
				}
				if(typeof options.card.usePreviousBalance != "undefined"){
					self.card["usePreviousBalance"] = options.card.usePreviousBalance;
				}
			}

			if(typeof options.neteller != "undefined"){
	/*
				if(typeof options.neteller.consumerId != "undefined" && options.neteller.merchantRefNum){
					self.neteller = {}
					self.neteller["consumerId"] = options.neteller.consumerId
					self.neteller["merchantRefNum"] = options.neteller.merchantRefNum
				}

				if(typeof options.neteller.detail1Description != "undefined"){
					self.neteller["detail1Description"] = options.neteller.detail1Description
				}
				if(typeof options.neteller.detail1Text != "undefined"){
					self.neteller["detail1Text"] = options.neteller.detail1Text
				}
	*/
			}

			if(typeof options.skrill != "undefined"){
				self.skrill = options.skrill;
			}

			if(typeof options.nuvei_gateway != "undefined"){
				self.nuvei_gateway = options.nuvei_gateway;
			}
			if(typeof options.nuvei_sdk != "undefined"){
				self.nuvei_sdk = options.nuvei_sdk;
			}
		}


	}
	cardGateway.prototype.getIsDebug = function(){
		return this.isDebug;
	}

	cardGateway.prototype.init = function(){
		var self = this;



		/*
			var options = {
				company: {
					name: e.companyName,
					logoURL : e.logoURL,
					color: e.companyColor
				},
				onErrorCallback: function(e,error){
				},
				onCloseCallback: function(stage){
				},
				onSuccessCallback: function(e){
				},
				gatewayErrorStrings: gatewayStrings,
				billingCycle: {
					endDate: "2020-01-26",
					frequency: 5
				}
			}
		*/
		if(self.card){
			 var options = {
				  amount: self.amount,
				  currency: self.currency,
				  environment: "TEST",
				  holderName: self.card.cardHolderName,
				  billingAddress:{				//REQUERIDO PARA 3DSECURE
					  country: self.card.country,				//CODIGO ISO DE PAÍS EN MAYUSCULAS
					  zip: self.card.zip,
					  useAsShippingAddress:true
				  },
				  threeDS:{						//REQUERIDO PARA 3DSECURE
					  useThreeDSecureVersion2:true,
					  transactionIntent:"GOODS_OR_SERVICE_PURCHASE"
				  },
				  locale: self.language,
				  accounts: {
					  CC: self.card.merchantAccountID
				  },
				  preferredPaymentMethod: "Cards",
			 }
			 if(self.card.state) {
				options["billingAddress"]["state"] = self.card.state;
			 }
			if(self.getIsDebug() === false){
				options["environment"] = "LIVE";
			}else if(self.getIsDebug() === true){
				options["environment"] = "TEST";
			}
		}

		if(self.neteller){
			 var options = {
				  amount: self.amount,
				  merchantRefNum: self.neteller.merchantRefNum,
				  currency: self.currency,
				  environment: "TEST",
				  billingAddress:{				//REQUERIDO PARA 3DSECURE
					  country: self.country,				//CODIGO ISO DE PAÍS EN MAYUSCULAS
					  zip: self.zip,
					  useAsShippingAddress:true
				  },
				  locale: self.language,
				  paymentMethodDetails: {
					  neteller:self.neteller
				  }		 }
			if(self.getIsDebug() === false){
				options["environment"] = "LIVE";
			}else if(self.getIsDebug() === true){
				options["environment"] = "TEST";
			}
		}

		if(self.nuvei_gateway){
			var options = self.nuvei_gateway;

		}

		if(self.nuvei_sdk){
			var options = self.nuvei_sdk;
		}

		if(self.skrill){
			var options = {
				sid: self.skrill.sid,
			  }
			if(self.getIsDebug() === false){
				options["environment"] = "LIVE";
			}else if(self.getIsDebug() === true){
				options["environment"] = "TEST";
			}
		}

		if(Object.keys(self.companyInfo).length > 0){
			if(typeof self.companyInfo["name"] != "undefined"){
				options["companyName"] = self.companyInfo["name"];
			}
			if(typeof self.companyInfo["logoURL"] != "undefined"){
				options["imageUrl"] = self.companyInfo["logoURL"];
			}
			if(typeof self.companyInfo["color"] != "undefined"){
				options["buttonColor"] = self.companyInfo["color"];
			}
		}


		if(self.billingCycle != false){
			options["threeDS"]["billingCycle"] = self.billingCycle;
			options["threeDS"]["authenticationPurpose"] = "INSTALMENT_TRANSACTION";
			options["threeDS"]["maxAuthorizationsForInstalmentPayment"] = 5;
		}
		if(self.card){	//PASARELA PAYSAFE POR TARJETA
			paysafe.checkout.setup(self.card.key, options,function(instance, error, result) {

				if(error){
					self.catchError(error);
				}else{
					self.instance = instance;

					if (result.token) {
					  self.token = result.token
						if (result.paymentMethod=="Cards") {
							var extraFields = {
									data:{
										paymentToken: self.token
									},
									refPago: self.tpvId

								}

							if(typeof self.card.usePreviousBalance != "undefined"){
								extraFields["usePreviousBalance"] = self.card.usePreviousBalance;
							}

							var merchantAPIforme = new formeSubmit(false,self.merchantAPIurl,{
								sendDataAsJSON:true,
								extraFields: extraFields,
								callbackOnSuccess:	function(e){
									self.onSuccessCallback(e);
								},
								callbackOnError:function(e){
									if(typeof e !="undefined" && typeof e.error != "undefined"){
										self.catchError({code:'custom',description:e.error});
									}else{
										self.catchError({code:'default'});
									}
									instance.close();
								},
								callbackOnFail: 	function(e){
									self.onErrorCallback(self,e.error);
									instance.close();
								}
							})
							// use AJAX to send result.token to your merchant server to take CC payment
						}
					} else {
						self.catchError({code:"default"})
						instance.close();
						// error handling
					}
				}
			}, self.onCloseCallback);
		}
		if(self.nuvei_gateway){
			var nuveiApiParams = $.param(self.nuvei_gateway);
			if(self.isDebug){
				var nuveiApiURL = "https://ppp-test.safecharge.com/ppp/purchase.do?" + nuveiApiParams
			} else {
				var nuveiApiURL = "https://secure.safecharge.com/ppp/purchase.do?" + nuveiApiParams
			}

	/*
			if(typeof self.render != "undefined" && self.render){
				if(this.render.openInPopup){
					var inject = self.popUpSelector+" "+self.render.selectorToInject;
					if(this.render.openInPopup.injectionMethod == "html"){
						options["renderTo"] = inject + " [data-injectedContent]";
					}else{
						$(inject).find('iframe').prop('src',nuveiApiURL);

					}
					$(self.popUpSelector).core_reveal("open");
				}else{
					 window.location.href = nuveiApiURL;
				}
			}
	*/
			window.location.href = nuveiApiURL;

		}
		if(self.nuvei_sdk){
			self.onGatewayLoadCallback(self);
			if(typeof self.render != "undefined" && self.render){
				if(this.render.openInPopup){
					var inject = self.popUpSelector+" "+self.render.selectorToInject;
					if(this.render.openInPopup.injectionMethod == "html"){
						options["renderTo"] = inject + " [data-injectedContent]";
					}else{
						$(inject).find('iframe').prop('src',nuveiApiURL)
					}
					$(self.popUpSelector).core_reveal("open");
				}else{
					options["renderTo"] = self.render.selectorToInject;
				}
			}
			checkout(options);
		}
		if(self.skrill){
			var sid = self.skrill.sid;
			var skrillApiURL = "https://pay.skrill.com?sid="+sid;

			if(typeof self.render != "undefined" && self.render){
				if(this.render.openInPopup){
					var iframeDom = self.popUpSelector+" "+self.render.selectorToInject;
					$(iframeDom).find('iframe').prop('src',skrillApiURL)
					$(self.popUpSelector).core_reveal("open");
				}else{
					var iframeDom = this.render.selectorToInject;
					$(iframeDom).append("<iframe></iframe>")
					$(iframeDom).find('iframe').prop('src',skrillApiURL)
					$(iframeDom).addClass('is-active');
				}
			}
			self.onGatewayLoadCallback(self);
		}
	}
	cardGateway.prototype.close = function(){
		$(this.popUpSelector).core_reveal("close");
	}
	cardGateway.prototype.open = function(type){
		var self = this;

		if(self.card){
			$.getScript("https://hosted.paysafe.com/checkout/v1/latest/paysafe.checkout.min.js",function(){
				self.init();
			})
		}
		if(self.skrill){
			self.init();
		}
		if(self.nuvei_gateway){
			self.init();
		}
		if(self.nuvei_sdk){
			if(typeof checkout != "undefined"){
				self.init();
			}else{
				var script = document.createElement('script');
				script.onload = function () {
					self.init();
				};
				if($('[data-externalScript="nuvei"]').length == 0){
					script.src = "https://cdn.safecharge.com/safecharge_resources/v1/checkout/checkout.js";
					script.setAttribute("data-externalScript", "nuvei")
					document.head.appendChild(script); //or something of the likes
				}

			}
		}
	}
	cardGateway.prototype.getToken = function(){
		var self = this;
		self.instance.tokenize(function(instance, error, result){
			if (error) {
				// display the tokenization error in dialog window
	// 		    alert(JSON.stringify(error));
				self.catchError(error)
			  } else {
				// write the Payment token value to the browser console
				self.token=result.token;
				//console.log(result.token);
			  }
		})
	}
	cardGateway.prototype.catchError = function(error){
	/*
		error:{
			code: 3882,					number|default|custom 	Si number no está en la cadena de traducción, se transforma en default
			description: "xxxxxxxxx"	si es custom,  este valor incluye la descripción
		}
	*/

		var payloadURL = "/data/?action=paymentManager&mode=error";

		var code = null;
		var desc = null;

		var self = this;
		if(typeof self.gatewayErrorStrings[error.code] != "undefined"){
			if(error.code != "default"){
				var errorToDisplay = "(" + error.code + ") " + self.gatewayErrorStrings[error.code];
				code= error.code;
				desc = self.gatewayErrorStrings[error.code];
			}else{
				var errorToDisplay = self.gatewayErrorStrings[error.code];
				desc = self.gatewayErrorStrings[error.code];
			}
		}else{
			if(error.code != "custom"){
				var errorToDisplay = "(" + error.code + ") " +  self.gatewayErrorStrings.default;
				code = error.code;
				desc = self.gatewayErrorStrings.default;
			}else{
				var errorToDisplay = error.description;
				desc = error.description;
			}
		}
		var errorPayload = new paymentErrorPayload(this.tpvId,desc,code);
		var errorReport = new formeSubmit(false,payloadURL,{
			extraFields:errorPayload,
			sendDataAsJSON: true
		})
		this.onErrorCallback(self,errorToDisplay);
	}

	class paymentErrorPayload{
		constructor(refPago,errorDescription,errorCode,operationId){
			this.errorCode = null;
			this.errorDescription = null;
			this.operationId = null;
			this.refPago = null;

			var resultObj = {}
			var tempObj = {}

			if(typeof errorDescription != "undefined"){ this.errorDescription = errorDescription }
			if(typeof refPago != "undefined"){ this.refPago = refPago }
			if(typeof errorCode != "undefined"){ this.errorCode = errorCode }
			if(typeof operationId != "undefined"){ this.operationId = operationId }

			if(this.errorCode != null){ tempObj["code"] = this.errorCode; }
			if(this.errorDescription != null){ tempObj["description"] = this.errorDescription; }
			if(this.operationId != null){ tempObj["operationId"] = this.operationId; }
			if(this.refPago != null){ resultObj["refPago"] = this.refPago; }
			if(Object.keys(tempObj).length > 0){
				resultObj["data"] = tempObj;
			}

			return resultObj;

		}

	}
	class paymentsGatewayManager {
		//Dependencias: async_lib.js, reveal.js

		constructor (paymentsManagerObj,paymentMethodDomElem){
			this.elem = paymentMethodDomElem;
			this.paymentsManagerObj = 	paymentsManagerObj;
			this.popupSelectorName = 	"data-payments-popup";	//Nombre del selector que se asignará a popups creados (excluye los que contienen iFrames, que se abren con su propio selector)
			this.operationTimeOut = 	15000;
			this.timeOutHandler	=		null;
		}

		throwError(){

		}
		getPaymentsManagerObj(){
			return this.paymentsManagerObj;
		}
		removePopUp(popupSelector){
			$(`[data-reveal]${popupSelector}`).remove();
			$(`[data-reveal]${popupSelector}`).parent('.reveal-overlay').remove();
		}
		openPopUp(id,contents,title = null,callback,options){
			//Abre un popup nuevo
			//Opciones:
			//	iFramed: {						//Asume que existe un modal existente con un iframe dentro (necesario por politicas de seguridad entre sitios)
			//				url: null|string	//Opcional
			//	},
			// Classes: [String]				//Array con clases que se van a añadir

			var self = this;
			var popUpSelector = '#' + id;
			var injectionInto = "body";
			var contents = 	contents ?? ""
			var iframeURL = options?.iFramed?.url ?? null;
			var iframed =	options?.iFramed ? true : null;
			var onOpenCallback = callback ?? function(){}
			var closeable = options?.closeable ?? true;
			let classes = options?.classes ?? [];	//[string], array con clases para añadir

			if($(injectionInto + " " + popUpSelector).length ==0 && !iframed){
				let titleHTML,closeHTML;
				titleHTML = closeHTML = '';
				if(closeable){
					closeHTML = `<button class="white right icon-slim-times-outline core_txtSize_2" data-core_reveal-close style="margin-right:0.2rem;position: absolute;right:0px;top:0.2rem" type="button"></button>`;
				}
				if(title){
					titleHTML = `<div class="core_panel core_halfThin bg_coal text-center" data-modal-title>
									<strong class="white core_smooth">${title}</strong>
									<div class="clearfix"></div>
								</div>
								<hr class="core_spaceTzero core*_spaceBzero">`
				}
				var html =	`
							${titleHTML}
							${closeHTML}
							<div data-modal-content>
								${contents}
							</div>`
				html = `<div id="${id}" ${self.popupSelectorName} data-reveal class="reveal ${classes.join(' ')}" data-close-on-click="false" data-close-on-esc="false"> ${html}</div>`;
				$(injectionInto).append(html);
				var gwpop = new core_reveal();
				$(popUpSelector).core_reveal('open');
				onOpenCallback();
			}else if(!iframed){
				$(popUpSelector).core_reveal('open');
				onOpenCallback();
			}
			if(iframed){
				//Añadimos self.popupSelectorName para tener todos los modales bajo el mismo contexto
				$(popUpSelector).attr(self.popupSelectorName,"");
				if(iframeURL){
					$(popUpSelector).find('iframe').attr('src',iframeURL);
				}
				onOpenCallback();
				$(popUpSelector).core_reveal('open');
			}
		}

		closePopUp(removeOrphans = false){
			//removeOrphans: algunos métodos como googlePay cierra el modal pero deja el reveal-overlay.
			//Estableciendo este método a true, elimina los reveal-overlay que no tengan contanido dentro
			var self = this;
			var popUpElem = $('[' + self.popupSelectorName + ']')
			$(popUpElem).core_reveal('close');
			$(popUpElem).remove();
			if(removeOrphans){
				$('.reveal-overlay').each( function(){
					if($(this).contents().length == 0){
						$(this).remove();
					}
				})
			}
		}

		setPopUpSrc(url,callback){
			//Para popUps con iFrame embebido, establece su url
			var self = this;
			var popUpElem = $('[' + self.popupSelectorName + '] iframe');
			$(popUpElem).onload = callback(self);
			$(popUpElem).attr('src',url);
		}

		canAccessIframe(iframeElem){
			try {
				return !!(iframeElem.contentDocument);
			}catch(e){
				return false;
			}
		}
/* 		registerPlugin(pluginName,argumentsArray){
			try{
				var pluginNamez = eval(pluginName);
				var plugin = new pluginNamez(...argumentsArray);
				this[pluginName] = plugin;
			}catch(exception){
				console.log("EXCEPCION:",exception)
			}
		} */

		load_SDKjs(SDKjsURL,callbackOnSDKJsLoad,tag){
			var script = document.createElement('script');
			script.onload = function () {
				callbackOnSDKJsLoad(this);
			};
			script.setAttribute('type', 'text/javascript');
			script.setAttribute('src', SDKjsURL);
			if(typeof tag != "undefined"){
				script.setAttribute(tag,'');
			}
			document.head.appendChild(script);
		}

		errorsHandling(errorPayloadObj,callbackOnPaymentFailure,callbackScope){
			var self = this;
			var cbScope = null;
			var cbOnFail = function(){};
			if(typeof callbackScope != "undefined"){ cbScope = callbackScope }
			if(typeof callbackOnPaymentFailure != "undefined"){ cbOnFail = callbackOnPaymentFailure}
			if(typeof callbackScope != "undefined" && callbackScope.xhrHandler != null){
				self.xhrHandler.abort();
			}
			var payloadURL =	 "/data/?action=paymentManager&mode=error";

			var errorReport = new formeSubmit(false,payloadURL,{
				extraFields:errorPayloadObj,
				sendDataAsJSON: true,
				statusMsg:{
					elem: self.getAsyncMsgsElem()
				},
				callbackOnSuccess: function(e){
					if(typeof e.type == "undefined"){
						//self.setAsyncMsgElem(e.error);
						self.paymentsManagerObj.unblockAllMethods();
						self.setSubmitBtState(true);
					}else{
						cbOnFail(e);
					}

				},
				callbackOnFail: function(e){
					self.setSubmitBtState(true);
				}
			})
		}

		getAsyncMsgsElem(){
			var self = this;
			var subM = self.paymentsManagerObj.getSelectedLimitId();
			var m = self.paymentsManagerObj.getSelectedMethodId();
			if((m != null && m != false) || (subM != null && subM != false)){
				if(subM != null && subM){
					var item = self.paymentsManagerObj.getLimitDOMelem(m,subM)
					var statusMsg = $(item).find('[data-status-msg]');
				}else{
					var item = self.paymentsManagerObj.getMethodDOMelem(m)
					var statusMsg = $(item).find('[data-payment-storage].is-active [data-status-msg]')
				}
			}else{
				//Si método y submétodo son null, preguntamos por si estuviera actuando un "QuickPayment"
				if($("[data-quickpaymanager]").length > 0){
					var statusMsg = $("[data-quickpaymanager] form[data-payment-storage] [data-status-msg]");
				}
			}
			if($(statusMsg).length > 0){
				return statusMsg;
			}
			return false;
		}

		clearAsyncMsg(){
			var elem = this.getAsyncMsgsElem();
			$(elem).hide().empty();
		}

		setAsyncMsgElem(content,msgStyle){
			var elem = this.getAsyncMsgsElem();
			$(elem).html(content).removeClass('success alert warning')
			if(typeof msgStyle != "undefined"){
				switch(msgStyle){
					case "alert":
						$(elem).html(content).addClass('alert');
					break;
					case "success":
						$(elem).html(content).addClass('success');
					break;
					case "warning":
						$(elem).html(content).addClass('warning');
					break;
					case "default":
					break;
				}
			}
		}
		getSubmitBtElem(){
			var self = this;
			var subM = self.paymentsManagerObj.getSelectedLimitId();
			var m = self.paymentsManagerObj.getSelectedMethodId();
			if((m != null && m != false) || (subM != null && subM != false)){
				if(subM != null && subM){
					var item = self.paymentsManagerObj.getLimitDOMelem(m,subM)
					var submitBt = $(item).find('[data-submit-payment]');
				}else{
					var item = self.paymentsManagerObj.getMethodDOMelem(m);
					var submitBt = $(item).find('[data-payment-storage].is-active [data-submit-payment]');
				}
			}else{
				//Si método y submétodo son null, preguntamos por si estuviera actuando un "QuickPayment"
				if($("[data-quickpaymanager]").length > 0){
					var submitBt = $("[data-quickpaymanager] form[data-payment-storage] [data-submit-payment]");
				}
			}

			if($(submitBt).length > 0){
				return submitBt;
			}
			return false;
		}
		setSubmitBtState(state){
			var self = this;
			var m = self.paymentsManagerObj.getSelectedMethodId();
			var submitBt = self.getSubmitBtElem()

			if(submitBt && $(submitBt).length > 0){
				if(state){
					self.paymentsManagerObj.unblockAllMethods(false);
					$(submitBt).removeAttr('disabled')
				}else{
					self.paymentsManagerObj.blockAllMethods(false);
					//var item = self.paymentsManagerObj.getMethodFromDOM(self.elem)
					if(m != null && m != false){
						self.paymentsManagerObj.unblockMethod(m,false)
					}
					$(submitBt).attr('disabled','disabled')
				}
			}
			return false;
		}

		initWatch(callbackScope,operationTimeOutInMs,transactionId){
			var self = this;
			if(self.timeOutHandler != null){
				self.stopWatch();
			}
			self.timeOutHandler = setTimeout(function(){
				self.stopWatch();
				self.errorsHandling(new paymentErrorPayload(transactionId,"operation TIMED OUT"),callbackScope);
			},operationTimeOutInMs)
		}
		stopWatch(){
			var self = this;
			clearTimeout(self.timeOutHandler);
		}

		removeIframeMsgActions(selector){
			const items = document.querySelectorAll;
			for(const elem in items){
				const elems = getEventListeners(item)?.onMessage;
				for(const eventItem in elems){
					eventItem.removeEventListener("message",eventItem.listener);
				}
			}
		}

		registerIframeMsgAction(message,callback){
			window.addEventListener('message',() => {
				callback();
			})
		}

		sendIframeToParent(message){
			window.top.postMessage(message, '*');
		}

		sendParentToIframe(message,iframeElem){
			iframeElem.contentWindow.postMessage(message,'*');
		}
	}

	class threeDSPlugin_paysafe {
		//Dependencias: async_lib.js

		constructor (paymentsGatewayManagerObj,accountID,cardBIN,APIkey,transactionID,callbackOnFailure,options){
			this.pgwm = paymentsGatewayManagerObj;
			this.SDKjsURL = 	"https://hosted.paysafe.com/threedsecure/js/latest/paysafe.threedsecure.min.js";
			this.transactionId = 	transactionID
			this.cardBIN = 			cardBIN;
			this.APIkey = 			APIkey;
			this.accountId =		accountID;
			this.debug = 			false;
			this.operationTimeOut = 15000;
			this.timeOutHandler	=	null;
			this.xhrHandler = 		null;
			this.callbackOnPaymentFailure = callbackOnFailure;

			if(typeof options != "undefined"){
				if(typeof options.debug != "undefined" && options.debug === true){
					this.debug = true;
				}

			}

			this.setup(this.accountId,this.cardBIN,this.APIkey);
		}

		setup(accountID,cardBIN,APIkey){
			var self = this;
			var setupOptions = {}
/* 			console.log('init')
 */			if(self.debug){ setupOptions["environment"] = "TEST" }else{ setupOptions["environment"] = "LIVE" }
			setupOptions["accountId"] = accountID;
			setupOptions["card"] = {
				cardBin: cardBIN
			};
			self.pgwm.load_SDKjs(self.SDKjsURL,function(){
				self.pgwm.setSubmitBtState(false);
				self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.wait)
				paysafe.threedsecure.start(APIkey,setupOptions,function(fingerPrintId,error){
					if(typeof fingerPrintId != "undefined"){
						self.sendAuthenticationCall(fingerPrintId,self.transactionId);
					}else{
						self.pgwm.errorsHandling(new paymentErrorPayload(self.transactionId,error.displayMessage,error.code,error.correlationId),self.callbackOnPaymentFailure);
					}
				});
			})
		}

		sendAuthenticationCall(fingerPrintId,transactionID){
			var url = "/data/?action=paymentManager&mode=continuePayment";
			var payload = new formeSubmit(false,url,{
				sendDataAsJSON: true,
				extraFields: {
					data: 			fingerPrintId,
					refPago:		transactionID
				},
				statusMsg: {
					elem: self.pgwm.getAsyncMsgsElem()
				},
				callbackOnSuccess: function(e){
					self.pgwm.setSubmitBtState(false);
				},
				callbackOnFail: function(e){
					self.pgwm.setSubmitBtState(true);
					self.pgwm.setAsyncMsgElem(e.error,"alert");
					self.pgwm.setSubmitBtState(true);
				}
			})
			self.xhrHandler = payload.getXHR();

		}

		sendChallenge(APIkey,sdkChallengePayload){
			var self = this;
			var setupOptions = {}
			if(self.debug){ setupOptions["environment"] = "TEST" }else{ setupOptions["environment"] = "LIVE" }
			setupOptions["sdkChallengePayload"] = sdkChallengePayload;
			paysafe.threedsecure.challenge(APIkey,setupOptions,function(id,error){
				if(typeof id != "undefined"){
					//console.log("id:",id)
				}else{
					self.pgwm.errorsHandling(new paymentErrorPayload(self.transactionId,error),self.callbackOnPaymentFailure);
				}
			})
		}
	}

	class threeDSPlugin_trust_googlePay {
		constructor (paymentsGatewayManagerObj,jwt,transactionID,paymentParams,callbackOnFailure,options){
			this.pgwm = paymentsGatewayManagerObj;
			this.SDKjsURL = 		"https://cdn.eu.trustpayments.com/js/latest/st.js";
			this.transactionId = 	transactionID
			this.containerAttr = 	"data-trustpaymentgpay-container";
			this.debug = 			false;
			this.elem = 			null;
			this.backendURL = 		"";//backendURL;
			this.operationTimeOut = 15000;
			this.xhrHandler = 		null;
			this.callbackOnPaymentFailure = callbackOnFailure;
			this.gpaySetup = 		{};
			this.country = 			paymentParams.country;
			this.currency = 		paymentParams.currency;
			this.amount = 			paymentParams.amount;
			this.allowedCards = 	paymentParams.allowedCards;
			this.gwMerchantId = 	paymentParams.gwMerchantId;
			this.gpMerchantId =		paymentParams.gpMerchantId;
			this.loaderURL = 		"//cdn.inicium.com/images/common/loaders/tail-spin.svg";
			if(typeof options != "undefined"){
				if(typeof options.debug != "undefined" && options.debug === true){
					this.debug = true;
				}
				if(typeof options.elem != "undefined"){
					this.elem = options.elem;
				}

			}
			this.setup(jwt);
		}
		setup(jwt){
			var self = this;
			var setupOptions = {}
			self.clean();
			self.pgwm.setSubmitBtState(false);
			self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.wait)
			self.buildServerSideForm("body",jwt);
			self.gpaySetup = {
				buttonOptions: {
					"buttonRootNode": "st-google-pay",
					buttonColor: 'white',
					buttonSizeMode: 'fill'
				},
				paymentRequest: {
					environment: self.debug ? "TEST" : "PRODUCTION",
					allowedPaymentMethods: [{
						"parameters": {
						  "allowedAuthMethods": ["PAN_ONLY", "CRYPTOGRAM_3DS"],
						  "allowedCardNetworks": self.allowedCards,
						},
						"tokenizationSpecification": {
						  "parameters": {
							"gateway": "trustpayments",
							"gatewayMerchantId": self.gwMerchantId
						  },
						  "type": "PAYMENT_GATEWAY"
						},
						"type": "CARD"
					}],
					merchantInfo: {
						merchantId: self.gpMerchantId,
					},
					apiVersion: 2,
					apiVersionMinor: 0,
					transactionInfo: {
						checkoutOption:"COMPLETE_IMMEDIATE_PURCHASE",
						currencyCode:self.currency,
						totalPriceStatus: "FINAL",
						totalPrice:String(self.amount),
					}
				}
			}

			self.pgwm.load_SDKjs(self.SDKjsURL,function(){
				try {
				(function() {
					var livestatus = 1;
					if(self.debug){
						livestatus = 0;
					}

					var st = SecureTrading({
					  jwt:jwt,
					  submitOnError: true,
					  livestatus: livestatus,
					  submitOnSuccess:false,
					  submitCallback: function(data){
					  	if(typeof data.errorcode != "undefined" && data.errorcode != "0"){
							var errorData = "";
							if(typeof data.errordata != "undefined"){
								errorData = "(" + data.errordata + ")";
							}
							self.clean();//Limpiamos la instancia, así evitamos redirecciones innecesarias fuera de nuestro control
							var errorPayload = new paymentErrorPayload(self.transactionId, data.errormessage + errorData, data.errorcode);
							self.pgwm.errorsHandling(errorPayload,self.callbackOnPaymentFailure);
							self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error,"alert")
							self.pgwm.setSubmitBtState(true);
							self.pgwm.closePopUp(true);
							self.clean();
						}else if(typeof data.errorcode != "undefined" && data.errorcode == "0"){
							var threedResponse = null;
							var jwtResponse = null;
							if(typeof data.threedresponse != "undefined"){ threedResponse = data.threedresponse; }
							if(typeof data.jwt != "undefined"){ jwtResponse = data.jwt; }
							self.clean();//Limpiamos la instancia, así evitamos redirecciones innecesarias fuera de nuestro control
							self.submitPayload(jwtResponse,self.transactionId,threedResponse);
						}
					  }
					});
					self.buildPopUp();
					st.GooglePay(self.gpaySetup)
					$('#googlePayPopUp [data-gpay-loader]').remove();
					//st.Components({startOnLoad: true});
				  })();
				} catch(error) {
					self.pgwm.errorsHandling(new paymentErrorPayload(self.transactionId,error.message),self.callbackOnPaymentFailure)
					self.pgwm.closePopUp();
					self.clean();
				}
			})
		}

		buildServerSideForm(injectToSelector){
			var self = this;
			$(injectToSelector).find('[' + self.containerAttr + ']').remove();

			var serverSideForm =	'<div ' + self.containerAttr + ' style="display:none">' +
										'<div id="st-notification-frame"></div>' +
										'<form id="st-form" method="POST" action="javascript:void(null)" target="threeDS_trustgpay_receiver"></form>' +
										'<iframe style="height:0px;width:0px;" name="threeDS_trustgpay_receiver"></iframe>' +
									'</div>'

			$(injectToSelector).append(serverSideForm);
		}

		buildPopUp(){
			var self = this;
			const HTML = `<div><img src="//cdn.inicium.com/images/common/art/cards/google_pay_card.png" class="animated fadeIn"><div id="st-google-pay"><img data-gpay-loader width="40" height="40" src="${self.loaderURL}"/></div></div>`
			self.pgwm.openPopUp("googlePayPopUp",HTML,null,() => {
				$('#googlePayPopUp').off('closed.zf.reveal').on('closed.zf.reveal',function(e,j){
					self.pgwm.setSubmitBtState(true)
					self.pgwm.clearAsyncMsg();
					self.pgwm.errorsHandling(new paymentErrorPayload(self.transactionId,"Operation cancelled"),self.callbackOnPaymentFailure);
				})
				$(document).off("click","#googlePayPopUp .gpay-card-info-container").on("click",'#googlePayPopUp .gpay-card-info-container',() => { self.pgwm.closePopUp();} )
			})
		}

		clean(){
			var self = this;
			$("[" + self.containerAttr + "]").add('#googlePayPopUp').remove()
		}

		submitPayload(jwt, transactionID, threedResponse){

			var self = this;
			var payloadURL =	"/data/?action=paymentManager&mode=continuePayment";
			var payloadQuery = 	new formeSubmit(false,payloadURL,{
				sendDataAsJSON: true,
				extraFields: {
					data:	{
						jwt: jwt,
						threedResponse: threedResponse
					},
					refPago: transactionID
				},
				statusMsg: {
					elem: self.pgwm.getAsyncMsgsElem()
				},
				callbackOnSuccess: function(j){
					if(typeof j.type != "undefined"){
						self.callbackOnPaymentFailure(j);
					}else{
						if(typeof j.data != "undefined" && typeof j.data.pagado != "undefined" && j.data.pagado === true){
							if(typeof j.data.url != "undefined"){
								window.location.href = j.data.url;
							}else{
								self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error,"alert")
								self.pgwm.setSubmitBtState(true);
								self.clean();
							}
						}else{
							self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error,"alert")
							self.pgwm.setSubmitBtState(true);
							self.clean();
						}
					}
				},
				callbackOnFail: function(j){
					if(typeof j.type != "undefined"){
						self.callbackOnPaymentFailure(j);
					}else{
						self.pgwm.setAsyncMsgElem(j.error,"alert");
						self.pgwm.setSubmitBtState(true);
						self.clean();

					}
				}
			})
			self.xhrHandler = payloadQuery.getXHR();

		}
	}

	class threeDSPlugin_trustpayments {
		//Dependencias: async_lib.js

		constructor (paymentsGatewayManagerObj,jwt,backendURL,transactionID,callbackOnFailure,options){
			this.pgwm = paymentsGatewayManagerObj;
			this.SDKjsURL = 		"https://webservices.securetrading.net/js/v3/st.js";
			this.transactionId = 	transactionID
			this.containerAttr = 	"data-trustpayment-container";
			this.debug = 			false;
			this.elem = 			null;
			this.backendURL = 		backendURL;
			this.operationTimeOut = 15000;
			this.timeOutHandler	=	null;
			this.xhrHandler = 		null;
			this.callbackOnPaymentFailure = callbackOnFailure;

			if(typeof options != "undefined"){
				if(typeof options.debug != "undefined" && options.debug === true){
					this.debug = true;
				}
				if(typeof options.elem != "undefined"){
					this.elem = options.elem;
				}

			}
			this.setup(jwt);
		}

		setup(jwt){
			var self = this;
			var setupOptions = {}
			self.clean();
			self.pgwm.setSubmitBtState(false);
			self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.wait)
			self.buildServerSideForm("body",jwt);
			self.pgwm.load_SDKjs(self.SDKjsURL,function(){
				try {
				(function() {
					var livestatus = 1;
					if(self.debug){
						livestatus = 0;
					}
					var st = SecureTrading({
					  jwt:jwt,
					  submitOnError: true,
					  livestatus: livestatus,
					  submitCallback: function(data){
					  	if(typeof data.errorcode != "undefined" && data.errorcode != "0"){
							var errorData = "";
							if(typeof data.errordata != "undefined"){
								errorData = "(" + data.errordata + ")";
							}
							self.clean();//Limpiamos la instancia, así evitamos redirecciones innecesarias fuera de nuestro control
							var errorPayload = new paymentErrorPayload(self.transactionId, data.errormessage + errorData, data.errorcode);
							self.pgwm.errorsHandling(errorPayload,self.callbackOnPaymentFailure);
						}else if(typeof data.errorcode != "undefined" && data.errorcode == "0"){
							var threedResponse = null;
							var jwtResponse = null;
							if(typeof data.threedresponse != "undefined"){ threedResponse = data.threedresponse; }
							if(typeof data.jwt != "undefined"){ jwtResponse = data.jwt; }
							self.clean();//Limpiamos la instancia, así evitamos redirecciones innecesarias fuera de nuestro control
							self.submitPayload(jwtResponse,self.transactionId,threedResponse);
						}
					  }
					});
					st.Components({startOnLoad: true});
				  })();
				} catch(error) {
					self.pgwm.errorsHandling(new paymentErrorPayload(self.transactionId,self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error),self.callbackOnPaymentFailure)
				}
			})
		}

		buildServerSideForm(injectToSelector,jwt){
			var self = this;
			$(injectToSelector).find('[' + self.containerAttr + ']').remove();

			var serverSideForm =	'<div ' + self.containerAttr + ' style="display:none">' +
										'<div id="st-notification-frame"></div>' +
										'<form id="st-form" method="POST" action="' + self.backendURL + '" target="threeDS_trustpayments_receiver"></form>' +
										'<iframe style="height:0px;width:0px;" name="threeDS_trustpayments_receiver"></iframe>' +
									'</div>'

			$(injectToSelector).append(serverSideForm);

		}

		clean(){
			var self = this;
			$("[" + self.containerAttr + "]").remove()
		}


		submitPayload(jwt, transactionID, threedResponse){

			var self = this;
			var payloadURL =	"/data/?action=paymentManager&mode=continuePayment";
			var payloadQuery = 	new formeSubmit(false,payloadURL,{
				sendDataAsJSON: true,
				extraFields: {
					data:	{
						jwt: jwt,
						threedResponse: threedResponse
					},
					refPago: transactionID
				},
				statusMsg: {
					elem: self.pgwm.getAsyncMsgsElem()
				},
				callbackOnSuccess: function(j){
					if(typeof j.type != "undefined"){
						self.callbackOnPaymentFailure(j);
					}else{
						if(typeof j.data != "undefined" && typeof j.data.pagado != "undefined" && j.data.pagado === true){
							if(typeof j.data.url != "undefined"){
								window.location.href = j.data.url;
							}else{
								self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error,"alert")
								self.pgwm.setSubmitBtState(true);
							}
						}else{
							self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error,"alert")
							self.pgwm.setSubmitBtState(true);
						}
					}
				},
				callbackOnFail: function(j){
					if(typeof j.type != "undefined"){
						self.callbackOnPaymentFailure(j);
					}else{
						self.pgwm.setAsyncMsgElem(j.error,"alert");
						self.pgwm.setSubmitBtState(true);
					}
				}
			})
			self.xhrHandler = payloadQuery.getXHR();

		}

	}

	class threeDSPlugin_nuvei {
		//Dependencias: async_lib.js

		constructor (paymentsGatewayManagerObj,merchantId,merchantSiteId,paymentParams,transactionID,callbackOnFailure,options){
			this.pgwm = paymentsGatewayManagerObj;
			this.merchantId = merchantId;
			this.merchantSiteId = merchantSiteId;
			this.SDKjsURL = 		"https://cdn.safecharge.com/safecharge_resources/v1/websdk/safecharge.js";
			this.transactionId = 	transactionID
			this.containerAttr = 	"data-safecharge-container";
			this.debug = 			false;
			this.elem = 			null;
			this.sfcObj = 			null;
			this.xhrHandler = 		null;
			this.callbackOnPaymentFailure = callbackOnFailure;
			this.paymentParams = paymentParams;
/* 			paymentParams = {
				sessionToken:
				clientUID:
				paymentOption:
				cardHolderName:
			} */
			if(typeof options != "undefined"){
				if(typeof options.debug != "undefined" && options.debug === true){
					this.debug = true;
				}
				if(typeof options.elem != "undefined"){
					this.elem = options.elem;
				}

			}
			this.setup();
		}

		setup(){
			var self = this;
			var setupOptions = {}
			self.pgwm.setSubmitBtState(false);
			self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.wait)
			self.clean();
			self.pgwm.load_SDKjs(self.SDKjsURL,function(){
				self.createPayment();
			},"data-safecharge-script")

		}
		createPayment(){
			var self = this;
			var environment = "prod";
			if(self.debug){
				environment = "int"
			}
			try{
				self.clean();
				window.paymentsManager_refPago = self.transactionId;
				self.sfcObj = new SafeCharge({
					env: environment, // Nuvei API environment - 'int' (integration) or 'prod' (production - default if omitted)
					merchantId: self.merchantId, // your Merchant ID provided by Nuvei
					merchantSiteId: self.merchantSiteId // your Merchant site ID provided by Nuvei
				})
				var style = "<style data-payments-css='nuvei'>.is-in, .is-in .sfcModal-dialog, .is-in .sfcModal-content, .is-in #ifrm {height:100%!important;overflow:auto!important}</style>";
				$(style).appendTo('head');
				self.sfcObj.createPayment(self.paymentParams,function(res){
					//console.log("create payment:",self.transactionId,window.paymentsManager_refPago)

					if(typeof res.result != "undefined"){
						if(res.result == "ERROR"){
							self.pgwm.errorsHandling(new paymentErrorPayload(self.transactionId,res.errorDescription,res.errorCode),self.callbackOnPaymentFailure);
						}else if( res.result == "DECLINED"){
							var errorDesc = "Declined";
							if(typeof res.errorDescription != "undefined" && res.errorDescription != null && res.errorDescription){
								errorDesc = res.errorDescription;
							}
							self.pgwm.errorsHandling(new paymentErrorPayload(self.transactionId,errorDesc),self.callbackOnPaymentFailure);
						}else if( res.result == "APPROVED"){
							self.transactionId = window.paymentsManager_refPago;
							self.submitCompletionPayload(res);
						}
					}else{
						if(typeof res.error != "undefined"){
							self.pgwm.errorsHandling(new paymentErrorPayload(self.transactionId,res.error.message,res.error.code),self.callbackOnPaymentFailure);
						}else{
							self.pgwm.errorsHandling(new paymentErrorPayload(self.transactionId,"Unable to create payment"),self.callbackOnPaymentFailure);
						}
					}
				});
			}catch(error){
				self.clean();
				self.pgwm.errorsHandling(new paymentErrorPayload(self.transactionId,error),self.callbackOnPaymentFailure);
			}
		}

		clean(){
/* 			$('[data-safecharge-script]').remove();
			if(this.sfcObj != null){
			} */
			if(typeof window.paymentsManager_refPago != "undefined"){
				delete window.paymentsManager_refPago;
			}
			$('[data-payments-css="nuvei"]').remove();
		}
		submitCompletionPayload(payloadData){
			var self = this;
			var payloadURL = "/data/?action=paymentManager&mode=continuePayment";

			var checkTransactionStatus = new formeSubmit(false,payloadURL,{
				sendDataAsJSON: true,
				extraFields: {
					data: payloadData,
					refPago: self.transactionId
				},
				statusMsg: {
					elem: self.pgwm.getAsyncMsgsElem()
				},
				callbackOnSuccess: function(j){
					if(typeof j.type != "undefined"){
						self.callbackOnPaymentFailure(j);
					}else{
						if(typeof j.data != "undefined" && typeof j.data.pagado != "undefined" && j.data.pagado === true){
							if(typeof j.data.url != "undefined"){
								window.location.href = j.data.url;
							}else{
								self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error,"alert")
								self.pgwm.setSubmitBtState(true);
							}
						}else{
							self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error,"alert")
							self.pgwm.setSubmitBtState(true);
						}
					}
				},
				callbackOnFail: function(j){
					if(typeof j.type != "undefined"){
						self.callbackOnPaymentFailure(j);
					}else{
						self.pgwm.setAsyncMsgElem(j.error,"alert");
						self.pgwm.setSubmitBtState(true);
					}
				}
			})

		}



	}


	class plugin_iframe {
		constructor (paymentsGatewayManagerObj,paymentParams,transactionID,callbackOnFailure,options = {}){
			//this.timeOut = 10;
			//this.httpResponse != 200;
			// Si mala respuesta o timeout, continuepayment con var threeDSCompInd a false o N
			this.pgwm 		= paymentsGatewayManagerObj;
			this.debug 		= (options?.debug && options?.debug === true) ? true : false;
			this.url 		= paymentParams.url ?? null;
			this.authParams	= paymentParams.authParams ?? null;
			this.domain 	= paymentParams.domain ?? null;
			this.xhrHandler = null;
			this.transactionId = 	transactionID;
			this.domain = this.domain.replace(/\/+$/,"");
			this.callbackOnPaymentFailure = callbackOnFailure;
			this.iframeBaseName = 'iframePaymentContent';

			this.setup();
		}

		setup(){
			var self = this;
			var setupOptions = {}
			self.clean();
			self.pgwm.setSubmitBtState(false);
			self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.wait)
			self.createPayment();
		}
		clean(){
			this.pgwm.removePopUp(`#${this.iframeBaseName}`);
		}
		createPayment(){
			let self = this;
			if(self.url){
				const HTML = `<iframe data-${this.iframeBaseName} name="${this.iframeBaseName}"></iframe>`
				self.pgwm.openPopUp(this.iframeBaseName,HTML,null,() => {
					let form = document.createElement('form');
					form = this.appendParamsToPost(form,this.authParams);

					form.target = this.iframeBaseName;
					form.method = "post";
					form.action = this.url;

					const iframeElem = document.querySelector(`[data-${this.iframeBaseName}]`);
					iframeElem.appendChild(form);
					form.submit();
					$(`#${this.iframeBaseName}`).off('closed.zf.reveal').on('closed.zf.reveal',(e,j) => {
						this.pgwm.setSubmitBtState(true)
						this.pgwm.clearAsyncMsg();
						this.clean();
					})
					$(iframeElem).off('load').on('load',(e) => {
						this.handleIframeLoad(e);
					});
				},{
					classes:["iframed"]
				})
			}

		}

		appendParamsToPost(formObject,params){
			for (const item in params){
				const inp 	= document.createElement('input');
				inp.type	= "hidden";
				inp.name	= item;
				inp.value 	= params[item];
				formObject.appendChild(inp);
			}
			return formObject;
		}

		handleIframeLoad(handler){
			const iframeElem = document.querySelector(`[data-${this.iframeBaseName}]`);
			var self = this;
			if(this.pgwm.canAccessIframe(iframeElem)){
				const path = `${iframeElem.contentWindow.location.protocol}//${iframeElem.contentWindow.location.hostname}`;
				if(path == this.domain){
					$(iframeElem).hide();
					console.log(iframeElem)
					console.log($(iframeElem).contents().text())
					try{
						const response = self.getResponse($(iframeElem).contents().find('body').html());
						let jsonContent;
						if(response){
							jsonContent = JSON.parse(response);
						}else{
							throwError();
						}
						this.pgwm.closePopUp();
						this.submitCompletionPayload(jsonContent)
					}catch(e){
						this.pgwm.closePopUp();
						this.pgwm.errorsHandling(new paymentErrorPayload(self.transactionId,"Invalid JSON",$(iframeElem).contents().text()),self.callbackOnPaymentFailure);
					}
				}
			}
		}

		getResponse(content){
			const re = new RegExp('\<REDSYS_RESPONSE\>(.*)\<\/REDSYS_RESPONSE\>','gi')
			const found = re.exec(content);
			if(found && found[1] != undefined){
				return found[1];
			}
			return false;
		}

		submitCompletionPayload(payloadData,callbackOnSuccess = ()=>{},callbackOnFail = ()=>{}){
			var self = this;
			var payloadURL = "/data/?action=paymentManager&mode=continuePayment";
			var checkTransactionStatus = new formeSubmit(false,payloadURL,{
				sendDataAsJSON: true,
				extraFields: {
					data: payloadData,
					refPago: self.transactionId
				},
				statusMsg: {
					elem: self.pgwm.getAsyncMsgsElem()
				},
				callbackOnSuccess: function(j){
					if(typeof j.type != "undefined"){
						callbackOnFail(j);
						self.callbackOnPaymentFailure(j);
					}else{
						if(j?.data?.pagado === true){
							callbackOnSuccess();
							if(typeof j.data.url != "undefined"){
								window.location.href = j.data.url;
							}else{
								self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error,"alert")
								self.pgwm.setSubmitBtState(true);
							}
						}else{
							callbackOnFail();
							self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error,"alert")
							self.pgwm.setSubmitBtState(true);
						}
					}
				},
				callbackOnFail: function(j){
					//console.log(callbackOnFail)
					callbackOnFail(j);
					if(typeof j.type != "undefined"){
						self.callbackOnPaymentFailure(j);
					}else{
						self.pgwm.setAsyncMsgElem(j.error,"alert");
						self.pgwm.setSubmitBtState(true);
					}
				}
			})
		}
	}


	class threeDSPlugin_iframeAuth extends plugin_iframe{
		constructor (paymentsGatewayManagerObj,paymentParams,transactionID,callbackOnFailure,options = {}){
			//this.timeOut = 10;
			//this.httpResponse != 200;
			// Si mala respuesta o timeout, continuepayment con var threeDSCompInd a false o N
			super(paymentsGatewayManagerObj,paymentParams,transactionID,callbackOnFailure,options);
		}

		clean(){
			$(`[data-${this.iframeBaseName}]`).remove();
		}

		createPayment(){
			let self = this;
			const intervalSecs = 10;
			let timerHandler;

			if(self.url){
				const HTML = `<iframe data-${this.iframeBaseName} name="${this.iframeBaseName}"></iframe>`
				$('body').append(HTML);

				let form = document.createElement('form');
				form = this.appendParamsToPost(form,this.authParams);
				form.target = this.iframeBaseName;
				form.method = "post";
				form.action = this.url;
				form.style.display = "none!important";
				const iframeElem = document.querySelector(`[data-${this.iframeBaseName}]`);
				iframeElem.appendChild(form);
				form.submit();
				timerHandler = setTimeout(() => {
					this.clean();
					this.submitCompletionPayload({threeDSCompInd:false})
				},intervalSecs * 1000);

				$(iframeElem).off('load').on('load',(e) => {
					this.handleIframeLoad(timerHandler);
				});

			}

		}
		handleIframeLoad(handler){
			const iframeElem = document.querySelector(`[data-${this.iframeBaseName}]`);


			if(this.pgwm.canAccessIframe(iframeElem)){
				const path = `${iframeElem.contentWindow.location.protocol}//${iframeElem.contentWindow.location.hostname}`;
				if(path == this.domain){
					$(iframeElem).hide();
					clearTimeout(handler);
					this.clean();
					this.submitCompletionPayload({threeDSCompInd:true})
				}
			}
		}
	}

	class threeDSPlugin_applepay {
		//Dependencias: async_lib.js

		constructor (paymentsGatewayManagerObj,merchantId,merchantSiteId,paymentParams,transactionID,callbackOnFailure,options = {}){
			this.pgwm = paymentsGatewayManagerObj;
			this.merchantId = merchantId;
			this.merchantSiteId = merchantSiteId;
			this.SDKjsURL = 		"https://cdn.safecharge.com/safecharge_resources/v1/sc_api_applepay.min.js";
			this.transactionId = 	transactionID;
			this.containerAttr = 	"data-safecharge-container";
			this.debug = 			false;
			this.elem = 			null;
			this.request = 			null;
			this.xhrHandler = 		null;
			this.callbackOnPaymentFailure = callbackOnFailure;
			this.country = 			paymentParams.country;
			this.currency = 		paymentParams.currency;
			this.amount = 			paymentParams.amount;
			this.paymentParams = 	paymentParams ?? {};
			this.companyLabel = 	paymentParams.company;
			this.prevErrorMsg = null;
			this.lang = options?.language ?? "EN";

/* 			paymentParams = {
				sessionToken:
				clientUID:
				paymentOption:
				cardHolderName:
			} */
			if(typeof options != "undefined"){
				if(typeof options.debug != "undefined" && options.debug === true){
					this.debug = true;
				}
				if(typeof options.elem != "undefined"){
					this.elem = options.elem;
				}

			}
			this.setup();
		}

		setup(){
			var self = this;
			var setupOptions = {}
			self.pgwm.setSubmitBtState(false);
			self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.wait)
			if(window.PaymentRequest){
				self.clean();
				self.pgwm.load_SDKjs(self.SDKjsURL,function(){
					let paymentRequest = {
						merchantSiteId: self.merchantSiteId, // use your own merchant site ID provided by Nuvei
						env: self.debug ? 'int' : 'prod' , // Nuvei API environment - 'int' (integration) or 'prod' (production - default if omitted)
						//shippingType: "shipping", // possible values: "delivery", "storePickup", "servicePickup"
						countryCode: self.country,
						currencyCode: self.currency,
						total: {
							label: self.companyLabel,
							amount: String(self.amount)
						},
					};
					self.createPayment(paymentRequest);
				},"data-applepay-script")
			}else{
				//Drop error
			}
		}

		createPayment(paymentRequestToApple){
			var self = this;
			let session;

			let sessionStarted = false;
			session = sfc.applePay.buildSession(paymentRequestToApple, (result, completion) => {
				/* postTransactionData is a function that calls server with provided data
				using Nuvei API and callback receives status from server */
				const paymentPayload = result;
					self.submitCompletionPayload(JSON.stringify(paymentPayload),() => {
						completion(true);
					},(data) => {
						completion(false);
					});
			});

			session.onpaymentmethodselected = event => {
				// Define ApplePayPaymentMethodUpdate based on the selected payment method.
				// No updates or errors are needed, pass an empty object.
				const update = {
					newTotal: {
						label: self.companyLabel,
						amount: String(self.amount)
					}
				};
				session.completePaymentMethodSelection(update);
			};

			session.oncancel = (evt) => {
				var errorMsg = self.prevErrorMsg ?? "Operation Cancelled"
				self.pgwm.errorsHandling(new paymentErrorPayload(self.transactionId,errorMsg),self.callbackOnPaymentFailure);
				self.pgwm.setSubmitBtState(true)
				sessionStarted = false;
			};

			const HTML = `<div><img src="//cdn.inicium.com/images/common/art/cards/apple_pay_card.png" class="animated fadeIn"><button -apple-pay-button-type="buy" lang="${self.lang}" class="apple-pay-button apple-pay-button-white"></button></div>`
			self.pgwm.openPopUp("applePayPopUp",HTML,null,() => {
				$('#applePayPopUp').off('closed.zf.reveal').on('closed.zf.reveal',function(e,j){
					self.pgwm.setSubmitBtState(true)
					self.pgwm.clearAsyncMsg();
					if(sessionStarted){
						self.pgwm.errorsHandling(new paymentErrorPayload(self.transactionId,"Operation cancelled"),self.callbackOnPaymentFailure);
					}
				})
				$('#applePayPopUp button.apple-pay-button').off('click').on('click',function(){
					session.begin();
					sessionStarted = true;
					self.pgwm.closePopUp();
				})

			})
		}

		clean(){
			this.errorMsg = null;
		}

		submitCompletionPayload(payloadData,callbackOnSuccess = ()=>{},callbackOnFail = ()=>{}){
			var self = this;
			var payloadURL = "/data/?action=paymentManager&mode=continuePayment";
			var checkTransactionStatus = new formeSubmit(false,payloadURL,{
				sendDataAsJSON: true,
				extraFields: {
					data: payloadData,
					refPago: self.transactionId
				},
				statusMsg: {
					elem: self.pgwm.getAsyncMsgsElem()
				},
				callbackOnSuccess: function(j){
					if(typeof j.type != "undefined"){
						callbackOnFail(j);
						self.callbackOnPaymentFailure(j);
					}else{
						if(j?.data?.pagado === true){
							callbackOnSuccess();
							if(typeof j.data.url != "undefined"){
								window.location.href = j.data.url;
							}else{
								self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error,"alert")
								self.pgwm.setSubmitBtState(true);
							}
						}else{
							callbackOnFail();
							self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error,"alert")
							self.pgwm.setSubmitBtState(true);
						}
					}
				},
				callbackOnFail: function(j){
					//console.log(callbackOnFail)
					callbackOnFail(j);
					if(typeof j.type != "undefined"){
						self.callbackOnPaymentFailure(j);
					}else{
						self.pgwm.setAsyncMsgElem(j.error,"alert");
						self.pgwm.setSubmitBtState(true);
					}
				}
			})
		}

	}

	class plugin_requestInfo {
		constructor (paymentsGatewayManagerObj,paymentParams,transactionID,callbackOnFailure,options = {}){
			//this.timeOut = 10;
			//this.httpResponse != 200;
			// Si mala respuesta o timeout, continuepayment con var threeDSCompInd a false o N
			this.pgwm 			= paymentsGatewayManagerObj;
			this.debug 			= (options?.debug && options?.debug 	=== true) ? true : false;
			this.xhrHandler 	= null;
			this.transactionId 	= 	transactionID;
			this.callbackOnPaymentFailure = callbackOnFailure;
			this.popupBaseName 	= 'requestAdditionalInfo';
			this.fieldsObj 		= paymentParams?.fieldsObj ?? [];
			this.actionsObj 	= paymentParams?.actionsObj ?? [];
			this.stringsObj		= paymentParams?.stringsObj ?? { title: "Additional Info Required", message:"Additional information is requested by payment processor." };
			this.paymentsObj 	= paymentParams?.paymentsObj ?? null;
			this.setup();
		}

		setup(){
			var self = this;
			var setupOptions = {}
			self.clean();
			self.pgwm.setSubmitBtState(false);
			self.pgwm.setAsyncMsgElem(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.wait)
			const fragment = self.createContent();
			self.pgwm.openPopUp(self.popupBaseName,fragment,null,() => {
				self.setEvents();
			},{classes: ['modernModal','fit'],closeable:false});
		}

		clean(){
			this.pgwm.removePopUp(`#${this.popupBaseName}`);
		}
		createContent(){
			let self = this;
			const fragment = `<div class="panelContent"><p data-title><strong>${self.stringsObj.title}</strong></p><p>${self.stringsObj.message}</p>${self.buildFragment(self.fieldsObj)} ${self.buildActions(self.actionsObj)}</div>`;
			return fragment;
		}

		setEvents(){
			let self = this;
			const elem = $(`#${self.popupBaseName}`);
			const submitBt = $(elem).find('[data-submit]');

			$(elem).find('[data-cancel]').off('click').on('click',() => { self.pgwm.closePopUp();self.pgwm.setSubmitBtState(true);self.pgwm.clearAsyncMsg()})
			$(submitBt).off('click').on('click',() => { self.submitCompletionPayload()})
			const formElems = Array.from(self.getForm()[0].elements);
			$(formElems).off('input').on('input',(el) => {
				if(!self.checkValidity()){
					$(submitBt).attr('disabled','');
				}else{
					$(submitBt).removeAttr('disabled');
				}
			});
		}

		buildFragment(fieldsObj = []){
			let outputHTML = "";
			for(const item of fieldsObj){
				let itemHTML;
				const placeHolder 	= item.placeHolder 	? `placeholder = "${item.placeHolder}"` : ``;
				const minLength 	= item.minLength	? `minlength = "${item.minLength}"` : `minlength = "1"`;
				const maxLength 	= item.maxLength	? `maxlength = "${item.maxLength}"` : ``;
				const id 			= item.id ? `id = "${item.id}"` : ``;
				const value 		= item.value ? `value = "${item.value}"`: ``;
				switch (item.type){
					case "input":
						itemHTML = `<input type="text" ${placeHolder} ${minLength} ${maxLength} ${id} ${value}>`;
					break;
				}
				itemHTML = `<label>${item.label} ${itemHTML}</label>`;
				outputHTML += itemHTML;
			}
			outputHTML = `<form>${outputHTML}<div data-status-msg style='displays:none'></div></form>`;
			return outputHTML;
		}

		buildActions(actionsObj = []){
			let self = this;
			let outputHTML = "";
			for(const item of actionsObj){
				let itemHTML;
				switch(item.type){
					case "send":
						itemHTML = `<button type="button" data-submit disabled>${item.label}</button>`;
					break;
					case "cancel":
						itemHTML = `<button type="cancel" data-cancel>${item.label}</button>`;
					break;
				}
				outputHTML += itemHTML;
			}
			outputHTML = `
				<div class="${self.popupBaseName}_actions botonera">
					${outputHTML}
				</div>
			`;
			return outputHTML;
		}
		getForm(){
			const formElem = $(`#${this.popupBaseName}`).find('form');
			return formElem;
		}

		checkValidity(addClasses = true){
			const fields = this.retrieveFormFields();
			let isValid = true;
			fields.forEach( el => {
				if(!el.validity.valid || el.value.trim().length == 0){
					if(addClasses) $(el).addClass('error')
					isValid = false;
				}else{
					if(addClasses) $(el).removeClass('error')
				}
			} );
			return isValid;
		}

		retrieveFormFields(){
			const formElem = this.getForm();
			const fields = Array.from(formElem[0].elements);
			return fields;
		}

		retrieveData(){
			const fields = this.retrieveFormFields();
			let obj = {};
			fields.forEach( el => {
				obj[el.id] = el.value;
			})
			return obj;
		}

		submitCompletionPayload(payloadData,callbackOnSuccess = ()=>{},callbackOnFail = ()=>{}){
			var self = this;
			var payloadURL = "/data/?action=withdrawalManager&mode=continuePayment";
			const contents = this.retrieveData();
			const statusMsgElem = $(this.getForm()).find('[data-status-msg]');
			$(statusMsgElem).removeClass('error').empty();
			var checkTransactionStatus = new formeSubmit(this.getForm(),payloadURL,{
				sendDataAsJSON: true,
				extraFields: {
					customValues: contents,
					refPago: self.transactionId
				},
				callbackOnSuccess: function(j){
					if(typeof j.type != "undefined"){
						callbackOnFail(j);
						self.callbackOnPaymentFailure(j);
					}else{
						if(j?.data?.pagado === true){
							callbackOnSuccess();
							if(typeof j.data.url != "undefined"){
								window.location.href = j.data.url;
							}else{
								$(statusMsgElem).html(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error).addClass("alert");
								self.pgwm.clearAsyncMsg();
								self.pgwm.setSubmitBtState(true);
							}
						}else{
							callbackOnFail();
							$(statusMsgElem).html(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error).addClass("alert");
							self.pgwm.clearAsyncMsg();
							self.pgwm.setSubmitBtState(true);
						}
					}
				},
				callbackOnFail: function(j){
					//console.log(callbackOnFail)
					callbackOnFail(j);
					if(typeof j.type != "undefined"){
						self.callbackOnPaymentFailure(j);
					}else{
						$(statusMsgElem).html(self.pgwm.getPaymentsManagerObj().paymentsObj.strings.error).addClass("alert");
						self.pgwm.clearAsyncMsg();
						self.pgwm.setSubmitBtState(true);
					}
				}
			})
		}
}

/************************************/
/* QUICK PAYMENTS					*/
/************************************/

const QP_LEGACY = 2;	//método que corresponda
const QP_SV = 1;		//saldo virtual
const QP_FREE = 0;		//sin cargo

var quickPay = function(lastPaymentMethod, lastPaymentMedio, paymentsObj, currencyObj,options){
	this.currencyObj = null;
	this.selectors = {
		elem: 				"[data-quickpaymanager]",
		content:			"[data-quickpaymanager-content]",
		details:	 		"[data-qp-detailed]",
		detailsVC:	 		"[data-qp-detailed='sv']",
		medioDetails: 		"[data-stored-data]",
		acquisitionDetails: "[data-stored-acquisition]",
		remainingBalance: 	"[data-remainingBalance-area]",
		amount: 			"[data-submit-payment] [data-amount]",
		saveForLater:		"input[data-qp-storage-add]",
		submitBt: 			"[data-submit-payment]",
		submitForm: 		"[data-payment-storage]"
	}
	this.classicPayments = {
		selector: 			"[data-paymethodsArea]",
		switchBtSelector:	"button[data-show-others]"
	}
	this.strings = {
		minLimit:			"<p>{t}El importe mínimo es de:{/t} <strong>%1</strong>. {}La diferencia <strong>(%2)</strong> se añadirá a tu Saldo Virtual{/t} </p>"
	}
	this.paymentsObj = paymentsObj;
	this.method = lastPaymentMethod;
	this.medio  = lastPaymentMedio;
	this.payMethodStruct = {
		method:null,
		submethod:null
	}

	this.useVCfirstIfAvailable = true;
	this.isUsingPreviousBalance = false;
	this.isSavingForLater = false;
	this.quickPayStatus = true;
	this.selectedMethod = null;

	var self = this;

	if(typeof currencyObj != "undefined" && currencyObj != null){
		this.currencyObj = currencyObj;
	}
	if(typeof options != "undefined"){
		if(typeof options.strings != "undefined"){
			if(typeof options.strings.minLimit != "undefined"){ this.strings.minLimit = options.strings.minLimit}
		}
	}

	this.init(lastPaymentMethod, lastPaymentMedio, paymentsObj, currencyObj,options);

}
quickPay.prototype.init = function(lastPaymentMethod, lastPaymentMedio, paymentsObj, currencyObj,options){
	var self = this;

	this.paymentsObj = paymentsObj;
	this.method = lastPaymentMethod;
	this.medio  = lastPaymentMedio;

	function setPayMethodStruct(id){
		//Devuelve el submétodo en función del código del método, ya que todos los métodos en paymentsObj, diferencian entre métodos y submétodos.
		if((typeof self.method != "undefined" && self.method != null)){
			$(self.getPaymentsObj().payMethods).each(function(kmethod,vmethod){
				if(vmethod.uid == id){
					self.payMethodStruct.method = vmethod;
					self.payMethodStruct.submethod = vmethod;
					$(vmethod.limits).each(function(ksubm,vsubm){
						if(vsubm.uid == id){
							self.payMethodStruct.submethod = vsubm;
						}
					})
				}else{
					$(vmethod.limits).each(function(ksubm,vsubm){
						if(vsubm.uid == id){
							self.payMethodStruct.submethod = vsubm;
							self.payMethodStruct.method = vmethod;
						}
					})
				}
			})
		}
	}

	function setEvents(){
		//Eventos
		//-------
		$(self.selectors.elem).find('form').foundation();
		$(self.selectors.elem).find(self.classicPayments.switchBtSelector).off('click').on('click',function(){
			self.switchToPayments();
		})
		$(self.selectors.elem).find(self.selectors.remainingBalance).find('input').off('click').on('click',function(){
			if($(this).prop('checked')){
				self.setUsePreviousBalance(true);
			}else{
				self.setUsePreviousBalance(false);
			}
			self.refreshTotals();
		})
		$(self.selectors.elem).find(self.selectors.saveForLater).off('click').on('click',function(){
			if($(this).prop('checked')){
				self.setSaveForLater(true);
			}else{
				self.setSaveForLater(false);
			}
		})
		if($(self.selectors.elem).find(self.selectors.remainingBalance).find('input').prop('checked')){
			self.setUsePreviousBalance(true);
		}else{
			self.setUsePreviousBalance(false);
		}
		if($(self.selectors.elem).find(self.selectors.saveForLater).prop('checked')){
			self.setSaveForLater(true);
		}else{
			self.setSaveForLater(false);
		}

		$(self.selectors.elem).find(self.selectors.submitBt).off('click').on('click',function(){
			self.performPay();
		})
		var form = $(self.selectors.elem).find(self.selectors.acquisitionDetails).find('form');

	}
	setEvents();
	setPayMethodStruct(this.method);
	this.refresh();
	unlock('[data-locked]');
	$(self.selectors.elem).removeClass('loading');
}

quickPay.prototype.refresh = function(){
	var self = this;

	const canPerformPaymentsWithChargedMethod = () => {
		const subm = self.getSubMethod();
		const m = self.getMethod();
		const max = subm.maxLimit;
		const remaining = subm.remaining;
		const amount = self.getAmount(null,null,true);
		const instant = m.instant;
		if(remaining >= amount && amount <= max && instant){
			return true;
		}
		return false;
	}
	const canUseVC = self.canUseVirtualCash();
	if(self.getMethod() != null || self.getSubMethod() != null || canUseVC){

		if(self.paymentsObj.paymentsObj.getAmount() == 0){
			self.switchToFreeOfChargeMethod();
		}else{
			if(canUseVC){
				self.switchToVcMethod();
			}else{
				if(canPerformPaymentsWithChargedMethod()){
					self.switchToChargedMethod();
				}else{
					self.enableQuickPay(false);
					return false;
				}
			}
		}
	}else{
		self.enableQuickPay(false);
		return false;
	}
	if(self.getMethod() != null || self.getSubMethod() != null){
		if(self.canUsePreviousBalance() === true){
			self.showUsePreviousBalance(true);
			$(self.selectors.elem).find(self.selectors.amount).html(self.getAmount(true))
		}else{
			self.showUsePreviousBalance(false);
			$(self.selectors.elem).find(self.selectors.amount).html(self.getAmount(true))
		}
		if(!self.getPaymentsMgr().getReadyForPurchase(self.getMethod().id,self.getSubMethod().id) && self.getCurrentMethod == QP_LEGACY){
			self.enableQuickPay(false);
		}
	}else if(canUseVC && QP_SV){
		self.enableQuickPay(true);
	}



	var limit = null;
	if(self.getCurrentMethod() == QP_LEGACY){
		var lim = self.getSubMethod().minLimit;
		var amount = self.getAmount(null,null,true);
		if(amount < lim){
			self.setMsg(self.strings.minLimit.placeHolder([self.currencyObj.getMoneda(parseFloat(lim)),self.currencyObj.getMoneda(parseFloat(lim)-amount)]));
			self.showMsg(true);
		}
	}else{
		self.clearMsg();
		self.showMsg(false);
	}
}

quickPay.prototype.refreshTotals = function(){
	var self = this;
	$(self.selectors.elem).find(self.selectors.amount).html(self.getAmount(true))
}

quickPay.prototype.getMethod = function(){
	return this.payMethodStruct.method;
}

quickPay.prototype.getSubMethod = function(){
	return this.payMethodStruct.submethod;
}

quickPay.prototype.getAmount = function(allowConversion,withFormat,ignoreLimit){
	var self = this;

	var amount = self.getPaymentsObj().getAmount();
	var allowConv = false;
	var useFormat = true;
	var useLimit = true;
	var usePreviousBalance = self.getIsUsingPreviousBalance();
	if(typeof allowConversion != "undefined" && allowConversion && self.getCurrentMethod() == QP_LEGACY){
		allowConv = true;
	}
	if(typeof withFormat != "undefined" && !withFormat){
		useFormat = false;
	}
	if(typeof ignoreLimit != "undefined" && ignoreLimit){
		useLimit = false;
	}
	//Gestión de importes por debajo del límite

	//Obtenemos balance de SV
	if(self.getPaymentsObj().isShoppingCart()){
		var svBalance = self.getPaymentsObj().getBalance();
		if(usePreviousBalance && self.getMethod().id != "sv"){
			amount = self.getPaymentsObj().getAmountToPaySubstractingBalance(amount,svBalance,self.getMethod().id,self.getSubMethod().id);
		}
	}
	if(self.getCurrentMethod() == QP_LEGACY){
		var limite = self.getSubMethod().minLimit;
		if(useLimit && amount < limite && (!self.getPaymentsObj().isShoppingCart() || (self.getPaymentsObj().isShoppingCart() && (!self.useVCfirstIfAvailable||( self.useVCfirstIfAvailable && svBalance < amount ))))){
			amount = limite;
		}
	}

	//******************************************** */
	if(!allowConv){
		if(self.currencyObj != null && useFormat){
			var amountFinal = self.getCurrencyObj().getMoneda(parseFloat(amount));
		}else{
			var amountFinal = amount;
		}
	}else{
		var conversionObj = self.getPaymentsObj().applyConversionRate(parseFloat(amount),self.getMethod().id,self.getSubMethod().id);
		if(self.getCurrencyObj() != null && useFormat){
			if(self.getCurrencyObj().getISOCurrency() != conversionObj.ISOcurrency){
				var amountFinal = self.getCurrencyObj().getMoneda(parseFloat(amount),conversionObj.ISOcurrency);
			}else{
				var amountFinal = self.getCurrencyObj().getMoneda(parseFloat(amount));
			}
		}else{
			amountFinal = conversionObj.value;
		}
	}
	return amountFinal;

}

quickPay.prototype.getPaymentsObj = function(){
	return this.paymentsObj.paymentsObj;
}

quickPay.prototype.getPaymentsMgr = function(){
	return this.paymentsObj;
}

quickPay.prototype.getCurrencyObj = function(){
	return this.currencyObj;
}

quickPay.prototype.switchToPayments = function(forceState){
	var force = null;
	if(typeof forceState != "undefined"){
		force = forceState
	}
	if(force == null){
		$(this.classicPayments.selector).slideToggle('fast');
		if(!$(this.classicPayments.selector).hasClass('is-active')){
			$(this.classicPayments.switchBtSelector).add(this.classicPayments.selector).addClass('is-active');
			$(this.selectors.content).slideUp('fast').removeClass('is-active');
		}else{
			$(this.classicPayments.switchBtSelector).add(this.classicPayments.selector).removeClass('is-active');
			$(this.selectors.content).slideDown('fast').addClass('is-active');
		}
	}else{
		if(force){
			$(this.classicPayments.selector).slideDown('fast');
			$(this.classicPayments.switchBtSelector).add(this.classicPayments.selector).addClass('is-active');
			$(this.selectors.content).slideUp('fast')
		}else{
			$(this.classicPayments.selector).slideUp('fast');
			$(this.classicPayments.switchBtSelector).add(this.classicPayments.selector).removeClass('is-active');
			$(this.selectors.content).slideDown('fast')
		}
	}



}
quickPay.prototype.showUsePreviousBalance = function(state){
	if(state){
		$(this.selectors.elem).find(this.selectors.remainingBalance).addClass('is-active');
	}else{
		$(this.selectors.elem).find(this.selectors.remainingBalance).removeClass('is-active');
	}
}

quickPay.prototype.canUsePreviousBalance = function(){
	var self = this;
	var importePago = self.getAmount(false,false);
	var saldo = self.getPaymentsObj().getBalance();
	var method = self.getSubMethod();
	if(method.allowFundsCompensation && self.getPaymentsObj().isShoppingCart()){
		if(typeof method.allowFundsCompensation != "undefined" && method.allowFundsCompensation === true){
			if(importePago > 0 && saldo < importePago && importePago > method.minLimit && importePago < method.remaining){
				if((importePago-saldo) >= method.minLimit){
					return true;
				}else{
					return -1;
				}
			}
		}
	}else{
		return false;
	}
}
quickPay.prototype.getIsUsingPreviousBalance = function(){
	return this.isUsingPreviousBalance;
}
quickPay.prototype.setUsePreviousBalance = function(state){
	var self = this;
	if(state){
		this.isUsingPreviousBalance = true;
	}else{
		this.isUsingPreviousBalance = false;
	}

}

quickPay.prototype.setMsg = function(msg,title){
	var self = this;
	var elem = $(self.selectors.elem).find('[data-msg-area]');
	self.clearMsg();
	if(typeof msg != "undefined" && msg != null){
		$(elem).find('[data-msg-area-message]').html(msg);
	}
	if(typeof title != "undefined" && title != null){
		$(elem).find('[data-msg-area-title]').html(title);
	}
}

quickPay.prototype.showMsg = function(state){
	var self = this;
	if(state){
		$(self.selectors.elem).find('[data-msg-area]').addClass('is-active');
	}else{
		$(self.selectors.elem).find('[data-msg-area]').removeClass('is-active');
	}
}

quickPay.prototype.clearMsg = function(){
	var self = this;
	$(self.selectors.elem).find('[data-msg-area] > *').empty();
}

quickPay.prototype.canUseVirtualCash = function(){
	var self = this;
	if(self.getPaymentsObj().isShoppingCart()){

		if(self.getPaymentsObj().isAvailable("sv",false,false)?.[0] == true){
			return true;
		}
	}
	return false;
}
quickPay.prototype.setSaveForLater = function(status){
	if(status){
		this.isSavingForLater = true;
	}else{
		this.isSavingForLater = false;
	}
}
quickPay.prototype.getIsUsingSaveForLater = function(){
	return this.isSavingForLater;
}

quickPay.prototype.setCurrentMethod = function(method){
	if(method == QP_FREE || method == QP_LEGACY || method == QP_SV){
		this.selectedMethod = method;
	}
}

quickPay.prototype.getCurrentMethod = function(){
	return this.selectedMethod;
}

quickPay.prototype.switchToFreeOfChargeMethod = function(){
	var self = this;
	$(self.selectors.elem).find(self.selectors.details).removeClass('is-active');
	$(self.selectors.elem).find(self.selectors.medioDetails).removeClass('is-active');
	$(self.selectors.elem).find(self.selectors.acquisitionDetails).removeClass('is-active');
	$(self.selectors.elem).find('[data-submit-payment]').removeClass('is-active');
	$(self.selectors.elem).find('[data-submit-payment="free"]').addClass('is-active');
	self.setCurrentMethod(QP_FREE);
}

quickPay.prototype.switchToChargedMethod = function(){
	var self = this;
	$(self.selectors.elem).find(self.selectors.details).addClass('is-active');
	$(self.selectors.elem).find(self.selectors.medioDetails).addClass('is-active');
	$(self.selectors.elem).find(self.selectors.acquisitionDetails).addClass('is-active');
	$(self.selectors.elem).find(self.selectors.detailsVC).removeClass('is-active');
	$(self.selectors.elem).find('[data-submit-payment]').removeClass('is-active');
	$(self.selectors.elem).find('[data-submit-payment="paid"]').addClass('is-active');
	self.setCurrentMethod(QP_LEGACY);
}

quickPay.prototype.switchToVcMethod = function(){
	var self = this;
	$(self.selectors.elem).find(self.selectors.details).removeClass('is-active');
	$(self.selectors.elem).find(self.selectors.medioDetails).removeClass('is-active');
	$(self.selectors.elem).find(self.selectors.acquisitionDetails).removeClass('is-active');
	$(self.selectors.elem).find(self.selectors.detailsVC).addClass('is-active');
	$(self.selectors.elem).find('[data-submit-payment]').removeClass('is-active');
	$(self.selectors.elem).find('[data-submit-payment="paid"]').addClass('is-active');
	self.setCurrentMethod(QP_SV);

}

quickPay.prototype.performPay = function(){
	var self = this;
	if(self.getCurrentMethod() == QP_LEGACY && self.medio == null){
		var form = $(self.selectors.elem).find(self.selectors.acquisitionDetails).find('form');
		if(form.length > 0){
			$(form).off('formvalid.zf.abide').on('formvalid.zf.abide',function(){
				self.submitPay();
			})
			$(form).foundation('validateForm');
		}else{
			self.submitPay();
		}
	}else{
		self.submitPay();
	}
}
quickPay.prototype.submitPay = function(){
	var self = this;

	var form = null;
	var valuesArray = {};
	var amount = null;
	var method = null;
	var submethod = null;
	var uid = null;
	var medio = null;
	if(self.getCurrentMethod() == QP_LEGACY){
		if(self.medio == null){
			$(self.selectors.elem).find(self.selectors.acquisitionDetails).find('[data-payment-field]').each(function(k,v){
				var fieldKey = $(v).attr('data-payment-field')
				var fieldValue = $(v).val();
				valuesArray[fieldKey] = fieldValue;
			})
			method = self.getMethod().id;
			submethod = self.getSubMethod().id;
			uid = self.getSubMethod().uid;
		}

		amount = self.getAmount(false,false);

		if(self.medio != null){
			medio = self.medio;
		}
	}else if(self.getCurrentMethod() == QP_FREE){
		amount = 0;
		amount = 	self.getAmount();
		method = 	submethod = "sv";
		uid =		self.getPaymentsObj().getLimit('sv','sv').uid;
	}else if(self.getCurrentMethod() == QP_SV){
		amount = 	self.getAmount();
		method = 	submethod = "sv";
		uid =		self.getPaymentsObj().getLimit('sv','sv').uid;
	}
	form = $(self.selectors.elem).find(self.selectors.submitForm);

	var paymentProtocol = {
		amount:					amount,
		method:					method,
		uid:					parseInt(uid),
		submethod:				submethod,
		usePreviousBalance: 	self.getIsUsingPreviousBalance(),
		forceMinLimit: 			true,
		isShoppingCart:			self.getPaymentsObj().isShoppingCart(),
		storedValueID:			medio,
		customValues: 			valuesArray,
		saveInAgenda: 			self.getIsUsingSaveForLater()
	}

	self.getPaymentsMgr().blockAllMethods();
	self.getPaymentsObj().performPay(method,submethod,paymentProtocol,$(form),function(){
		self.getPaymentsMgr().unblockAllMethods(false);
	});
}

quickPay.prototype.enableQuickPay = function(state){
	//Habilita o deshabilita los quickPayments y muestra los métodos clásicos cuando esté deshabilitado.
	//Cancela la navegación entre métodos clásico y rápido
	var self = this;
	self.quickPayStatus = state;
	if(state){
		self.switchToPayments(false);
		$(self.selectors.elem).find(self.classicPayments.switchBtSelector).removeAttr('disabled','').show();
	}else{
		self.switchToPayments(true);
		$(self.selectors.elem).find(self.classicPayments.switchBtSelector).attr('disabled','').hide();
	}
}

quickPay.prototype.getQuickPayStatus = function(){
	return this.quickPayStatus;
}

quickPay.prototype.setSavingForMethodState = function(state,forceState){
	//Función que habilita o deshabilita el control de guardar en agenda.
	//Por defecto, si se deshabilita, la propidad de guardar en agenda que se establece en paymentsObj se pone a false, pero puede forzarse a true
	//aunque el control esté disabled, pasando el parámetro forceState a true (siempre que el método soportara previamente el guardado en agenda).

	var self = this;
	var actionMgrElem = $(self.selectors.elem).find(self.selectors.saveForLater);
	var label = $(actionMgrElem).parent();
	const savingState = forceState ?? state;

	if(!state){
		$(actionMgrElem).attr('disabled','');
		$(label).addClass('disabled');
		if(!savingState){
			$(actionMgrElem).prop('checked',false);
			$(label).removeClass('is-active');
			self.setSaveForLater(false);
		}else{
			$(actionMgrElem).prop('checked',true);
			$(label).addClass('is-active');
			self.setSaveForLater(true);
		}
	}else{
		$(actionMgrElem).removeAttr('disabled');
		$(actionMgrElem).prop('checked','true').parent().addClass('is-active');
		$(label).addClass('is-active');
		$(label).removeClass('disabled');
		self.setSaveForLater(true);
	}
}

function unlock(selectorsToUnlock,attributeToRemove){
	//Elimina el atributo 'disabled' de los selectores pasados.
	//Normalmente se usa data-lock como atributo, por normalizar
	//Si el atributo 'data-forceLock" existe, mantiene el estado disabled ignorando la función
	$(selectorsToUnlock).each(function(){
		if(typeof $(this).attr('data-forceLock') == "undefined"){
			$(this).removeAttr('disabled');
		}
		if(attributeToRemove){
			$(this).removeAttr(attributeToRemove);
		}
	})
}

String.prototype.placeHolder = function(arrayOfValues){
	var texto = this
	if(Array.isArray(arrayOfValues)){
		$(arrayOfValues).each(function(k,v){
			var placeHolder = "%"+(k+1);
			texto = texto.replace(new RegExp(placeHolder, 'g'), v);
		})
	}else{
		var placeHolder = "%1";
		texto = texto.replace(new RegExp(placeHolder, 'g'), arrayOfValues);
	}
	return texto;
}
